(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-collection-v2"] && !Shopify.designMode) return;
  try {
    
  /* The numeric catalogue is loaded in market context; no external runtime. */
  class OrtluxResponsiveCollection extends HTMLElement {
    static dimensions = {
      scene: 'filter.p.m.ortlux.use_cases',
      brand: 'filter.p.m.ortlux.brand',
      load: 'filter.p.m.ortlux.load_bands',
      range: 'filter.p.m.ortlux.range_bands',
      weight: 'filter.p.m.ortlux.weight_bands',
      road: 'filter.p.m.ortlux.road_legal_markets',
    };
    static positive(v) {
      return typeof v === 'number' && Number.isFinite(v) && v > 0;
    }
    static labels(items) {
      const result = new Map();
      if (items.length < 2 || items.length > 12) return result;
      const metrics = [
        ['lightest', (p) => p.weight, 1],
        ['longest', (p) => p.range, -1],
        [
          'value',
          (p) =>
            OrtluxResponsiveCollection.positive(p.range) && OrtluxResponsiveCollection.positive(p.price)
              ? p.price / p.range
              : null,
          1,
        ],
        ['cheapest', (p) => p.price, 1],
      ];
      for (const [label, get, dir] of metrics) {
        const list = items
          .map((p) => ({ p, v: get(p) }))
          .filter((x) => OrtluxResponsiveCollection.positive(x.v))
          .sort((a, b) => dir * (a.v - b.v));
        if (list.length < 2) continue;
        const best = list[0],
          second = list[1];
        const gap = dir === 1 ? (second.v - best.v) / second.v : (best.v - second.v) / second.v;
        if (gap + Number.EPSILON >= 0.1 && !result.has(best.p.id)) result.set(best.p.id, label);
      }
      return result;
    }
    static matches(p, params, skip) {
      for (const [key, name] of Object.entries(this.dimensions)) {
        if (key === skip) continue;
        const selected = params.getAll(name).flatMap((x) => x.split(','));
        if (!selected.length) continue;
        const hit = selected.some((v) =>
          key === 'scene'
            ? (p.scenes || []).includes(v)
            : key === 'brand'
              ? String(p.brandId) === v
              : key === 'road'
                ? (p.road || []).includes(v)
                : key === 'load'
                  ? this.positive(p.load) && p.load >= Number(v)
                  : key === 'range'
                    ? this.positive(p.range) && p.range >= Number(v)
                    : key === 'weight'
                      ? this.positive(p.weight) && (v === 'gt25' ? p.weight > 25 : p.weight <= Number(v))
                      : true,
        );
        if (!hit) return false;
      }
      if (skip !== 'price') {
        const min = params.get('filter.v.price.gte'),
          max = params.get('filter.v.price.lte');
        const prices = Array.isArray(p.prices) && p.prices.length ? p.prices : [p.price];
        if (
          !prices.some(
            (price) =>
              (min === null || min === '' || price >= Number(min) * 100) &&
              (max === null || max === '' || price <= Number(max) * 100),
          )
        )
          return false;
      }
      return true;
    }
    connectedCallback() {
      if (!this.querySelector('[data-grid]')) return;
      if (this.initialized) return;
      this.initialized = true;
      this.c = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.pageSize = 12;
      this.selected = new Map();
      this.all = null;
      this.current = new URL(location.href);
      this.visited = new Set();
      this.abort = new AbortController();
      this.money = new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency',
        currency: this.dataset.currency,
      });
      this.number = new Intl.NumberFormat(this.dataset.locale, {
        maximumFractionDigits: 1,
      });
      try {
        this.visited = new Set(JSON.parse(localStorage.getItem('ortlux-visited') || '[]'));
      } catch {}
      this.dataset.enhanced = '';
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      this.addEventListener('click', (e) => this.click(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('change', (e) => this.change(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('keydown', (e) => this.keydown(e), {
        signal: this.abort.signal,
      });
      this.querySelector('form').addEventListener(
        'submit',
        (e) => {
          e.preventDefault();
          this.filterChange();
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'popstate',
        () => {
          this.current = new URL(location.href);
          this.ready.then(() => {
            this.syncInputs();
            this.render(false);
            this.restore();
          });
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'pageshow',
        (e) => {
          if (e.persisted) {
            this.markVisited();
            this.restore();
          }
        },
        { signal: this.abort.signal },
      );
      window.addEventListener('pagehide', () => this.save(), {
        signal: this.abort.signal,
      });
      window.addEventListener(
        'resize',
        () => {
          if (innerWidth > 750 && this.drawerOpen) this.closeFilters();
        },
        { signal: this.abort.signal },
      );
      this.querySelector('[data-comparison]').addEventListener(
        'close',
        () => this.querySelector('[data-compare]').focus(),
        { signal: this.abort.signal },
      );
      document.addEventListener(
        'focusin',
        (e) => {
          if (this.drawerOpen || this.querySelector('[data-comparison]').open) return;
          const tray = this.querySelector('[data-tray]');
          if (tray.hidden || tray.contains(e.target)) return;
          const rect = e.target.getBoundingClientRect(),
            top = tray.getBoundingClientRect().top;
          if (rect.bottom > top - 8) window.scrollBy({ top: rect.bottom - top + 16, behavior: 'instant' });
        },
        { signal: this.abort.signal },
      );
      this.markVisited();
      this.syncInputs();
      this.ready = this.load();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.closeFilters(false);
    }
    say(text) {
      this.querySelector('[data-live]').textContent = text;
    }
    async load() {
      this.setAttribute('aria-busy', 'true');
      this.say(this.c.loading);
      try {
        let products = [],
          page = 1,
          pages = 1;
        do {
          let url;
          if (this.dataset.preview) {
            url = new URL(this.dataset.preview, location.href);
            url.searchParams.set('page', page);
          } else {
            url = new URL(this.dataset.url, location.origin);
            url.searchParams.set('section_id', 'ortlux-collection-data-v2');
            url.searchParams.set('page', page);
          }
          const response = await fetch(url, {
            signal: this.abort.signal,
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Catalogue response ' + response.status);
          let data;
          if (this.dataset.preview) data = await response.json();
          else {
            const t = document.createElement('template');
            t.innerHTML = await response.text();
            const node = t.content.querySelector('[data-catalog-data]');
            if (!node) throw new Error('Missing data section');
            data = JSON.parse(node.textContent);
          }
          if (
            !Array.isArray(data.products) ||
            !Number.isInteger(data.pages) ||
            data.pages < 1 ||
            data.pages > 100
          )
            throw new Error('Invalid catalogue response');
          products.push(...data.products);
          pages = data.pages;
          page++;
        } while (page <= pages);
        this.all = [...new Map(products.map((p) => [String(p.id), { ...p, id: String(p.id) }])).values()];
        this.setupMissingFilters();
        this.setupPrices();
        this.syncInputs();
        this.render(false);
        this.restore();
        this.querySelector('[data-retry]').hidden = true;
      } catch (e) {
        if (e.name !== 'AbortError') {
          this.say(this.c.error);
          this.querySelector('[data-retry]').hidden = false;
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
    setupMissingFilters() {
      const form = this.querySelector('.oc-filter-form');
      const options = {
        scene: ['commuting', 'cargo', 'offroad', 'folding'],
        brand: [
          ...new Set(
            this.all.map((p) => String(p.brandId)).filter((id) => id !== 'null' && id !== 'undefined'),
          ),
        ],
        load: ['120', '150'],
        range: ['40', '60', '80'],
        weight: ['20', '25', 'gt25'],
        road: [this.dataset.market],
      };
      for (const [dimension, values] of Object.entries(options)) {
        if (form.querySelector(`[data-dimension="${dimension}"]`)) continue;
        if (
          (dimension === 'scene' && this.dataset.kind === 'scene') ||
          (dimension === 'brand' && this.dataset.kind === 'brand') ||
          (dimension === 'road' && this.dataset.vehicle !== 'escooter')
        )
          continue;
        const meaningful = values.filter((value) =>
          this.all.some((p) =>
            OrtluxResponsiveCollection.matches(
              p,
              new URLSearchParams([[OrtluxResponsiveCollection.dimensions[dimension], value]]),
            ),
          ),
        );
        if (!meaningful.length) continue;
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = dimension;
        const legend = document.createElement('legend');
        legend.textContent = this.c[dimension];
        fieldset.append(legend);
        for (const value of meaningful) {
          const label = document.createElement('label');
          label.className = 'oc-check';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.name = OrtluxResponsiveCollection.dimensions[dimension];
          input.value = value;
          const text = document.createElement('span');
          text.textContent =
            dimension === 'brand'
              ? this.all.find((p) => String(p.brandId) === value).brand
              : dimension === 'scene'
                ? this.c[value]
                : dimension === 'road'
                  ? this.c.approved
                  : dimension === 'weight'
                    ? `${value === 'gt25' ? '>' : '≤'} ${value === 'gt25' ? '25' : value} kg`
                    : `≥ ${value} ${dimension === 'range' ? 'km' : 'kg'}`;
          const count = document.createElement('small');
          count.dataset.optionCount = '';
          label.append(input, text, count);
          fieldset.append(label);
        }
        form.append(fieldset);
      }
      if (!form.querySelector('[data-dimension="price"]') && this.all.length) {
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = 'price';
        const legend = document.createElement('legend');
        legend.textContent = this.c.price;
        const bands = document.createElement('div');
        bands.dataset.priceBands = '';
        const inputs = document.createElement('div');
        inputs.className = 'oc-price-inputs';
        for (const [suffix, title] of [
          ['gte', this.c.from],
          ['lte', this.c.up_to],
        ]) {
          const label = document.createElement('label');
          label.textContent = title;
          const input = document.createElement('input');
          input.name = `filter.v.price.${suffix}`;
          input.type = 'number';
          input.min = '0';
          input.step = '0.01';
          input.inputMode = 'decimal';
          label.append(input);
          inputs.append(label);
        }
        fieldset.append(legend, bands, inputs);
        form.prepend(fieldset);
      }
    }
    setupPrices() {
      const raw = JSON.parse(this.querySelector('[data-price-config]').textContent || 'null');
      this.bands = raw?.[this.dataset.currency] || [];
      const wrap = this.querySelector('[data-price-bands]');
      if (!wrap) return;
      wrap.replaceChildren();
      wrap.setAttribute('aria-busy', 'false');
      for (const [index, band] of this.bands.entries()) {
        if (!Array.isArray(band) || band.length !== 2) continue;
        const label = document.createElement('label');
        label.className = 'oc-check';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'oc_price';
        input.value = index;
        const text = document.createElement('span');
        text.textContent = this.bandText(band);
        const count = document.createElement('small');
        count.dataset.optionCount = '';
        label.append(input, text, count);
        wrap.append(label);
      }
    }
    bandText([min, max]) {
      return min === null
        ? `${this.c.up_to} ${this.money.format(max)}`
        : max === null
          ? `${this.c.from} ${this.money.format(min)}`
          : `${this.money.format(min)}–${this.money.format(max)}`;
    }
    syncInputs() {
      const p = this.current.searchParams;
      this.querySelectorAll('.oc-filter-form input').forEach((input) => {
        if (input.name === 'oc_price') {
          const band = this.bands?.[input.value];
          input.checked =
            !!band &&
            String(band[0] ?? '') === (p.get('filter.v.price.gte') || '') &&
            String(band[1] ?? '') === (p.get('filter.v.price.lte') || '');
        } else if (input.type === 'checkbox')
          input.checked = p
            .getAll(input.name)
            .flatMap((x) => x.split(','))
            .includes(input.value);
        else input.value = p.get(input.name) || '';
      });
      this.querySelector('[data-sort]').value = p.get('oc_sort') || p.get('sort_by') || 'manual';
    }
    async filterChange() {
      if (!this.all) {
        await this.ready;
        if (!this.all) return;
      }
      const next = new URL(location.href);
      for (const k of [...next.searchParams.keys()])
        if (k.startsWith('filter.') || k === 'page') next.searchParams.delete(k);
      for (const [k, v] of new FormData(this.querySelector('form')))
        if (v && k !== 'oc_price') next.searchParams.append(k, v);
      this.navigate(next);
    }
    change(e) {
      if (e.target.matches('[data-sort]')) {
        const next = new URL(location.href);
        next.searchParams.delete('page');
        next.searchParams.delete('sort_by');
        next.searchParams.delete('oc_sort');
        const v = e.target.value;
        if (v === 'range-descending' || v === 'weight-ascending') next.searchParams.set('oc_sort', v);
        else if (v !== 'manual') next.searchParams.set('sort_by', v);
        this.ready.then(() => {
          if (this.all) this.navigate(next);
        });
      } else if (e.target.matches('[data-compare-id]')) this.select(e.target);
      else if (e.target.closest('.oc-filter-form')) {
        if (e.target.name === 'oc_price') {
          const [min, max] = this.bands[e.target.value];
          this.querySelector('[name="filter.v.price.gte"]').value = min ?? '';
          this.querySelector('[name="filter.v.price.lte"]').value = max ?? '';
        }
        this.filterChange();
      }
    }
    navigate(url) {
      this.save();
      history.pushState({ oc: { url: url.href, scroll: 0 } }, '', url);
      this.current = url;
      this.syncInputs();
      this.render();
    }
    save(anchor) {
      const state = {
        ...history.state,
        oc: { url: location.href, scroll: scrollY, anchor: anchor || null },
      };
      history.replaceState(state, '');
    }
    restore() {
      const s = history.state?.oc;
      if (!s || s.url !== location.href) {
        if (location.hash.startsWith('#oc-card-'))
          requestAnimationFrame(() =>
            requestAnimationFrame(() =>
              document
                .getElementById(location.hash.slice(1))
                ?.scrollIntoView({ block: 'center', behavior: 'instant' }),
            ),
          );
        return;
      }
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          window.scrollTo({ top: s.scroll || 0, behavior: 'instant' });
        }),
      );
    }
    sort(items) {
      const sort =
        this.current.searchParams.get('oc_sort') || this.current.searchParams.get('sort_by') || 'manual';
      return [...items].sort((a, b) => {
        if (sort === 'price-ascending') return a.price - b.price;
        if (sort === 'price-descending') return b.price - a.price;
        if (sort === 'range-descending') return (b.range ?? -Infinity) - (a.range ?? -Infinity);
        if (sort === 'weight-ascending') return (a.weight ?? Infinity) - (b.weight ?? Infinity);
        return a.rank - b.rank;
      });
    }
    render(announce = true) {
      if (!this.all) return;
      if (announce || this.current.searchParams.has('oc_sort'))
        document.querySelector('[data-oc-itemlist]')?.remove();
      const params = this.current.searchParams;
      const filteredUrl = [...params.keys()].some(
        (key) => key.startsWith('filter.') || key === 'oc_sort' || key === 'sort_by',
      );
      let robots = document.getElementById('ortlux-filter-robots');
      if (filteredUrl) {
        if (!robots) {
          robots = document.createElement('meta');
          robots.id = 'ortlux-filter-robots';
          robots.name = 'robots';
          document.head.append(robots);
        }
        robots.content = 'noindex,follow';
      } else robots?.remove();
      this.results = this.sort(
        this.all
          .filter((p) => OrtluxResponsiveCollection.matches(p, params))
          .map((p) => {
            const min = params.get('filter.v.price.gte'),
              max = params.get('filter.v.price.lte');
            const prices = (p.prices?.length ? p.prices : [p.price]).filter(
              (v) => (!min || v >= Number(min) * 100) && (!max || v <= Number(max) * 100),
            );
            return { ...p, price: Math.min(...prices) };
          }),
      );
      const sortControl = this.querySelector('[data-sort]');
      for (const [value, metric] of [['weight-ascending', 'weight'], ['range-descending', 'range']]) {
        const option = sortControl.querySelector(`option[value="${value}"]`);
        const available = this.results.some((p) => OrtluxResponsiveCollection.positive(p[metric]));
        option.hidden = !available;
        option.disabled = !available;
        if (!available && (params.get('oc_sort') === value || params.get('sort_by') === value)) {
          params.delete('oc_sort');
          params.delete('sort_by');
          this.results.sort((a, b) => a.rank - b.rank);
          history.replaceState(history.state, '', this.current);
        }
      }
      sortControl.value = params.get('oc_sort') || params.get('sort_by') || 'manual';
      this.visibleColumns = Math.max(1, getComputedStyle(this.querySelector('[data-grid]')).gridTemplateColumns.split(' ').length);
      const count = this.results.length,
        pages = Math.max(1, Math.ceil(count / this.pageSize));
      this.page = Math.min(pages, Math.max(1, parseInt(params.get('page') || '1', 10) || 1));
      const labels = OrtluxResponsiveCollection.labels(this.results),
        visible = this.results.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
      this.querySelector('[data-grid]').replaceChildren(
        ...visible.map((p, i) => this.card(p, labels.get(p.id), i)),
      );
      this.querySelectorAll('[data-count],[data-result-count]').forEach(
        (e) => (e.textContent = this.number.format(count)),
      );
      this.updateCounts();
      this.active();
      this.pagination(pages);
      this.empty();
      this.updateTray();
      this.markVisited();
      this.say(`${this.number.format(count)} ${this.c.results}`);
      if (announce) this.querySelector('[data-grid-wrap]').setAttribute('data-updated', '');
    }
    card(p, label, index = 9) {
      const node = this.querySelector('[data-card-template]').content.firstElementChild.cloneNode(true);
      node.dataset.id = p.id;
      node.id = 'oc-card-' + p.id;
      const link = node.querySelector('a');
      link.href = this.productURL(p);
      link.dataset.productId = p.id;
      const img = node.querySelector('img');
      if (p.image) {
        if (p.srcset) img.srcset = p.srcset;
        img.sizes = '(max-width: 640px) 100vw, (max-width: 1100px) 50vw, 33vw';
        img.src = p.image;
        img.alt = p.imageAlt || p.modelLabel;
        img.width = p.imageWidth || 600;
        img.height = p.imageHeight || 400;
        img.loading = index < this.visibleColumns ? 'eager' : 'lazy';
        img.decoding = 'async';
        img.fetchPriority = index === 0 ? 'high' : 'auto';
      } else {
        img.remove();
        node.querySelector('.oc-card-image').append(document.createTextNode(this.c.no_image));
      }
      node.querySelector('.oc-card-brand').textContent = p.brand;
      node.querySelector('h3').textContent = p.title;
      node.querySelector('[data-price]').textContent =
        (p.varies ? this.c.from + ' ' : '') + this.money.format(p.price / 100);
      const old = node.querySelector('s');
      if (p.comparePrice > p.price) old.textContent = this.money.format(p.comparePrice / 100);
      else old.remove();
      node.querySelector('[data-range]').textContent =
        p.range === null || p.range === undefined ? '—' : this.number.format(p.range) + ' km';
      node.querySelector('[data-weight]').textContent =
        p.weight === null || p.weight === undefined ? '—' : this.number.format(p.weight) + ' kg';
      node.querySelector('[data-badge]').textContent = label ? this.c[label] : '';
      const input = node.querySelector('[data-compare-id]');
      input.dataset.compareId = p.id;
      input.setAttribute('aria-label', this.c.compare + ' ' + p.brand + ' ' + p.title);
      input.checked = this.selected.has(p.id);
      input.disabled = this.selected.size >= 4 && !input.checked;
      return node;
    }
    productURL(p) {
      const url = new URL(p.url, location.href);
      url.searchParams.set('oc_return', this.current.pathname + this.current.search + '#oc-card-' + p.id);
      return url.href;
    }
    updateCounts() {
      for (const input of this.querySelectorAll('.oc-filter-form input[type=checkbox]')) {
        const key = input.closest('fieldset').dataset.dimension;
        const params = new URLSearchParams(this.current.search);
        params.delete(input.name);
        params.append(input.name, input.value);
        const count = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)).length;
        input.disabled = !count && !input.checked;
        input.closest('label').querySelector('[data-option-count]').textContent = count;
      }
      const pool = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, this.current.searchParams, 'price'));
      this.querySelectorAll('[name=oc_price]').forEach((input) => {
        const [min, max] = this.bands[input.value];
        const count = pool.filter((p) =>
          (p.prices?.length ? p.prices : [p.price]).some(
            (price) => (min === null || price >= min * 100) && (max === null || price <= max * 100),
          ),
        ).length;
        input.closest('label').querySelector('small').textContent = count;
        input.disabled = !count && !input.checked;
      });
    }
    active() {
      const wrap = this.querySelector('[data-active]');
      wrap.replaceChildren();
      for (const [key, val] of this.current.searchParams) {
        if (!key.startsWith('filter.')) continue;
        const input = [...this.querySelectorAll('.oc-filter-form input')].find(
          (e) => e.name === key && e.value === val,
        );
        const label = input?.closest('label')?.querySelector('span')?.textContent || val;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.removeFilter = key;
        button.dataset.value = val;
        button.textContent = (key.includes('price.') ? this.c.price + ' ' + val : label) + ' ×';
        button.setAttribute('aria-label', this.c.remove + ' ' + button.textContent);
        wrap.append(button);
      }
      if (!wrap.children.length) wrap.textContent = this.c.no_filters;
    }
    pagination(pages) {
      const nav = this.querySelector('[data-pagination]');
      nav.replaceChildren();
      for (const [name, page] of [
        ['prev', this.page - 1],
        ['next', this.page + 1],
      ]) {
        if (page < 1 || page > pages) continue;
        const a = document.createElement('a');
        const url = new URL(this.current);
        url.searchParams.set('page', page);
        a.href = url.href;
        a.rel =
          name +
          ([...this.current.searchParams.keys()].some(
            (k) => k.startsWith('filter.') || k === 'sort_by' || k === 'oc_sort',
          )
            ? ' nofollow'
            : '');
        a.dataset.page = page;
        a.textContent = this.c[name];
        nav.append(a);
      }
      const span = document.createElement('span');
      span.textContent = `${this.c.page} ${this.page} ${this.c.of} ${pages}`;
      nav.insertBefore(span, nav.querySelector('[rel~="next"]'));
    }
    empty() {
      const box = this.querySelector('[data-empty]');
      box.hidden = this.results.length > 0;
      this.querySelector('[data-grid]').hidden = !box.hidden;
      if (box.hidden) return;
      const keys = [...new Set([...this.current.searchParams.keys()].filter((k) => k.startsWith('filter.')))];
      const actions = box.querySelector('[data-relax-actions]');
      actions.replaceChildren();
      let near = [],
        chosen = [];
      const candidates = keys
        .map((key) => {
          const params = new URLSearchParams(this.current.search);
          params.delete(key);
          return {
            key,
            params,
            list: this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)),
          };
        })
        .sort((a, b) => b.list.length - a.list.length);
      if (candidates.length) {
        let params = new URLSearchParams(this.current.search);
        for (const item of candidates) {
          params.delete(item.key);
          chosen.push(item.key);
          near = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params));
          if (near.length >= 4) break;
        }
      }
      const names = chosen.map((k) => {
        const dim = Object.entries(OrtluxResponsiveCollection.dimensions).find(([, v]) => v === k)?.[0] || 'price';
        return this.c[dim];
      });
      box.querySelector('[data-empty-reason]').textContent = names.join(' + ') + ' — ' + this.c.relaxed;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.relax = JSON.stringify(chosen);
      button.textContent = this.c.relax + ': ' + names.join(' + ');
      actions.append(button);
      box.querySelector('[data-near]').replaceChildren(...near.slice(0, 4).map((p) => this.card(p)));
    }
    select(input) {
      const p =
        this.results?.find((p) => p.id === input.dataset.compareId) ||
        this.all?.find((p) => p.id === input.dataset.compareId);
      if (!p) {
        input.checked = false;
        this.say(this.c.loading);
        return;
      }
      if (input.checked && this.selected.size < 4) this.selected.set(p.id, p);
      else this.selected.delete(p.id);
      this.updateTray();
      this.say(`${this.selected.size} / 4 ${this.c.selected}`);
    }
    updateTray() {
      const tray = this.querySelector('[data-tray]');
      tray.hidden = !this.selected.size;
      tray.querySelector('[data-selected-count]').textContent = this.selected.size + ' / 4';
      tray.querySelector('[data-limit]').textContent = this.selected.size === 4 ? this.c.limit : '';
      const list = tray.querySelector('[data-selected-list]');
      list.replaceChildren();
      for (const p of this.selected.values()) {
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.removeCompare = p.id;
        b.textContent = p.title + ' ×';
        b.setAttribute('aria-label', this.c.remove + ' ' + p.title);
        list.append(b);
      }
      this.querySelectorAll('[data-compare-id]').forEach((input) => {
        input.checked = this.selected.has(input.dataset.compareId);
        input.disabled = this.selected.size === 4 && !input.checked;
        input.title = input.disabled ? this.c.limit : '';
      });
    }
    compare() {
      const dialog = this.querySelector('[data-comparison]'),
        table = dialog.querySelector('table'),
        items = [...this.selected.values()];
      if (!items.length) return;
      const head = document.createElement('tr'),
        corner = document.createElement('th');
      corner.scope = 'col';
      corner.textContent = this.c.model;
      head.append(corner);
      for (const p of items) {
        const th = document.createElement('th');
        th.scope = 'col';
        th.textContent = p.brand + ' ' + p.title;
        head.append(th);
      }
      table.querySelector('thead').replaceChildren(head);
      const rows = [
        ['vehicle', 'vehicle', ''],
        ['load', 'load', 'kg'],
        ['weight', 'weight', 'kg'],
        ['range', 'range', 'km'],
        ['price', 'price', ''],
        ['motor', 'motor', 'W'],
        ['battery', 'battery', 'Wh'],
        ['speed', 'speed', 'km/h'],
        ['ip', 'ip', ''],
        ['heightMin', 'height_min', 'cm'],
        ['heightMax', 'height_max', 'cm'],
        ['rangeMax', 'range', 'km'],
        ['motorModel', 'motor_model', ''],
        ['frameMaterial', 'frame_material', ''],
        ['brakes', 'brakes', ''],
        ['tyres', 'tyres', ''],
        ['dimensions', 'dimensions', ''],
        ['gradeability', 'gradeability', '%'],
        ['testedMin', 'tested_min', 'km'],
        ['testedMax', 'tested_max', 'km'],
        ['testConditions', 'test_conditions', ''],
      ];
      const body = table.querySelector('tbody');
      body.replaceChildren();
      rows.forEach(([key, label, unit], index) => {
        if (index > 4 && !items.some((p) => p[key] !== null && p[key] !== undefined && p[key] !== '')) return;
        const tr = document.createElement('tr'),
          th = document.createElement('th');
        th.scope = 'row';
        th.textContent = this.c[label] + (key === 'rangeMax' ? ' (max)' : '');
        tr.append(th);
        for (const p of items) {
          const td = document.createElement('td');
          td.textContent =
            p[key] === null || p[key] === undefined || p[key] === ''
              ? '—'
              : key === 'price'
                ? this.money.format(p.price / 100)
                : `${typeof p[key] === 'number' ? this.number.format(p[key]) : p[key]}${unit ? ' ' + unit : ''}`;
          tr.append(td);
        }
        body.append(tr);
      });
      const foot = document.createElement('tr'),
        th = document.createElement('th');
      th.scope = 'row';
      th.textContent = this.c.model;
      foot.append(th);
      for (const p of items) {
        const td = document.createElement('td'),
          a = document.createElement('a');
        a.href = this.productURL(p);
        a.dataset.productId = p.id;
        a.textContent = p.title + ' ↗';
        td.append(a);
        foot.append(td);
      }
      table.querySelector('tfoot').replaceChildren(foot);
      dialog.showModal();
      dialog.querySelector('button').focus();
    }
    markVisited() {
      this.querySelectorAll('.oc-card').forEach((card) => {
        card.querySelector('.oc-visited').hidden = !this.visited.has(card.dataset.id);
      });
    }
    openFilters() {
      const panel = this.querySelector('.oc-sidebar');
      this.drawerOpen = true;
      this.dataset.drawerOpen = '';
      panel.dataset.open = '';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'true');
      this.querySelector('[data-shade]').hidden = false;
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.inerted = [];
      for (const node of document.body.children) {
        if (!node.contains(this) && !node.inert) {
          node.inert = true;
          this.inerted.push(node);
        }
      }
      this.querySelector('[data-close-filters]').focus();
    }
    closeFilters(focus = true) {
      if (!this.drawerOpen) return;
      this.drawerOpen = false;
      delete this.dataset.drawerOpen;
      const panel = this.querySelector('.oc-sidebar');
      delete panel.dataset.open;
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'false');
      this.querySelector('[data-shade]').hidden = true;
      document.body.style.overflow = this.oldOverflow || '';
      this.inerted?.forEach((e) => (e.inert = false));
      if (focus) this.querySelector('[data-open-filters]').focus();
    }
    keydown(e) {
      if (!this.drawerOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeFilters();
      }
      if (e.key === 'Tab') {
        const nodes = [
          ...this.querySelector('.oc-sidebar').querySelectorAll(
            'button:not([disabled]),input:not([disabled]),a[href],select',
          ),
        ].filter((el) => el.getClientRects().length);
        const first = nodes[0],
          last = nodes.at(-1);
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    click(e) {
      const target = e.target.closest('button,a');
      if (!target) return;
      if (target.dataset.productId) {
        const destination = new URL(target.href, location.href);
        destination.searchParams.set(
          'oc_return',
          this.current.pathname + this.current.search + '#oc-card-' + target.dataset.productId,
        );
        target.href = destination.href;
        this.save('oc-card-' + target.dataset.productId);
        this.visited.add(target.dataset.productId);
        try {
          localStorage.setItem('ortlux-visited', JSON.stringify([...this.visited]));
        } catch {}
        this.markVisited();
        return;
      }
      if (target.matches('[data-open-filters]')) this.openFilters();
      else if (target.matches('[data-close-filters]')) this.closeFilters();
      else if (target.matches('[data-retry]')) this.ready = this.load();
      else if (target.matches('[data-page]')) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        this.navigate(new URL(target.href));
        const h = this.querySelector('.oc-result-heading');
        h.tabIndex = -1;
        h.focus({ preventScroll: true });
        h.scrollIntoView({ block: 'start', behavior: 'instant' });
      } else if (target.matches('[data-clear]')) {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()])
          if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.removeFilter) {
        const url = new URL(location.href),
          key = target.dataset.removeFilter,
          values = url.searchParams.getAll(key).filter((x) => x !== target.dataset.value);
        url.searchParams.delete(key);
        values.forEach((v) => url.searchParams.append(key, v));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.relax) {
        const url = new URL(location.href);
        JSON.parse(target.dataset.relax).forEach((k) => url.searchParams.delete(k));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.matches('[data-compare]')) this.compare();
      else if (target.matches('[data-close-compare]')) this.querySelector('[data-comparison]').close();
      else if (target.dataset.removeCompare) {
        this.selected.delete(target.dataset.removeCompare);
        this.updateTray();
        this.say(`${this.selected.size} / 4 ${this.c.selected}`);
        const fallback = this.selected.size
          ? this.querySelector('[data-compare]')
          : this.querySelector('[data-clear]');
        fallback.focus();
      } else if (target.matches('[data-clear-compare]')) {
        this.selected.clear();
        this.updateTray();
        this.say('0 / 4 ' + this.c.selected);
        this.querySelector('[data-clear]').focus();
      }
    }
  }
  if (!customElements.get('ortlux-responsive-collection')) customElements.define('ortlux-responsive-collection', OrtluxResponsiveCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-collection-v3"] && !Shopify.designMode) return;
  try {
    
  /* The numeric catalogue is loaded in market context; no external runtime. */
  class OrtluxResponsiveCollection extends HTMLElement {
    static dimensions = {
      scene: 'filter.p.m.ortlux.use_cases',
      brand: 'filter.p.m.ortlux.brand',
      load: 'filter.p.m.ortlux.load_bands',
      range: 'filter.p.m.ortlux.range_bands',
      weight: 'filter.p.m.ortlux.weight_bands',
      road: 'filter.p.m.ortlux.road_legal_markets',
    };
    static positive(v) {
      return typeof v === 'number' && Number.isFinite(v) && v > 0;
    }
    static labels(items) {
      const result = new Map();
      if (items.length < 2 || items.length > 12) return result;
      const metrics = [
        ['lightest', (p) => p.weight, 1],
        ['longest', (p) => p.range, -1],
        [
          'value',
          (p) =>
            OrtluxResponsiveCollection.positive(p.range) && OrtluxResponsiveCollection.positive(p.price)
              ? p.price / p.range
              : null,
          1,
        ],
        ['cheapest', (p) => p.price, 1],
      ];
      for (const [label, get, dir] of metrics) {
        const list = items
          .map((p) => ({ p, v: get(p) }))
          .filter((x) => OrtluxResponsiveCollection.positive(x.v))
          .sort((a, b) => dir * (a.v - b.v));
        if (list.length < 2) continue;
        const best = list[0],
          second = list[1];
        const gap = dir === 1 ? (second.v - best.v) / second.v : (best.v - second.v) / second.v;
        if (gap + Number.EPSILON >= 0.1 && !result.has(best.p.id)) result.set(best.p.id, label);
      }
      return result;
    }
    static matches(p, params, skip) {
      for (const [key, name] of Object.entries(this.dimensions)) {
        if (key === skip) continue;
        const selected = params.getAll(name).flatMap((x) => x.split(','));
        if (!selected.length) continue;
        const hit = selected.some((v) =>
          key === 'scene'
            ? (p.scenes || []).includes(v)
            : key === 'brand'
              ? String(p.brandId) === v
              : key === 'road'
                ? (p.road || []).includes(v)
                : key === 'load'
                  ? this.positive(p.load) && p.load >= Number(v)
                  : key === 'range'
                    ? this.positive(p.range) && p.range >= Number(v)
                    : key === 'weight'
                      ? this.positive(p.weight) && (v === 'gt25' ? p.weight > 25 : p.weight <= Number(v))
                      : true,
        );
        if (!hit) return false;
      }
      if (skip !== 'price') {
        const min = params.get('filter.v.price.gte'),
          max = params.get('filter.v.price.lte');
        const prices = Array.isArray(p.prices) && p.prices.length ? p.prices : [p.price];
        if (
          !prices.some(
            (price) =>
              (min === null || min === '' || price >= Number(min) * 100) &&
              (max === null || max === '' || price <= Number(max) * 100),
          )
        )
          return false;
      }
      return true;
    }
    connectedCallback() {
      if (!this.querySelector('[data-grid]')) return;
      if (this.initialized) return;
      this.initialized = true;
      this.c = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.pageSize = 12;
      this.selected = new Map();
      this.all = null;
      this.current = new URL(location.href);
      this.visited = new Set();
      this.abort = new AbortController();
      this.money = new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency',
        currency: this.dataset.currency,
      });
      this.number = new Intl.NumberFormat(this.dataset.locale, {
        maximumFractionDigits: 1,
      });
      try {
        this.visited = new Set(JSON.parse(localStorage.getItem('ortlux-visited') || '[]'));
      } catch {}
      this.dataset.enhanced = '';
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      this.addEventListener('click', (e) => this.click(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('change', (e) => this.change(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('keydown', (e) => this.keydown(e), {
        signal: this.abort.signal,
      });
      this.querySelector('form').addEventListener(
        'submit',
        (e) => {
          e.preventDefault();
          this.filterChange();
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'popstate',
        () => {
          this.current = new URL(location.href);
          this.ready.then(() => {
            this.syncInputs();
            this.render(false);
            this.restore();
          });
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'pageshow',
        (e) => {
          if (e.persisted) {
            this.markVisited();
            this.restore();
          }
        },
        { signal: this.abort.signal },
      );
      window.addEventListener('pagehide', () => this.save(), {
        signal: this.abort.signal,
      });
      window.addEventListener(
        'resize',
        () => {
          if (innerWidth > 750 && this.drawerOpen) this.closeFilters();
        },
        { signal: this.abort.signal },
      );
      this.querySelector('[data-comparison]').addEventListener(
        'close',
        () => this.querySelector('[data-compare]').focus(),
        { signal: this.abort.signal },
      );
      document.addEventListener(
        'focusin',
        (e) => {
          if (this.drawerOpen || this.querySelector('[data-comparison]').open) return;
          const tray = this.querySelector('[data-tray]');
          if (tray.hidden || tray.contains(e.target)) return;
          const rect = e.target.getBoundingClientRect(),
            top = tray.getBoundingClientRect().top;
          if (rect.bottom > top - 8) window.scrollBy({ top: rect.bottom - top + 16, behavior: 'instant' });
        },
        { signal: this.abort.signal },
      );
      this.markVisited();
      this.syncInputs();
      this.ready = this.load();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.closeFilters(false);
    }
    say(text) {
      this.querySelector('[data-live]').textContent = text;
    }
    async load() {
      this.setAttribute('aria-busy', 'true');
      this.say(this.c.loading);
      try {
        let products = [],
          page = 1,
          pages = 1;
        do {
          let url;
          if (this.dataset.preview) {
            url = new URL(this.dataset.preview, location.href);
            url.searchParams.set('page', page);
          } else {
            url = new URL(this.dataset.url, location.origin);
            url.searchParams.set('section_id', 'ortlux-collection-data-v2');
            url.searchParams.set('page', page);
          }
          const response = await fetch(url, {
            signal: this.abort.signal,
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Catalogue response ' + response.status);
          let data;
          if (this.dataset.preview) data = await response.json();
          else {
            const t = document.createElement('template');
            t.innerHTML = await response.text();
            const node = t.content.querySelector('[data-catalog-data]');
            if (!node) throw new Error('Missing data section');
            data = JSON.parse(node.textContent);
          }
          if (
            !Array.isArray(data.products) ||
            !Number.isInteger(data.pages) ||
            data.pages < 1 ||
            data.pages > 100
          )
            throw new Error('Invalid catalogue response');
          products.push(...data.products);
          pages = data.pages;
          page++;
        } while (page <= pages);
        this.all = [...new Map(products.map((p) => [String(p.id), { ...p, id: String(p.id) }])).values()];
        this.setupMissingFilters();
        this.setupPrices();
        this.syncInputs();
        this.render(false);
        this.restore();
        this.querySelector('[data-retry]').hidden = true;
      } catch (e) {
        if (e.name !== 'AbortError') {
          this.say(this.c.error);
          this.querySelector('[data-retry]').hidden = false;
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
    setupMissingFilters() {
      const form = this.querySelector('.oc-filter-form');
      const options = {
        scene: ['commuting', 'cargo', 'offroad', 'folding'],
        brand: [
          ...new Set(
            this.all.map((p) => String(p.brandId)).filter((id) => id !== 'null' && id !== 'undefined'),
          ),
        ],
        load: ['120', '150'],
        range: ['40', '60', '80'],
        weight: ['20', '25', 'gt25'],
        road: [this.dataset.market],
      };
      for (const [dimension, values] of Object.entries(options)) {
        if (form.querySelector(`[data-dimension="${dimension}"]`)) continue;
        if (
          (dimension === 'scene' && this.dataset.kind === 'scene') ||
          (dimension === 'brand' && this.dataset.kind === 'brand') ||
          (dimension === 'road' && this.dataset.vehicle !== 'escooter')
        )
          continue;
        const meaningful = values.filter((value) =>
          this.all.some((p) =>
            OrtluxResponsiveCollection.matches(
              p,
              new URLSearchParams([[OrtluxResponsiveCollection.dimensions[dimension], value]]),
            ),
          ),
        );
        if (!meaningful.length) continue;
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = dimension;
        const legend = document.createElement('legend');
        legend.textContent = this.c[dimension];
        fieldset.append(legend);
        for (const value of meaningful) {
          const label = document.createElement('label');
          label.className = 'oc-check';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.name = OrtluxResponsiveCollection.dimensions[dimension];
          input.value = value;
          const text = document.createElement('span');
          text.textContent =
            dimension === 'brand'
              ? this.all.find((p) => String(p.brandId) === value).brand
              : dimension === 'scene'
                ? this.c[value]
                : dimension === 'road'
                  ? this.c.approved
                  : dimension === 'weight'
                    ? `${value === 'gt25' ? '>' : '≤'} ${value === 'gt25' ? '25' : value} kg`
                    : `≥ ${value} ${dimension === 'range' ? 'km' : 'kg'}`;
          const count = document.createElement('small');
          count.dataset.optionCount = '';
          label.append(input, text, count);
          fieldset.append(label);
        }
        form.append(fieldset);
      }
      if (!form.querySelector('[data-dimension="price"]') && this.all.length) {
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = 'price';
        const legend = document.createElement('legend');
        legend.textContent = this.c.price;
        const bands = document.createElement('div');
        bands.dataset.priceBands = '';
        const inputs = document.createElement('div');
        inputs.className = 'oc-price-inputs';
        for (const [suffix, title] of [
          ['gte', this.c.from],
          ['lte', this.c.up_to],
        ]) {
          const label = document.createElement('label');
          label.textContent = title;
          const input = document.createElement('input');
          input.name = `filter.v.price.${suffix}`;
          input.type = 'number';
          input.min = '0';
          input.step = '0.01';
          input.inputMode = 'decimal';
          label.append(input);
          inputs.append(label);
        }
        fieldset.append(legend, bands, inputs);
        form.prepend(fieldset);
      }
    }
    setupPrices() {
      const raw = JSON.parse(this.querySelector('[data-price-config]').textContent || 'null');
      this.bands = raw?.[this.dataset.currency] || [];
      const wrap = this.querySelector('[data-price-bands]');
      if (!wrap) return;
      wrap.replaceChildren();
      wrap.setAttribute('aria-busy', 'false');
      for (const [index, band] of this.bands.entries()) {
        if (!Array.isArray(band) || band.length !== 2) continue;
        const label = document.createElement('label');
        label.className = 'oc-check';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'oc_price';
        input.value = index;
        const text = document.createElement('span');
        text.textContent = this.bandText(band);
        const count = document.createElement('small');
        count.dataset.optionCount = '';
        label.append(input, text, count);
        wrap.append(label);
      }
    }
    bandText([min, max]) {
      return min === null
        ? `${this.c.up_to} ${this.money.format(max)}`
        : max === null
          ? `${this.c.from} ${this.money.format(min)}`
          : `${this.money.format(min)}–${this.money.format(max)}`;
    }
    syncInputs() {
      const p = this.current.searchParams;
      this.querySelectorAll('.oc-filter-form input').forEach((input) => {
        if (input.name === 'oc_price') {
          const band = this.bands?.[input.value];
          input.checked =
            !!band &&
            String(band[0] ?? '') === (p.get('filter.v.price.gte') || '') &&
            String(band[1] ?? '') === (p.get('filter.v.price.lte') || '');
        } else if (input.type === 'checkbox')
          input.checked = p
            .getAll(input.name)
            .flatMap((x) => x.split(','))
            .includes(input.value);
        else input.value = p.get(input.name) || '';
      });
      this.querySelector('[data-sort]').value = p.get('oc_sort') || p.get('sort_by') || 'manual';
    }
    async filterChange() {
      if (!this.all) {
        await this.ready;
        if (!this.all) return;
      }
      const next = new URL(location.href);
      for (const k of [...next.searchParams.keys()])
        if (k.startsWith('filter.') || k === 'page') next.searchParams.delete(k);
      for (const [k, v] of new FormData(this.querySelector('form')))
        if (v && k !== 'oc_price') next.searchParams.append(k, v);
      this.navigate(next);
    }
    change(e) {
      if (e.target.matches('[data-sort]')) {
        const next = new URL(location.href);
        next.searchParams.delete('page');
        next.searchParams.delete('sort_by');
        next.searchParams.delete('oc_sort');
        const v = e.target.value;
        if (v === 'range-descending' || v === 'weight-ascending') next.searchParams.set('oc_sort', v);
        else if (v !== 'manual') next.searchParams.set('sort_by', v);
        this.ready.then(() => {
          if (this.all) this.navigate(next);
        });
      } else if (e.target.matches('[data-compare-id]')) this.select(e.target);
      else if (e.target.closest('.oc-filter-form')) {
        if (e.target.name === 'oc_price') {
          const [min, max] = this.bands[e.target.value];
          this.querySelector('[name="filter.v.price.gte"]').value = min ?? '';
          this.querySelector('[name="filter.v.price.lte"]').value = max ?? '';
        }
        this.filterChange();
      }
    }
    navigate(url) {
      this.save();
      history.pushState({ oc: { url: url.href, scroll: 0 } }, '', url);
      this.current = url;
      this.syncInputs();
      this.render();
    }
    save(anchor) {
      const state = {
        ...history.state,
        oc: { url: location.href, scroll: scrollY, anchor: anchor || null },
      };
      history.replaceState(state, '');
    }
    restore() {
      const s = history.state?.oc;
      if (!s || s.url !== location.href) {
        if (location.hash.startsWith('#oc-card-'))
          requestAnimationFrame(() =>
            requestAnimationFrame(() =>
              document
                .getElementById(location.hash.slice(1))
                ?.scrollIntoView({ block: 'center', behavior: 'instant' }),
            ),
          );
        return;
      }
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          window.scrollTo({ top: s.scroll || 0, behavior: 'instant' });
        }),
      );
    }
    sort(items) {
      const sort =
        this.current.searchParams.get('oc_sort') || this.current.searchParams.get('sort_by') || 'manual';
      return [...items].sort((a, b) => {
        if (sort === 'price-ascending') return a.price - b.price;
        if (sort === 'price-descending') return b.price - a.price;
        if (sort === 'range-descending') return (b.range ?? -Infinity) - (a.range ?? -Infinity);
        if (sort === 'weight-ascending') return (a.weight ?? Infinity) - (b.weight ?? Infinity);
        return a.rank - b.rank;
      });
    }
    render(announce = true) {
      if (!this.all) return;
      if (announce || this.current.searchParams.has('oc_sort'))
        document.querySelector('[data-oc-itemlist]')?.remove();
      const params = this.current.searchParams;
      const filteredUrl = [...params.keys()].some(
        (key) => key.startsWith('filter.') || key === 'oc_sort' || key === 'sort_by',
      );
      let robots = document.getElementById('ortlux-filter-robots');
      if (filteredUrl) {
        if (!robots) {
          robots = document.createElement('meta');
          robots.id = 'ortlux-filter-robots';
          robots.name = 'robots';
          document.head.append(robots);
        }
        robots.content = 'noindex,follow';
      } else robots?.remove();
      this.results = this.sort(
        this.all
          .filter((p) => OrtluxResponsiveCollection.matches(p, params))
          .map((p) => {
            const min = params.get('filter.v.price.gte'),
              max = params.get('filter.v.price.lte');
            const prices = (p.prices?.length ? p.prices : [p.price]).filter(
              (v) => (!min || v >= Number(min) * 100) && (!max || v <= Number(max) * 100),
            );
            return { ...p, price: Math.min(...prices) };
          }),
      );
      const sortControl = this.querySelector('[data-sort]');
      for (const [value, metric] of [['weight-ascending', 'weight'], ['range-descending', 'range']]) {
        const option = sortControl.querySelector(`option[value="${value}"]`);
        const available = this.results.some((p) => OrtluxResponsiveCollection.positive(p[metric]));
        option.hidden = !available;
        option.disabled = !available;
        if (!available && (params.get('oc_sort') === value || params.get('sort_by') === value)) {
          params.delete('oc_sort');
          params.delete('sort_by');
          this.results.sort((a, b) => a.rank - b.rank);
          history.replaceState(history.state, '', this.current);
        }
      }
      sortControl.value = params.get('oc_sort') || params.get('sort_by') || 'manual';
      this.visibleColumns = Math.max(1, getComputedStyle(this.querySelector('[data-grid]')).gridTemplateColumns.split(' ').length);
      const count = this.results.length,
        pages = Math.max(1, Math.ceil(count / this.pageSize));
      this.page = Math.min(pages, Math.max(1, parseInt(params.get('page') || '1', 10) || 1));
      const labels = OrtluxResponsiveCollection.labels(this.results),
        visible = this.results.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
      this.querySelector('[data-grid]').replaceChildren(
        ...visible.map((p, i) => this.card(p, labels.get(p.id), i)),
      );
      this.querySelectorAll('[data-count],[data-result-count]').forEach(
        (e) => (e.textContent = this.number.format(count)),
      );
      this.updateCounts();
      this.active();
      this.pagination(pages);
      this.empty();
      this.updateTray();
      this.markVisited();
      this.say(`${this.number.format(count)} ${this.c.results}`);
      if (announce) this.querySelector('[data-grid-wrap]').setAttribute('data-updated', '');
    }
    card(p, label, index = 9) {
      const node = this.querySelector('[data-card-template]').content.firstElementChild.cloneNode(true);
      node.dataset.id = p.id;
      node.id = 'oc-card-' + p.id;
      const link = node.querySelector('a');
      link.href = this.productURL(p);
      link.dataset.productId = p.id;
      const img = node.querySelector('img');
      if (p.image) {
        if (p.srcset) img.srcset = p.srcset;
        img.sizes = '(max-width: 640px) 100vw, (max-width: 1100px) 50vw, 33vw';
        img.src = p.image;
        img.alt = p.imageAlt || p.modelLabel;
        img.width = p.imageWidth || 600;
        img.height = p.imageHeight || 400;
        img.loading = index < this.visibleColumns ? 'eager' : 'lazy';
        img.decoding = 'async';
        img.fetchPriority = index === 0 ? 'high' : 'auto';
      } else {
        img.remove();
        node.querySelector('.oc-card-image').append(document.createTextNode(this.c.no_image));
      }
      node.querySelector('.oc-card-brand').textContent = p.brand;
      node.querySelector('h3').textContent = p.title;
      node.querySelector('[data-price]').textContent =
        (p.varies ? this.c.from + ' ' : '') + this.money.format(p.price / 100);
      const old = node.querySelector('s');
      if (p.comparePrice > p.price) old.textContent = this.money.format(p.comparePrice / 100);
      else old.remove();
      node.querySelector('[data-range]').textContent =
        p.range === null || p.range === undefined ? '—' : this.number.format(p.range) + ' km';
      node.querySelector('[data-weight]').textContent =
        p.weight === null || p.weight === undefined ? '—' : this.number.format(p.weight) + ' kg';
      node.querySelector('[data-badge]').textContent = label ? this.c[label] : '';
      const input = node.querySelector('[data-compare-id]');
      input.dataset.compareId = p.id;
      input.setAttribute('aria-label', this.c.compare + ' ' + p.brand + ' ' + p.title);
      input.checked = this.selected.has(p.id);
      input.disabled = this.selected.size >= 4 && !input.checked;
      return node;
    }
    productURL(p) {
      const url = new URL(p.url, location.href);
      url.searchParams.set('oc_return', this.current.pathname + this.current.search + '#oc-card-' + p.id);
      return url.href;
    }
    updateCounts() {
      for (const input of this.querySelectorAll('.oc-filter-form input[type=checkbox]')) {
        const key = input.closest('fieldset').dataset.dimension;
        const params = new URLSearchParams(this.current.search);
        params.delete(input.name);
        params.append(input.name, input.value);
        const count = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)).length;
        input.disabled = !count && !input.checked;
        input.closest('label').querySelector('[data-option-count]').textContent = count;
      }
      const pool = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, this.current.searchParams, 'price'));
      this.querySelectorAll('[name=oc_price]').forEach((input) => {
        const [min, max] = this.bands[input.value];
        const count = pool.filter((p) =>
          (p.prices?.length ? p.prices : [p.price]).some(
            (price) => (min === null || price >= min * 100) && (max === null || price <= max * 100),
          ),
        ).length;
        input.closest('label').querySelector('small').textContent = count;
        input.disabled = !count && !input.checked;
      });
    }
    active() {
      const wrap = this.querySelector('[data-active]');
      wrap.replaceChildren();
      for (const [key, val] of this.current.searchParams) {
        if (!key.startsWith('filter.')) continue;
        const input = [...this.querySelectorAll('.oc-filter-form input')].find(
          (e) => e.name === key && e.value === val,
        );
        const label = input?.closest('label')?.querySelector('span')?.textContent || val;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.removeFilter = key;
        button.dataset.value = val;
        button.textContent = (key.includes('price.') ? this.c.price + ' ' + val : label) + ' ×';
        button.setAttribute('aria-label', this.c.remove + ' ' + button.textContent);
        wrap.append(button);
      }
      if (!wrap.children.length) wrap.textContent = this.c.no_filters;
    }
    pagination(pages) {
      const nav = this.querySelector('[data-pagination]');
      nav.replaceChildren();
      for (const [name, page] of [
        ['prev', this.page - 1],
        ['next', this.page + 1],
      ]) {
        if (page < 1 || page > pages) continue;
        const a = document.createElement('a');
        const url = new URL(this.current);
        url.searchParams.set('page', page);
        a.href = url.href;
        a.rel =
          name +
          ([...this.current.searchParams.keys()].some(
            (k) => k.startsWith('filter.') || k === 'sort_by' || k === 'oc_sort',
          )
            ? ' nofollow'
            : '');
        a.dataset.page = page;
        a.textContent = this.c[name];
        nav.append(a);
      }
      const span = document.createElement('span');
      span.textContent = `${this.c.page} ${this.page} ${this.c.of} ${pages}`;
      nav.insertBefore(span, nav.querySelector('[rel~="next"]'));
    }
    empty() {
      const box = this.querySelector('[data-empty]');
      box.hidden = this.results.length > 0;
      this.querySelector('[data-grid]').hidden = !box.hidden;
      if (box.hidden) return;
      const keys = [...new Set([...this.current.searchParams.keys()].filter((k) => k.startsWith('filter.')))];
      const actions = box.querySelector('[data-relax-actions]');
      actions.replaceChildren();
      let near = [],
        chosen = [];
      const candidates = keys
        .map((key) => {
          const params = new URLSearchParams(this.current.search);
          params.delete(key);
          return {
            key,
            params,
            list: this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)),
          };
        })
        .sort((a, b) => b.list.length - a.list.length);
      if (candidates.length) {
        let params = new URLSearchParams(this.current.search);
        for (const item of candidates) {
          params.delete(item.key);
          chosen.push(item.key);
          near = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params));
          if (near.length >= 4) break;
        }
      }
      const names = chosen.map((k) => {
        const dim = Object.entries(OrtluxResponsiveCollection.dimensions).find(([, v]) => v === k)?.[0] || 'price';
        return this.c[dim];
      });
      box.querySelector('[data-empty-reason]').textContent = names.join(' + ') + ' — ' + this.c.relaxed;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.relax = JSON.stringify(chosen);
      button.textContent = this.c.relax + ': ' + names.join(' + ');
      actions.append(button);
      box.querySelector('[data-near]').replaceChildren(...near.slice(0, 4).map((p) => this.card(p)));
    }
    select(input) {
      const p =
        this.results?.find((p) => p.id === input.dataset.compareId) ||
        this.all?.find((p) => p.id === input.dataset.compareId);
      if (!p) {
        input.checked = false;
        this.say(this.c.loading);
        return;
      }
      if (input.checked && this.selected.size < 4) this.selected.set(p.id, p);
      else this.selected.delete(p.id);
      this.updateTray();
      this.say(`${this.selected.size} / 4 ${this.c.selected}`);
    }
    updateTray() {
      const tray = this.querySelector('[data-tray]');
      tray.hidden = !this.selected.size;
      tray.querySelector('[data-selected-count]').textContent = this.selected.size + ' / 4';
      tray.querySelector('[data-limit]').textContent = this.selected.size === 4 ? this.c.limit : '';
      const list = tray.querySelector('[data-selected-list]');
      list.replaceChildren();
      for (const p of this.selected.values()) {
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.removeCompare = p.id;
        b.textContent = p.title + ' ×';
        b.setAttribute('aria-label', this.c.remove + ' ' + p.title);
        list.append(b);
      }
      this.querySelectorAll('[data-compare-id]').forEach((input) => {
        input.checked = this.selected.has(input.dataset.compareId);
        input.disabled = this.selected.size === 4 && !input.checked;
        input.title = input.disabled ? this.c.limit : '';
      });
    }
    compare() {
      const dialog = this.querySelector('[data-comparison]'),
        table = dialog.querySelector('table'),
        items = [...this.selected.values()];
      if (!items.length) return;
      const head = document.createElement('tr'),
        corner = document.createElement('th');
      corner.scope = 'col';
      corner.textContent = this.c.model;
      head.append(corner);
      for (const p of items) {
        const th = document.createElement('th');
        th.scope = 'col';
        th.textContent = p.brand + ' ' + p.title;
        head.append(th);
      }
      table.querySelector('thead').replaceChildren(head);
      const rows = [
        ['vehicle', 'vehicle', ''],
        ['load', 'load', 'kg'],
        ['weight', 'weight', 'kg'],
        ['range', 'range', 'km'],
        ['price', 'price', ''],
        ['motor', 'motor', 'W'],
        ['battery', 'battery', 'Wh'],
        ['speed', 'speed', 'km/h'],
        ['ip', 'ip', ''],
        ['heightMin', 'height_min', 'cm'],
        ['heightMax', 'height_max', 'cm'],
        ['rangeMax', 'range', 'km'],
        ['motorModel', 'motor_model', ''],
        ['frameMaterial', 'frame_material', ''],
        ['brakes', 'brakes', ''],
        ['tyres', 'tyres', ''],
        ['dimensions', 'dimensions', ''],
        ['gradeability', 'gradeability', '%'],
        ['testedMin', 'tested_min', 'km'],
        ['testedMax', 'tested_max', 'km'],
        ['testConditions', 'test_conditions', ''],
      ];
      const body = table.querySelector('tbody');
      body.replaceChildren();
      rows.forEach(([key, label, unit], index) => {
        if (index > 4 && !items.some((p) => p[key] !== null && p[key] !== undefined && p[key] !== '')) return;
        const tr = document.createElement('tr'),
          th = document.createElement('th');
        th.scope = 'row';
        th.textContent = this.c[label] + (key === 'rangeMax' ? ' (max)' : '');
        tr.append(th);
        for (const p of items) {
          const td = document.createElement('td');
          td.textContent =
            p[key] === null || p[key] === undefined || p[key] === ''
              ? '—'
              : key === 'price'
                ? this.money.format(p.price / 100)
                : `${typeof p[key] === 'number' ? this.number.format(p[key]) : p[key]}${unit ? ' ' + unit : ''}`;
          tr.append(td);
        }
        body.append(tr);
      });
      const foot = document.createElement('tr'),
        th = document.createElement('th');
      th.scope = 'row';
      th.textContent = this.c.model;
      foot.append(th);
      for (const p of items) {
        const td = document.createElement('td'),
          a = document.createElement('a');
        a.href = this.productURL(p);
        a.dataset.productId = p.id;
        a.textContent = p.title + ' ↗';
        td.append(a);
        foot.append(td);
      }
      table.querySelector('tfoot').replaceChildren(foot);
      dialog.showModal();
      dialog.querySelector('button').focus();
    }
    markVisited() {
      this.querySelectorAll('.oc-card').forEach((card) => {
        card.querySelector('.oc-visited').hidden = !this.visited.has(card.dataset.id);
      });
    }
    openFilters() {
      const panel = this.querySelector('.oc-sidebar');
      this.drawerOpen = true;
      this.dataset.drawerOpen = '';
      panel.dataset.open = '';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'true');
      this.querySelector('[data-shade]').hidden = false;
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.inerted = [];
      for (const node of document.body.children) {
        if (!node.contains(this) && !node.inert) {
          node.inert = true;
          this.inerted.push(node);
        }
      }
      this.querySelector('[data-close-filters]').focus();
    }
    closeFilters(focus = true) {
      if (!this.drawerOpen) return;
      this.drawerOpen = false;
      delete this.dataset.drawerOpen;
      const panel = this.querySelector('.oc-sidebar');
      delete panel.dataset.open;
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'false');
      this.querySelector('[data-shade]').hidden = true;
      document.body.style.overflow = this.oldOverflow || '';
      this.inerted?.forEach((e) => (e.inert = false));
      if (focus) this.querySelector('[data-open-filters]').focus();
    }
    keydown(e) {
      if (!this.drawerOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeFilters();
      }
      if (e.key === 'Tab') {
        const nodes = [
          ...this.querySelector('.oc-sidebar').querySelectorAll(
            'button:not([disabled]),input:not([disabled]),a[href],select',
          ),
        ].filter((el) => el.getClientRects().length);
        const first = nodes[0],
          last = nodes.at(-1);
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    click(e) {
      const target = e.target.closest('button,a');
      if (!target) return;
      if (target.dataset.productId) {
        const destination = new URL(target.href, location.href);
        destination.searchParams.set(
          'oc_return',
          this.current.pathname + this.current.search + '#oc-card-' + target.dataset.productId,
        );
        target.href = destination.href;
        this.save('oc-card-' + target.dataset.productId);
        this.visited.add(target.dataset.productId);
        try {
          localStorage.setItem('ortlux-visited', JSON.stringify([...this.visited]));
        } catch {}
        this.markVisited();
        return;
      }
      if (target.matches('[data-open-filters]')) this.openFilters();
      else if (target.matches('[data-close-filters]')) this.closeFilters();
      else if (target.matches('[data-retry]')) this.ready = this.load();
      else if (target.matches('[data-page]')) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        this.navigate(new URL(target.href));
        const h = this.querySelector('.oc-result-heading');
        h.tabIndex = -1;
        h.focus({ preventScroll: true });
        h.scrollIntoView({ block: 'start', behavior: 'instant' });
      } else if (target.matches('[data-clear]')) {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()])
          if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.removeFilter) {
        const url = new URL(location.href),
          key = target.dataset.removeFilter,
          values = url.searchParams.getAll(key).filter((x) => x !== target.dataset.value);
        url.searchParams.delete(key);
        values.forEach((v) => url.searchParams.append(key, v));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.relax) {
        const url = new URL(location.href);
        JSON.parse(target.dataset.relax).forEach((k) => url.searchParams.delete(k));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.matches('[data-compare]')) this.compare();
      else if (target.matches('[data-close-compare]')) this.querySelector('[data-comparison]').close();
      else if (target.dataset.removeCompare) {
        this.selected.delete(target.dataset.removeCompare);
        this.updateTray();
        this.say(`${this.selected.size} / 4 ${this.c.selected}`);
        const fallback = this.selected.size
          ? this.querySelector('[data-compare]')
          : this.querySelector('[data-clear]');
        fallback.focus();
      } else if (target.matches('[data-clear-compare]')) {
        this.selected.clear();
        this.updateTray();
        this.say('0 / 4 ' + this.c.selected);
        this.querySelector('[data-clear]').focus();
      }
    }
  }
  if (!customElements.get('ortlux-responsive-collection')) customElements.define('ortlux-responsive-collection', OrtluxResponsiveCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-collection-v4"] && !Shopify.designMode) return;
  try {
    
  /* The numeric catalogue is loaded in market context; no external runtime. */
  class OrtluxResponsiveCollection extends HTMLElement {
    static dimensions = {
      scene: 'filter.p.m.ortlux.use_cases',
      brand: 'filter.p.m.ortlux.brand',
      load: 'filter.p.m.ortlux.load_bands',
      range: 'filter.p.m.ortlux.range_bands',
      weight: 'filter.p.m.ortlux.weight_bands',
      road: 'filter.p.m.ortlux.road_legal_markets',
    };
    static positive(v) {
      return typeof v === 'number' && Number.isFinite(v) && v > 0;
    }
    static labels(items) {
      const result = new Map();
      if (items.length < 2 || items.length > 12) return result;
      const metrics = [
        ['lightest', (p) => p.weight, 1],
        ['longest', (p) => p.range, -1],
        [
          'value',
          (p) =>
            OrtluxResponsiveCollection.positive(p.range) && OrtluxResponsiveCollection.positive(p.price)
              ? p.price / p.range
              : null,
          1,
        ],
        ['cheapest', (p) => p.price, 1],
      ];
      for (const [label, get, dir] of metrics) {
        const list = items
          .map((p) => ({ p, v: get(p) }))
          .filter((x) => OrtluxResponsiveCollection.positive(x.v))
          .sort((a, b) => dir * (a.v - b.v));
        if (list.length < 2) continue;
        const best = list[0],
          second = list[1];
        const gap = dir === 1 ? (second.v - best.v) / second.v : (best.v - second.v) / second.v;
        if (gap + Number.EPSILON >= 0.1 && !result.has(best.p.id)) result.set(best.p.id, label);
      }
      return result;
    }
    static matches(p, params, skip) {
      for (const [key, name] of Object.entries(this.dimensions)) {
        if (key === skip) continue;
        const selected = params.getAll(name).flatMap((x) => x.split(','));
        if (!selected.length) continue;
        const hit = selected.some((v) =>
          key === 'scene'
            ? (p.scenes || []).includes(v)
            : key === 'brand'
              ? String(p.brandId) === v
              : key === 'road'
                ? (p.road || []).includes(v)
                : key === 'load'
                  ? this.positive(p.load) && p.load >= Number(v)
                  : key === 'range'
                    ? this.positive(p.range) && p.range >= Number(v)
                    : key === 'weight'
                      ? this.positive(p.weight) && (v === 'gt25' ? p.weight > 25 : p.weight <= Number(v))
                      : true,
        );
        if (!hit) return false;
      }
      if (skip !== 'price') {
        const min = params.get('filter.v.price.gte'),
          max = params.get('filter.v.price.lte');
        const prices = Array.isArray(p.prices) && p.prices.length ? p.prices : [p.price];
        if (
          !prices.some(
            (price) =>
              (min === null || min === '' || price >= Number(min) * 100) &&
              (max === null || max === '' || price <= Number(max) * 100),
          )
        )
          return false;
      }
      return true;
    }
    connectedCallback() {
      if (!this.querySelector('[data-grid]')) return;
      if (this.initialized) return;
      this.initialized = true;
      this.c = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.pageSize = 12;
      this.selected = new Map();
      this.all = null;
      this.current = new URL(location.href);
      this.visited = new Set();
      this.abort = new AbortController();
      this.money = new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency',
        currency: this.dataset.currency,
      });
      this.number = new Intl.NumberFormat(this.dataset.locale, {
        maximumFractionDigits: 1,
      });
      try {
        this.visited = new Set(JSON.parse(localStorage.getItem('ortlux-visited') || '[]'));
      } catch {}
      this.dataset.enhanced = '';
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      this.addEventListener('click', (e) => this.click(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('change', (e) => this.change(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('keydown', (e) => this.keydown(e), {
        signal: this.abort.signal,
      });
      this.querySelector('form').addEventListener(
        'submit',
        (e) => {
          e.preventDefault();
          this.filterChange();
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'popstate',
        () => {
          this.current = new URL(location.href);
          this.ready.then(() => {
            this.syncInputs();
            this.render(false);
            this.restore();
          });
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'pageshow',
        (e) => {
          if (e.persisted) {
            this.markVisited();
            this.restore();
          }
        },
        { signal: this.abort.signal },
      );
      window.addEventListener('pagehide', () => this.save(), {
        signal: this.abort.signal,
      });
      window.addEventListener(
        'resize',
        () => {
          if (innerWidth > 750 && this.drawerOpen) this.closeFilters();
        },
        { signal: this.abort.signal },
      );
      this.querySelector('[data-comparison]').addEventListener(
        'close',
        () => this.querySelector('[data-compare]').focus(),
        { signal: this.abort.signal },
      );
      document.addEventListener(
        'focusin',
        (e) => {
          if (this.drawerOpen || this.querySelector('[data-comparison]').open) return;
          const tray = this.querySelector('[data-tray]');
          if (tray.hidden || tray.contains(e.target)) return;
          const rect = e.target.getBoundingClientRect(),
            top = tray.getBoundingClientRect().top;
          if (rect.bottom > top - 8) window.scrollBy({ top: rect.bottom - top + 16, behavior: 'instant' });
        },
        { signal: this.abort.signal },
      );
      this.markVisited();
      this.syncInputs();
      this.ready = this.load();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.closeFilters(false);
    }
    say(text) {
      this.querySelector('[data-live]').textContent = text;
    }
    async load() {
      this.setAttribute('aria-busy', 'true');
      this.say(this.c.loading);
      try {
        let products = [],
          page = 1,
          pages = 1;
        do {
          let url;
          if (this.dataset.preview) {
            url = new URL(this.dataset.preview, location.href);
            url.searchParams.set('page', page);
          } else {
            url = new URL(this.dataset.url, location.origin);
            url.searchParams.set('section_id', 'ortlux-collection-data-v2');
            url.searchParams.set('page', page);
          }
          const response = await fetch(url, {
            signal: this.abort.signal,
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Catalogue response ' + response.status);
          let data;
          if (this.dataset.preview) data = await response.json();
          else {
            const t = document.createElement('template');
            t.innerHTML = await response.text();
            const node = t.content.querySelector('[data-catalog-data]');
            if (!node) throw new Error('Missing data section');
            data = JSON.parse(node.textContent);
          }
          if (
            !Array.isArray(data.products) ||
            !Number.isInteger(data.pages) ||
            data.pages < 1 ||
            data.pages > 100
          )
            throw new Error('Invalid catalogue response');
          products.push(...data.products);
          pages = data.pages;
          page++;
        } while (page <= pages);
        this.all = [...new Map(products.map((p) => [String(p.id), { ...p, id: String(p.id) }])).values()];
        this.setupMissingFilters();
        this.setupPrices();
        this.syncInputs();
        this.render(false);
        this.restore();
        this.querySelector('[data-retry]').hidden = true;
      } catch (e) {
        if (e.name !== 'AbortError') {
          this.say(this.c.error);
          this.querySelector('[data-retry]').hidden = false;
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
    setupMissingFilters() {
      const form = this.querySelector('.oc-filter-form');
      const options = {
        scene: ['commuting', 'cargo', 'offroad', 'folding'],
        brand: [
          ...new Set(
            this.all.map((p) => String(p.brandId)).filter((id) => id !== 'null' && id !== 'undefined'),
          ),
        ],
        load: ['120', '150'],
        range: ['40', '60', '80'],
        weight: ['20', '25', 'gt25'],
        road: [this.dataset.market],
      };
      for (const [dimension, values] of Object.entries(options)) {
        if (form.querySelector(`[data-dimension="${dimension}"]`)) continue;
        if (
          (dimension === 'scene' && this.dataset.kind === 'scene') ||
          (dimension === 'brand' && this.dataset.kind === 'brand') ||
          (dimension === 'road' && this.dataset.vehicle !== 'escooter')
        )
          continue;
        const meaningful = values.filter((value) =>
          this.all.some((p) =>
            OrtluxResponsiveCollection.matches(
              p,
              new URLSearchParams([[OrtluxResponsiveCollection.dimensions[dimension], value]]),
            ),
          ),
        );
        if (!meaningful.length) continue;
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = dimension;
        const legend = document.createElement('legend');
        legend.textContent = this.c[dimension];
        fieldset.append(legend);
        for (const value of meaningful) {
          const label = document.createElement('label');
          label.className = 'oc-check';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.name = OrtluxResponsiveCollection.dimensions[dimension];
          input.value = value;
          const text = document.createElement('span');
          text.textContent =
            dimension === 'brand'
              ? this.all.find((p) => String(p.brandId) === value).brand
              : dimension === 'scene'
                ? this.c[value]
                : dimension === 'road'
                  ? this.c.approved
                  : dimension === 'weight'
                    ? `${value === 'gt25' ? '>' : '≤'} ${value === 'gt25' ? '25' : value} kg`
                    : `≥ ${value} ${dimension === 'range' ? 'km' : 'kg'}`;
          const count = document.createElement('small');
          count.dataset.optionCount = '';
          label.append(input, text, count);
          fieldset.append(label);
        }
        form.append(fieldset);
      }
      if (!form.querySelector('[data-dimension="price"]') && this.all.length) {
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = 'price';
        const legend = document.createElement('legend');
        legend.textContent = this.c.price;
        const bands = document.createElement('div');
        bands.dataset.priceBands = '';
        const inputs = document.createElement('div');
        inputs.className = 'oc-price-inputs';
        for (const [suffix, title] of [
          ['gte', this.c.from],
          ['lte', this.c.up_to],
        ]) {
          const label = document.createElement('label');
          label.textContent = title;
          const input = document.createElement('input');
          input.name = `filter.v.price.${suffix}`;
          input.type = 'number';
          input.min = '0';
          input.step = '0.01';
          input.inputMode = 'decimal';
          label.append(input);
          inputs.append(label);
        }
        fieldset.append(legend, bands, inputs);
        form.prepend(fieldset);
      }
    }
    setupPrices() {
      const raw = JSON.parse(this.querySelector('[data-price-config]').textContent || 'null');
      this.bands = raw?.[this.dataset.currency] || [];
      const wrap = this.querySelector('[data-price-bands]');
      if (!wrap) return;
      wrap.replaceChildren();
      wrap.setAttribute('aria-busy', 'false');
      for (const [index, band] of this.bands.entries()) {
        if (!Array.isArray(band) || band.length !== 2) continue;
        const label = document.createElement('label');
        label.className = 'oc-check';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'oc_price';
        input.value = index;
        const text = document.createElement('span');
        text.textContent = this.bandText(band);
        const count = document.createElement('small');
        count.dataset.optionCount = '';
        label.append(input, text, count);
        wrap.append(label);
      }
    }
    bandText([min, max]) {
      return min === null
        ? `${this.c.up_to} ${this.money.format(max)}`
        : max === null
          ? `${this.c.from} ${this.money.format(min)}`
          : `${this.money.format(min)}–${this.money.format(max)}`;
    }
    syncInputs() {
      const p = this.current.searchParams;
      this.querySelectorAll('.oc-filter-form input').forEach((input) => {
        if (input.name === 'oc_price') {
          const band = this.bands?.[input.value];
          input.checked =
            !!band &&
            String(band[0] ?? '') === (p.get('filter.v.price.gte') || '') &&
            String(band[1] ?? '') === (p.get('filter.v.price.lte') || '');
        } else if (input.type === 'checkbox')
          input.checked = p
            .getAll(input.name)
            .flatMap((x) => x.split(','))
            .includes(input.value);
        else input.value = p.get(input.name) || '';
      });
      this.querySelector('[data-sort]').value = p.get('oc_sort') || p.get('sort_by') || 'manual';
    }
    async filterChange() {
      if (!this.all) {
        await this.ready;
        if (!this.all) return;
      }
      const next = new URL(location.href);
      for (const k of [...next.searchParams.keys()])
        if (k.startsWith('filter.') || k === 'page') next.searchParams.delete(k);
      for (const [k, v] of new FormData(this.querySelector('form')))
        if (v && k !== 'oc_price') next.searchParams.append(k, v);
      this.navigate(next);
    }
    change(e) {
      if (e.target.matches('[data-sort]')) {
        const next = new URL(location.href);
        next.searchParams.delete('page');
        next.searchParams.delete('sort_by');
        next.searchParams.delete('oc_sort');
        const v = e.target.value;
        if (v === 'range-descending' || v === 'weight-ascending') next.searchParams.set('oc_sort', v);
        else if (v !== 'manual') next.searchParams.set('sort_by', v);
        this.ready.then(() => {
          if (this.all) this.navigate(next);
        });
      } else if (e.target.matches('[data-compare-id]')) this.select(e.target);
      else if (e.target.closest('.oc-filter-form')) {
        if (e.target.name === 'oc_price') {
          const [min, max] = this.bands[e.target.value];
          this.querySelector('[name="filter.v.price.gte"]').value = min ?? '';
          this.querySelector('[name="filter.v.price.lte"]').value = max ?? '';
        }
        this.filterChange();
      }
    }
    navigate(url) {
      this.save();
      history.pushState({ oc: { url: url.href, scroll: 0 } }, '', url);
      this.current = url;
      this.syncInputs();
      this.render();
    }
    save(anchor) {
      const state = {
        ...history.state,
        oc: { url: location.href, scroll: scrollY, anchor: anchor || null },
      };
      history.replaceState(state, '');
    }
    restore() {
      const s = history.state?.oc;
      if (!s || s.url !== location.href) {
        if (location.hash.startsWith('#oc-card-'))
          requestAnimationFrame(() =>
            requestAnimationFrame(() =>
              document
                .getElementById(location.hash.slice(1))
                ?.scrollIntoView({ block: 'center', behavior: 'instant' }),
            ),
          );
        return;
      }
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          window.scrollTo({ top: s.scroll || 0, behavior: 'instant' });
        }),
      );
    }
    sort(items) {
      const sort =
        this.current.searchParams.get('oc_sort') || this.current.searchParams.get('sort_by') || 'manual';
      return [...items].sort((a, b) => {
        if (sort === 'price-ascending') return a.price - b.price;
        if (sort === 'price-descending') return b.price - a.price;
        if (sort === 'range-descending') return (b.range ?? -Infinity) - (a.range ?? -Infinity);
        if (sort === 'weight-ascending') return (a.weight ?? Infinity) - (b.weight ?? Infinity);
        return a.rank - b.rank;
      });
    }
    render(announce = true) {
      if (!this.all) return;
      if (announce || this.current.searchParams.has('oc_sort'))
        document.querySelector('[data-oc-itemlist]')?.remove();
      const params = this.current.searchParams;
      const filteredUrl = [...params.keys()].some(
        (key) => key.startsWith('filter.') || key === 'oc_sort' || key === 'sort_by',
      );
      let robots = document.getElementById('ortlux-filter-robots');
      if (filteredUrl) {
        if (!robots) {
          robots = document.createElement('meta');
          robots.id = 'ortlux-filter-robots';
          robots.name = 'robots';
          document.head.append(robots);
        }
        robots.content = 'noindex,follow';
      } else robots?.remove();
      this.results = this.sort(
        this.all
          .filter((p) => OrtluxResponsiveCollection.matches(p, params))
          .map((p) => {
            const min = params.get('filter.v.price.gte'),
              max = params.get('filter.v.price.lte');
            const prices = (p.prices?.length ? p.prices : [p.price]).filter(
              (v) => (!min || v >= Number(min) * 100) && (!max || v <= Number(max) * 100),
            );
            return { ...p, price: Math.min(...prices) };
          }),
      );
      const sortControl = this.querySelector('[data-sort]');
      for (const [value, metric] of [['weight-ascending', 'weight'], ['range-descending', 'range']]) {
        const option = sortControl.querySelector(`option[value="${value}"]`);
        const available = this.results.some((p) => OrtluxResponsiveCollection.positive(p[metric]));
        option.hidden = !available;
        option.disabled = !available;
        if (!available && (params.get('oc_sort') === value || params.get('sort_by') === value)) {
          params.delete('oc_sort');
          params.delete('sort_by');
          this.results.sort((a, b) => a.rank - b.rank);
          history.replaceState(history.state, '', this.current);
        }
      }
      sortControl.value = params.get('oc_sort') || params.get('sort_by') || 'manual';
      this.visibleColumns = Math.max(1, getComputedStyle(this.querySelector('[data-grid]')).gridTemplateColumns.split(' ').length);
      const count = this.results.length,
        pages = Math.max(1, Math.ceil(count / this.pageSize));
      this.page = Math.min(pages, Math.max(1, parseInt(params.get('page') || '1', 10) || 1));
      const labels = OrtluxResponsiveCollection.labels(this.results),
        visible = this.results.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
      this.querySelector('[data-grid]').replaceChildren(
        ...visible.map((p, i) => this.card(p, labels.get(p.id), i)),
      );
      this.querySelectorAll('[data-count],[data-result-count]').forEach(
        (e) => (e.textContent = this.number.format(count)),
      );
      this.updateCounts();
      this.active();
      this.pagination(pages);
      this.empty();
      this.updateTray();
      this.markVisited();
      this.say(`${this.number.format(count)} ${this.c.results}`);
      if (announce) this.querySelector('[data-grid-wrap]').setAttribute('data-updated', '');
    }
    card(p, label, index = 9) {
      const node = this.querySelector('[data-card-template]').content.firstElementChild.cloneNode(true);
      node.dataset.id = p.id;
      node.id = 'oc-card-' + p.id;
      const link = node.querySelector('a');
      link.href = this.productURL(p);
      link.dataset.productId = p.id;
      const img = node.querySelector('img');
      if (p.image) {
        if (p.srcset) img.srcset = p.srcset;
        img.sizes = '(max-width: 640px) 100vw, (max-width: 1100px) 50vw, 33vw';
        img.src = p.image;
        img.alt = p.imageAlt || p.modelLabel;
        img.width = p.imageWidth || 600;
        img.height = p.imageHeight || 400;
        img.loading = index < this.visibleColumns ? 'eager' : 'lazy';
        img.decoding = 'async';
        img.fetchPriority = index === 0 ? 'high' : 'auto';
      } else {
        img.remove();
        node.querySelector('.oc-card-image').append(document.createTextNode(this.c.no_image));
      }
      node.querySelector('.oc-card-brand').textContent = p.brand;
      node.querySelector('h3').textContent = p.title;
      node.querySelector('[data-price]').textContent =
        (p.varies ? this.c.from + ' ' : '') + this.money.format(p.price / 100);
      const old = node.querySelector('s');
      if (p.comparePrice > p.price) old.textContent = this.money.format(p.comparePrice / 100);
      else old.remove();
      node.querySelector('[data-range]').textContent =
        p.range === null || p.range === undefined ? '—' : this.number.format(p.range) + ' km';
      node.querySelector('[data-weight]').textContent =
        p.weight === null || p.weight === undefined ? '—' : this.number.format(p.weight) + ' kg';
      node.querySelector('[data-badge]').textContent = label ? this.c[label] : '';
      const input = node.querySelector('[data-compare-id]');
      input.dataset.compareId = p.id;
      input.setAttribute('aria-label', this.c.compare + ' ' + p.brand + ' ' + p.title);
      input.checked = this.selected.has(p.id);
      input.disabled = this.selected.size >= 4 && !input.checked;
      return node;
    }
    productURL(p) {
      const url = new URL(p.url, location.href);
      url.searchParams.set('oc_return', this.current.pathname + this.current.search + '#oc-card-' + p.id);
      return url.href;
    }
    updateCounts() {
      for (const input of this.querySelectorAll('.oc-filter-form input[type=checkbox]')) {
        const key = input.closest('fieldset').dataset.dimension;
        const params = new URLSearchParams(this.current.search);
        params.delete(input.name);
        params.append(input.name, input.value);
        const count = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)).length;
        input.disabled = !count && !input.checked;
        input.closest('label').querySelector('[data-option-count]').textContent = count;
      }
      const pool = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, this.current.searchParams, 'price'));
      this.querySelectorAll('[name=oc_price]').forEach((input) => {
        const [min, max] = this.bands[input.value];
        const count = pool.filter((p) =>
          (p.prices?.length ? p.prices : [p.price]).some(
            (price) => (min === null || price >= min * 100) && (max === null || price <= max * 100),
          ),
        ).length;
        input.closest('label').querySelector('small').textContent = count;
        input.disabled = !count && !input.checked;
      });
    }
    active() {
      const wrap = this.querySelector('[data-active]');
      wrap.replaceChildren();
      for (const [key, val] of this.current.searchParams) {
        if (!key.startsWith('filter.')) continue;
        const input = [...this.querySelectorAll('.oc-filter-form input')].find(
          (e) => e.name === key && e.value === val,
        );
        const label = input?.closest('label')?.querySelector('span')?.textContent || val;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.removeFilter = key;
        button.dataset.value = val;
        button.textContent = (key.includes('price.') ? this.c.price + ' ' + val : label) + ' ×';
        button.setAttribute('aria-label', this.c.remove + ' ' + button.textContent);
        wrap.append(button);
      }
      if (!wrap.children.length) wrap.textContent = this.c.no_filters;
    }
    pagination(pages) {
      const nav = this.querySelector('[data-pagination]');
      nav.replaceChildren();
      for (const [name, page] of [
        ['prev', this.page - 1],
        ['next', this.page + 1],
      ]) {
        if (page < 1 || page > pages) continue;
        const a = document.createElement('a');
        const url = new URL(this.current);
        url.searchParams.set('page', page);
        a.href = url.href;
        a.rel =
          name +
          ([...this.current.searchParams.keys()].some(
            (k) => k.startsWith('filter.') || k === 'sort_by' || k === 'oc_sort',
          )
            ? ' nofollow'
            : '');
        a.dataset.page = page;
        a.textContent = this.c[name];
        nav.append(a);
      }
      const span = document.createElement('span');
      span.textContent = `${this.c.page} ${this.page} ${this.c.of} ${pages}`;
      nav.insertBefore(span, nav.querySelector('[rel~="next"]'));
    }
    empty() {
      const box = this.querySelector('[data-empty]');
      box.hidden = this.results.length > 0;
      this.querySelector('[data-grid]').hidden = !box.hidden;
      if (box.hidden) return;
      const keys = [...new Set([...this.current.searchParams.keys()].filter((k) => k.startsWith('filter.')))];
      const actions = box.querySelector('[data-relax-actions]');
      actions.replaceChildren();
      let near = [],
        chosen = [];
      const candidates = keys
        .map((key) => {
          const params = new URLSearchParams(this.current.search);
          params.delete(key);
          return {
            key,
            params,
            list: this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)),
          };
        })
        .sort((a, b) => b.list.length - a.list.length);
      if (candidates.length) {
        let params = new URLSearchParams(this.current.search);
        for (const item of candidates) {
          params.delete(item.key);
          chosen.push(item.key);
          near = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params));
          if (near.length >= 4) break;
        }
      }
      const names = chosen.map((k) => {
        const dim = Object.entries(OrtluxResponsiveCollection.dimensions).find(([, v]) => v === k)?.[0] || 'price';
        return this.c[dim];
      });
      box.querySelector('[data-empty-reason]').textContent = names.join(' + ') + ' — ' + this.c.relaxed;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.relax = JSON.stringify(chosen);
      button.textContent = this.c.relax + ': ' + names.join(' + ');
      actions.append(button);
      box.querySelector('[data-near]').replaceChildren(...near.slice(0, 4).map((p) => this.card(p)));
    }
    select(input) {
      const p =
        this.results?.find((p) => p.id === input.dataset.compareId) ||
        this.all?.find((p) => p.id === input.dataset.compareId);
      if (!p) {
        input.checked = false;
        this.say(this.c.loading);
        return;
      }
      if (input.checked && this.selected.size < 4) this.selected.set(p.id, p);
      else this.selected.delete(p.id);
      this.updateTray();
      this.say(`${this.selected.size} / 4 ${this.c.selected}`);
    }
    updateTray() {
      const tray = this.querySelector('[data-tray]');
      tray.hidden = !this.selected.size;
      tray.querySelector('[data-selected-count]').textContent = this.selected.size + ' / 4';
      tray.querySelector('[data-limit]').textContent = this.selected.size === 4 ? this.c.limit : '';
      const list = tray.querySelector('[data-selected-list]');
      list.replaceChildren();
      for (const p of this.selected.values()) {
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.removeCompare = p.id;
        b.textContent = p.title + ' ×';
        b.setAttribute('aria-label', this.c.remove + ' ' + p.title);
        list.append(b);
      }
      this.querySelectorAll('[data-compare-id]').forEach((input) => {
        input.checked = this.selected.has(input.dataset.compareId);
        input.disabled = this.selected.size === 4 && !input.checked;
        input.title = input.disabled ? this.c.limit : '';
      });
    }
    compare() {
      const dialog = this.querySelector('[data-comparison]'),
        table = dialog.querySelector('table'),
        items = [...this.selected.values()];
      if (!items.length) return;
      const head = document.createElement('tr'),
        corner = document.createElement('th');
      corner.scope = 'col';
      corner.textContent = this.c.model;
      head.append(corner);
      for (const p of items) {
        const th = document.createElement('th');
        th.scope = 'col';
        const link = document.createElement('a');
        link.className = 'oc-compare-model';
        link.href = this.productURL(p);
        link.dataset.productId = p.id;
        if (p.image) {
          const image = document.createElement('img');
          const src = new URL(p.image, location.origin);
          src.searchParams.set('width', '320');
          image.src = src.href;
          image.width = 160;
          image.height = 160;
          image.alt = '';
          image.decoding = 'async';
          image.className = 'oc-compare-image';
          link.append(image);
        }
        const name = document.createElement('span');
        name.textContent = p.title;
        link.append(name);
        th.append(link);
        head.append(th);
      }
      table.querySelector('thead').replaceChildren(head);
      const rows = [
        ['vehicle', 'vehicle', ''],
        ['load', 'load', 'kg'],
        ['weight', 'weight', 'kg'],
        ['range', 'range', 'km'],
        ['price', 'price', ''],
        ['motor', 'motor', 'W'],
        ['battery', 'battery', 'Wh'],
        ['speed', 'speed', 'km/h'],
        ['ip', 'ip', ''],
        ['heightMin', 'height_min', 'cm'],
        ['heightMax', 'height_max', 'cm'],
        ['rangeMax', 'range', 'km'],
        ['motorModel', 'motor_model', ''],
        ['frameMaterial', 'frame_material', ''],
        ['brakes', 'brakes', ''],
        ['tyres', 'tyres', ''],
        ['dimensions', 'dimensions', ''],
        ['gradeability', 'gradeability', '%'],
        ['testedMin', 'tested_min', 'km'],
        ['testedMax', 'tested_max', 'km'],
        ['testConditions', 'test_conditions', ''],
      ];
      const body = table.querySelector('tbody');
      body.replaceChildren();
      rows.forEach(([key, label, unit], index) => {
        if (key === 'vehicle') return;
        if (index > 4 && !items.some((p) => p[key] !== null && p[key] !== undefined && p[key] !== '')) return;
        const tr = document.createElement('tr'),
          th = document.createElement('th');
        th.scope = 'row';
        th.textContent = this.c[label] + (key === 'rangeMax' ? ' (max)' : '');
        tr.append(th);
        for (const p of items) {
          const td = document.createElement('td');
          td.textContent =
            p[key] === null || p[key] === undefined || p[key] === ''
              ? '—'
              : key === 'price'
                ? this.money.format(p.price / 100)
                : `${typeof p[key] === 'number' ? this.number.format(p[key]) : p[key]}${unit ? ' ' + unit : ''}`;
          tr.append(td);
        }
        body.append(tr);
      });
      const foot = document.createElement('tr'),
        th = document.createElement('th');
      th.scope = 'row';
      th.textContent = this.c.model;
      foot.append(th);
      for (const p of items) {
        const td = document.createElement('td'),
          a = document.createElement('a');
        a.href = this.productURL(p);
        a.dataset.productId = p.id;
        a.textContent = p.title + ' ↗';
        td.append(a);
        foot.append(td);
      }
      table.querySelector('tfoot').replaceChildren(foot);
      dialog.showModal();
      dialog.querySelector('button').focus();
    }
    markVisited() {
      this.querySelectorAll('.oc-card').forEach((card) => {
        card.querySelector('.oc-visited').hidden = !this.visited.has(card.dataset.id);
      });
    }
    openFilters() {
      const panel = this.querySelector('.oc-sidebar');
      this.drawerOpen = true;
      this.dataset.drawerOpen = '';
      panel.dataset.open = '';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'true');
      this.querySelector('[data-shade]').hidden = false;
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.inerted = [];
      for (const node of document.body.children) {
        if (!node.contains(this) && !node.inert) {
          node.inert = true;
          this.inerted.push(node);
        }
      }
      this.querySelector('[data-close-filters]').focus();
    }
    closeFilters(focus = true) {
      if (!this.drawerOpen) return;
      this.drawerOpen = false;
      delete this.dataset.drawerOpen;
      const panel = this.querySelector('.oc-sidebar');
      delete panel.dataset.open;
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'false');
      this.querySelector('[data-shade]').hidden = true;
      document.body.style.overflow = this.oldOverflow || '';
      this.inerted?.forEach((e) => (e.inert = false));
      if (focus) this.querySelector('[data-open-filters]').focus();
    }
    keydown(e) {
      if (!this.drawerOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeFilters();
      }
      if (e.key === 'Tab') {
        const nodes = [
          ...this.querySelector('.oc-sidebar').querySelectorAll(
            'button:not([disabled]),input:not([disabled]),a[href],select',
          ),
        ].filter((el) => el.getClientRects().length);
        const first = nodes[0],
          last = nodes.at(-1);
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    click(e) {
      const target = e.target.closest('button,a');
      if (!target) return;
      if (target.dataset.productId) {
        const destination = new URL(target.href, location.href);
        destination.searchParams.set(
          'oc_return',
          this.current.pathname + this.current.search + '#oc-card-' + target.dataset.productId,
        );
        target.href = destination.href;
        this.save('oc-card-' + target.dataset.productId);
        this.visited.add(target.dataset.productId);
        try {
          localStorage.setItem('ortlux-visited', JSON.stringify([...this.visited]));
        } catch {}
        this.markVisited();
        return;
      }
      if (target.matches('[data-open-filters]')) this.openFilters();
      else if (target.matches('[data-close-filters]')) this.closeFilters();
      else if (target.matches('[data-retry]')) this.ready = this.load();
      else if (target.matches('[data-page]')) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        this.navigate(new URL(target.href));
        const h = this.querySelector('.oc-result-heading');
        h.tabIndex = -1;
        h.focus({ preventScroll: true });
        h.scrollIntoView({ block: 'start', behavior: 'instant' });
      } else if (target.matches('[data-clear]')) {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()])
          if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.removeFilter) {
        const url = new URL(location.href),
          key = target.dataset.removeFilter,
          values = url.searchParams.getAll(key).filter((x) => x !== target.dataset.value);
        url.searchParams.delete(key);
        values.forEach((v) => url.searchParams.append(key, v));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.relax) {
        const url = new URL(location.href);
        JSON.parse(target.dataset.relax).forEach((k) => url.searchParams.delete(k));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.matches('[data-compare]')) this.compare();
      else if (target.matches('[data-close-compare]')) this.querySelector('[data-comparison]').close();
      else if (target.dataset.removeCompare) {
        this.selected.delete(target.dataset.removeCompare);
        this.updateTray();
        this.say(`${this.selected.size} / 4 ${this.c.selected}`);
        const fallback = this.selected.size
          ? this.querySelector('[data-compare]')
          : this.querySelector('[data-clear]');
        fallback.focus();
      } else if (target.matches('[data-clear-compare]')) {
        this.selected.clear();
        this.updateTray();
        this.say('0 / 4 ' + this.c.selected);
        this.querySelector('[data-clear]').focus();
      }
    }
  }
  if (!customElements.get('ortlux-responsive-collection')) customElements.define('ortlux-responsive-collection', OrtluxResponsiveCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-collection-v5"] && !Shopify.designMode) return;
  try {
    
  /* The numeric catalogue is loaded in market context; no external runtime. */
  class OrtluxResponsiveCollection extends HTMLElement {
    static dimensions = {
      scene: 'filter.p.m.ortlux.use_cases',
      brand: 'filter.p.m.ortlux.brand',
      load: 'filter.p.m.ortlux.load_bands',
      range: 'filter.p.m.ortlux.range_bands',
      weight: 'filter.p.m.ortlux.weight_bands',
      road: 'filter.p.m.ortlux.road_legal_markets',
    };
    static positive(v) {
      return typeof v === 'number' && Number.isFinite(v) && v > 0;
    }
    static labels(items) {
      const result = new Map();
      if (items.length < 2 || items.length > 12) return result;
      const metrics = [
        ['lightest', (p) => p.weight, 1],
        ['longest', (p) => p.range, -1],
        [
          'value',
          (p) =>
            OrtluxResponsiveCollection.positive(p.range) && OrtluxResponsiveCollection.positive(p.price)
              ? p.price / p.range
              : null,
          1,
        ],
        ['cheapest', (p) => p.price, 1],
      ];
      for (const [label, get, dir] of metrics) {
        const list = items
          .map((p) => ({ p, v: get(p) }))
          .filter((x) => OrtluxResponsiveCollection.positive(x.v))
          .sort((a, b) => dir * (a.v - b.v));
        if (list.length < 2) continue;
        const best = list[0],
          second = list[1];
        const gap = dir === 1 ? (second.v - best.v) / second.v : (best.v - second.v) / second.v;
        if (gap + Number.EPSILON >= 0.1 && !result.has(best.p.id)) result.set(best.p.id, label);
      }
      return result;
    }
    static matches(p, params, skip) {
      for (const [key, name] of Object.entries(this.dimensions)) {
        if (key === skip) continue;
        const selected = params.getAll(name).flatMap((x) => x.split(','));
        if (!selected.length) continue;
        const hit = selected.some((v) =>
          key === 'scene'
            ? (p.scenes || []).includes(v)
            : key === 'brand'
              ? String(p.brandId) === v
              : key === 'road'
                ? (p.road || []).includes(v)
                : key === 'load'
                  ? this.positive(p.load) && p.load >= Number(v)
                  : key === 'range'
                    ? this.positive(p.range) && p.range >= Number(v)
                    : key === 'weight'
                      ? this.positive(p.weight) && (v === 'gt25' ? p.weight > 25 : p.weight <= Number(v))
                      : true,
        );
        if (!hit) return false;
      }
      if (skip !== 'price') {
        const min = params.get('filter.v.price.gte'),
          max = params.get('filter.v.price.lte');
        const prices = Array.isArray(p.prices) && p.prices.length ? p.prices : [p.price];
        if (
          !prices.some(
            (price) =>
              (min === null || min === '' || price >= Number(min) * 100) &&
              (max === null || max === '' || price <= Number(max) * 100),
          )
        )
          return false;
      }
      return true;
    }
    connectedCallback() {
      if (!this.querySelector('[data-grid]')) return;
      if (this.initialized) return;
      this.initialized = true;
      this.c = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.pageSize = 12;
      this.selected = new Map();
      this.all = null;
      this.current = new URL(location.href);
      this.visited = new Set();
      this.abort = new AbortController();
      this.money = new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency',
        currency: this.dataset.currency,
      });
      this.number = new Intl.NumberFormat(this.dataset.locale, {
        maximumFractionDigits: 1,
      });
      try {
        this.visited = new Set(JSON.parse(localStorage.getItem('ortlux-visited') || '[]'));
      } catch {}
      this.dataset.enhanced = '';
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      this.addEventListener('click', (e) => this.click(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('change', (e) => this.change(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('keydown', (e) => this.keydown(e), {
        signal: this.abort.signal,
      });
      this.querySelector('form').addEventListener(
        'submit',
        (e) => {
          e.preventDefault();
          this.filterChange();
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'popstate',
        () => {
          this.current = new URL(location.href);
          this.ready.then(() => {
            this.syncInputs();
            this.render(false);
            this.restore();
          });
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'pageshow',
        (e) => {
          if (e.persisted) {
            this.markVisited();
            this.restore();
          }
        },
        { signal: this.abort.signal },
      );
      window.addEventListener('pagehide', () => this.save(), {
        signal: this.abort.signal,
      });
      window.addEventListener(
        'resize',
        () => {
          if (innerWidth > 750 && this.drawerOpen) this.closeFilters();
        },
        { signal: this.abort.signal },
      );
      this.querySelector('[data-comparison]').addEventListener(
        'close',
        () => this.querySelector('[data-compare]').focus(),
        { signal: this.abort.signal },
      );
      document.addEventListener(
        'focusin',
        (e) => {
          if (this.drawerOpen || this.querySelector('[data-comparison]').open) return;
          const tray = this.querySelector('[data-tray]');
          if (tray.hidden || tray.contains(e.target)) return;
          const rect = e.target.getBoundingClientRect(),
            top = tray.getBoundingClientRect().top;
          if (rect.bottom > top - 8) window.scrollBy({ top: rect.bottom - top + 16, behavior: 'instant' });
        },
        { signal: this.abort.signal },
      );
      this.markVisited();
      this.syncInputs();
      this.ready = this.load();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.closeFilters(false);
    }
    say(text) {
      this.querySelector('[data-live]').textContent = text;
    }
    async load() {
      this.setAttribute('aria-busy', 'true');
      this.say(this.c.loading);
      try {
        let products = [],
          page = 1,
          pages = 1;
        do {
          let url;
          if (this.dataset.preview) {
            url = new URL(this.dataset.preview, location.href);
            url.searchParams.set('page', page);
          } else {
            url = new URL(this.dataset.url, location.origin);
            url.searchParams.set('section_id', 'ortlux-collection-data-v2');
            url.searchParams.set('page', page);
          }
          const response = await fetch(url, {
            signal: this.abort.signal,
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Catalogue response ' + response.status);
          let data;
          if (this.dataset.preview) data = await response.json();
          else {
            const t = document.createElement('template');
            t.innerHTML = await response.text();
            const node = t.content.querySelector('[data-catalog-data]');
            if (!node) throw new Error('Missing data section');
            data = JSON.parse(node.textContent);
          }
          if (
            !Array.isArray(data.products) ||
            !Number.isInteger(data.pages) ||
            data.pages < 1 ||
            data.pages > 100
          )
            throw new Error('Invalid catalogue response');
          products.push(...data.products);
          pages = data.pages;
          page++;
        } while (page <= pages);
        this.all = [...new Map(products.map((p) => [String(p.id), { ...p, id: String(p.id) }])).values()];
        this.setupMissingFilters();
        this.setupPrices();
        this.syncInputs();
        this.render(false);
        this.restore();
        this.querySelector('[data-retry]').hidden = true;
      } catch (e) {
        if (e.name !== 'AbortError') {
          this.say(this.c.error);
          this.querySelector('[data-retry]').hidden = false;
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
    setupMissingFilters() {
      const form = this.querySelector('.oc-filter-form');
      const options = {
        scene: ['commuting', 'cargo', 'offroad', 'folding'],
        brand: [
          ...new Set(
            this.all.map((p) => String(p.brandId)).filter((id) => id !== 'null' && id !== 'undefined'),
          ),
        ],
        load: ['120', '150'],
        range: ['40', '60', '80'],
        weight: ['20', '25', 'gt25'],
        road: [this.dataset.market],
      };
      for (const [dimension, values] of Object.entries(options)) {
        if (form.querySelector(`[data-dimension="${dimension}"]`)) continue;
        if (
          (dimension === 'scene' && this.dataset.kind === 'scene') ||
          (dimension === 'brand' && this.dataset.kind === 'brand') ||
          (dimension === 'road' && this.dataset.vehicle !== 'escooter')
        )
          continue;
        const meaningful = values.filter((value) =>
          this.all.some((p) =>
            OrtluxResponsiveCollection.matches(
              p,
              new URLSearchParams([[OrtluxResponsiveCollection.dimensions[dimension], value]]),
            ),
          ),
        );
        if (!meaningful.length) continue;
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = dimension;
        const legend = document.createElement('legend');
        legend.textContent = this.c[dimension];
        fieldset.append(legend);
        for (const value of meaningful) {
          const label = document.createElement('label');
          label.className = 'oc-check';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.name = OrtluxResponsiveCollection.dimensions[dimension];
          input.value = value;
          const text = document.createElement('span');
          text.textContent =
            dimension === 'brand'
              ? this.all.find((p) => String(p.brandId) === value).brand
              : dimension === 'scene'
                ? this.c[value]
                : dimension === 'road'
                  ? this.c.approved
                  : dimension === 'weight'
                    ? `${value === 'gt25' ? '>' : '≤'} ${value === 'gt25' ? '25' : value} kg`
                    : `≥ ${value} ${dimension === 'range' ? 'km' : 'kg'}`;
          const count = document.createElement('small');
          count.dataset.optionCount = '';
          label.append(input, text, count);
          fieldset.append(label);
        }
        form.append(fieldset);
      }
      if (!form.querySelector('[data-dimension="price"]') && this.all.length) {
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = 'price';
        const legend = document.createElement('legend');
        legend.textContent = this.c.price;
        const bands = document.createElement('div');
        bands.dataset.priceBands = '';
        const inputs = document.createElement('div');
        inputs.className = 'oc-price-inputs';
        for (const [suffix, title] of [
          ['gte', this.c.from],
          ['lte', this.c.up_to],
        ]) {
          const label = document.createElement('label');
          label.textContent = title;
          const input = document.createElement('input');
          input.name = `filter.v.price.${suffix}`;
          input.type = 'number';
          input.min = '0';
          input.step = '0.01';
          input.inputMode = 'decimal';
          label.append(input);
          inputs.append(label);
        }
        fieldset.append(legend, bands, inputs);
        form.prepend(fieldset);
      }
    }
    setupPrices() {
      const raw = JSON.parse(this.querySelector('[data-price-config]').textContent || 'null');
      this.bands = raw?.[this.dataset.currency] || [];
      const wrap = this.querySelector('[data-price-bands]');
      if (!wrap) return;
      wrap.replaceChildren();
      wrap.setAttribute('aria-busy', 'false');
      for (const [index, band] of this.bands.entries()) {
        if (!Array.isArray(band) || band.length !== 2) continue;
        const label = document.createElement('label');
        label.className = 'oc-check';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'oc_price';
        input.value = index;
        const text = document.createElement('span');
        text.textContent = this.bandText(band);
        const count = document.createElement('small');
        count.dataset.optionCount = '';
        label.append(input, text, count);
        wrap.append(label);
      }
    }
    bandText([min, max]) {
      return min === null
        ? `${this.c.up_to} ${this.money.format(max)}`
        : max === null
          ? `${this.c.from} ${this.money.format(min)}`
          : `${this.money.format(min)}–${this.money.format(max)}`;
    }
    syncInputs() {
      const p = this.current.searchParams;
      this.querySelectorAll('.oc-filter-form input').forEach((input) => {
        if (input.name === 'oc_price') {
          const band = this.bands?.[input.value];
          input.checked =
            !!band &&
            String(band[0] ?? '') === (p.get('filter.v.price.gte') || '') &&
            String(band[1] ?? '') === (p.get('filter.v.price.lte') || '');
        } else if (input.type === 'checkbox')
          input.checked = p
            .getAll(input.name)
            .flatMap((x) => x.split(','))
            .includes(input.value);
        else input.value = p.get(input.name) || '';
      });
      this.querySelector('[data-sort]').value = p.get('oc_sort') || p.get('sort_by') || 'manual';
    }
    async filterChange() {
      if (!this.all) {
        await this.ready;
        if (!this.all) return;
      }
      const next = new URL(location.href);
      for (const k of [...next.searchParams.keys()])
        if (k.startsWith('filter.') || k === 'page') next.searchParams.delete(k);
      for (const [k, v] of new FormData(this.querySelector('form')))
        if (v && k !== 'oc_price') next.searchParams.append(k, v);
      this.navigate(next);
    }
    change(e) {
      if (e.target.matches('[data-sort]')) {
        const next = new URL(location.href);
        next.searchParams.delete('page');
        next.searchParams.delete('sort_by');
        next.searchParams.delete('oc_sort');
        const v = e.target.value;
        if (v === 'range-descending' || v === 'weight-ascending') next.searchParams.set('oc_sort', v);
        else if (v !== 'manual') next.searchParams.set('sort_by', v);
        this.ready.then(() => {
          if (this.all) this.navigate(next);
        });
      } else if (e.target.matches('[data-compare-id]')) this.select(e.target);
      else if (e.target.closest('.oc-filter-form')) {
        if (e.target.name === 'oc_price') {
          const [min, max] = this.bands[e.target.value];
          this.querySelector('[name="filter.v.price.gte"]').value = min ?? '';
          this.querySelector('[name="filter.v.price.lte"]').value = max ?? '';
        }
        this.filterChange();
      }
    }
    navigate(url) {
      this.save();
      history.pushState({ oc: { url: url.href, scroll: 0 } }, '', url);
      this.current = url;
      this.syncInputs();
      this.render();
    }
    save(anchor) {
      const state = {
        ...history.state,
        oc: { url: location.href, scroll: scrollY, anchor: anchor || null },
      };
      history.replaceState(state, '');
    }
    restore() {
      const s = history.state?.oc;
      if (!s || s.url !== location.href) {
        if (location.hash.startsWith('#oc-card-'))
          requestAnimationFrame(() =>
            requestAnimationFrame(() =>
              document
                .getElementById(location.hash.slice(1))
                ?.scrollIntoView({ block: 'center', behavior: 'instant' }),
            ),
          );
        return;
      }
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          window.scrollTo({ top: s.scroll || 0, behavior: 'instant' });
        }),
      );
    }
    sort(items) {
      const sort =
        this.current.searchParams.get('oc_sort') || this.current.searchParams.get('sort_by') || 'manual';
      return [...items].sort((a, b) => {
        if (sort === 'price-ascending') return a.price - b.price;
        if (sort === 'price-descending') return b.price - a.price;
        if (sort === 'range-descending') return (b.range ?? -Infinity) - (a.range ?? -Infinity);
        if (sort === 'weight-ascending') return (a.weight ?? Infinity) - (b.weight ?? Infinity);
        return a.rank - b.rank;
      });
    }
    render(announce = true) {
      if (!this.all) return;
      if (announce || this.current.searchParams.has('oc_sort'))
        document.querySelector('[data-oc-itemlist]')?.remove();
      const params = this.current.searchParams;
      const filteredUrl = [...params.keys()].some(
        (key) => key.startsWith('filter.') || key === 'oc_sort' || key === 'sort_by',
      );
      let robots = document.getElementById('ortlux-filter-robots');
      if (filteredUrl) {
        if (!robots) {
          robots = document.createElement('meta');
          robots.id = 'ortlux-filter-robots';
          robots.name = 'robots';
          document.head.append(robots);
        }
        robots.content = 'noindex,follow';
      } else robots?.remove();
      this.results = this.sort(
        this.all
          .filter((p) => OrtluxResponsiveCollection.matches(p, params))
          .map((p) => {
            const min = params.get('filter.v.price.gte'),
              max = params.get('filter.v.price.lte');
            const prices = (p.prices?.length ? p.prices : [p.price]).filter(
              (v) => (!min || v >= Number(min) * 100) && (!max || v <= Number(max) * 100),
            );
            return { ...p, price: Math.min(...prices) };
          }),
      );
      const sortControl = this.querySelector('[data-sort]');
      for (const [value, metric] of [['weight-ascending', 'weight'], ['range-descending', 'range']]) {
        const option = sortControl.querySelector(`option[value="${value}"]`);
        const available = this.results.some((p) => OrtluxResponsiveCollection.positive(p[metric]));
        option.hidden = !available;
        option.disabled = !available;
        if (!available && (params.get('oc_sort') === value || params.get('sort_by') === value)) {
          params.delete('oc_sort');
          params.delete('sort_by');
          this.results.sort((a, b) => a.rank - b.rank);
          history.replaceState(history.state, '', this.current);
        }
      }
      sortControl.value = params.get('oc_sort') || params.get('sort_by') || 'manual';
      this.visibleColumns = Math.max(1, getComputedStyle(this.querySelector('[data-grid]')).gridTemplateColumns.split(' ').length);
      const count = this.results.length,
        pages = Math.max(1, Math.ceil(count / this.pageSize));
      this.page = Math.min(pages, Math.max(1, parseInt(params.get('page') || '1', 10) || 1));
      const labels = OrtluxResponsiveCollection.labels(this.results),
        visible = this.results.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
      this.querySelector('[data-grid]').replaceChildren(
        ...visible.map((p, i) => this.card(p, labels.get(p.id), i)),
      );
      this.querySelectorAll('[data-count],[data-result-count]').forEach(
        (e) => (e.textContent = this.number.format(count)),
      );
      this.updateCounts();
      this.active();
      this.pagination(pages);
      this.empty();
      this.updateTray();
      this.markVisited();
      this.say(`${this.number.format(count)} ${this.c.results}`);
      if (announce) this.querySelector('[data-grid-wrap]').setAttribute('data-updated', '');
    }
    card(p, label, index = 9) {
      const node = this.querySelector('[data-card-template]').content.firstElementChild.cloneNode(true);
      node.dataset.id = p.id;
      node.id = 'oc-card-' + p.id;
      const link = node.querySelector('a');
      link.href = this.productURL(p);
      link.dataset.productId = p.id;
      const img = node.querySelector('img');
      if (p.image) {
        if (p.srcset) img.srcset = p.srcset;
        img.sizes = '(max-width: 640px) 100vw, (max-width: 1100px) 50vw, 33vw';
        img.src = p.image;
        img.alt = p.imageAlt || p.modelLabel;
        img.width = p.imageWidth || 600;
        img.height = p.imageHeight || 400;
        img.loading = index < this.visibleColumns ? 'eager' : 'lazy';
        img.decoding = 'async';
        img.fetchPriority = index === 0 ? 'high' : 'auto';
      } else {
        img.remove();
        node.querySelector('.oc-card-image').append(document.createTextNode(this.c.no_image));
      }
      node.querySelector('.oc-card-brand').textContent = p.brand;
      node.querySelector('h3').textContent = p.title;
      node.querySelector('[data-price]').textContent =
        (p.varies ? this.c.from + ' ' : '') + this.money.format(p.price / 100);
      const old = node.querySelector('s');
      if (p.comparePrice > p.price) old.textContent = this.money.format(p.comparePrice / 100);
      else old.remove();
      node.querySelector('[data-range]').textContent =
        p.range === null || p.range === undefined ? '—' : this.number.format(p.range) + ' km';
      node.querySelector('[data-weight]').textContent =
        p.weight === null || p.weight === undefined ? '—' : this.number.format(p.weight) + ' kg';
      node.querySelector('[data-badge]').textContent = label ? this.c[label] : '';
      const input = node.querySelector('[data-compare-id]');
      input.dataset.compareId = p.id;
      input.setAttribute('aria-label', this.c.compare + ' ' + p.brand + ' ' + p.title);
      input.checked = this.selected.has(p.id);
      input.disabled = this.selected.size >= 4 && !input.checked;
      return node;
    }
    productURL(p) {
      const url = new URL(p.url, location.href);
      url.searchParams.set('oc_return', this.current.pathname + this.current.search + '#oc-card-' + p.id);
      return url.href;
    }
    updateCounts() {
      for (const input of this.querySelectorAll('.oc-filter-form input[type=checkbox]')) {
        const key = input.closest('fieldset').dataset.dimension;
        const params = new URLSearchParams(this.current.search);
        params.delete(input.name);
        params.append(input.name, input.value);
        const count = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)).length;
        input.disabled = !count && !input.checked;
        input.closest('label').querySelector('[data-option-count]').textContent = count;
      }
      const pool = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, this.current.searchParams, 'price'));
      this.querySelectorAll('[name=oc_price]').forEach((input) => {
        const [min, max] = this.bands[input.value];
        const count = pool.filter((p) =>
          (p.prices?.length ? p.prices : [p.price]).some(
            (price) => (min === null || price >= min * 100) && (max === null || price <= max * 100),
          ),
        ).length;
        input.closest('label').querySelector('small').textContent = count;
        input.disabled = !count && !input.checked;
      });
    }
    active() {
      const wrap = this.querySelector('[data-active]');
      wrap.replaceChildren();
      for (const [key, val] of this.current.searchParams) {
        if (!key.startsWith('filter.')) continue;
        const input = [...this.querySelectorAll('.oc-filter-form input')].find(
          (e) => e.name === key && e.value === val,
        );
        const label = input?.closest('label')?.querySelector('span')?.textContent || val;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.removeFilter = key;
        button.dataset.value = val;
        button.textContent = (key.includes('price.') ? this.c.price + ' ' + val : label) + ' ×';
        button.setAttribute('aria-label', this.c.remove + ' ' + button.textContent);
        wrap.append(button);
      }
      if (!wrap.children.length) wrap.textContent = this.c.no_filters;
    }
    pagination(pages) {
      const nav = this.querySelector('[data-pagination]');
      nav.replaceChildren();
      for (const [name, page] of [
        ['prev', this.page - 1],
        ['next', this.page + 1],
      ]) {
        if (page < 1 || page > pages) continue;
        const a = document.createElement('a');
        const url = new URL(this.current);
        url.searchParams.set('page', page);
        a.href = url.href;
        a.rel =
          name +
          ([...this.current.searchParams.keys()].some(
            (k) => k.startsWith('filter.') || k === 'sort_by' || k === 'oc_sort',
          )
            ? ' nofollow'
            : '');
        a.dataset.page = page;
        a.textContent = this.c[name];
        nav.append(a);
      }
      const span = document.createElement('span');
      span.textContent = `${this.c.page} ${this.page} ${this.c.of} ${pages}`;
      nav.insertBefore(span, nav.querySelector('[rel~="next"]'));
    }
    empty() {
      const box = this.querySelector('[data-empty]');
      box.hidden = this.results.length > 0;
      this.querySelector('[data-grid]').hidden = !box.hidden;
      if (box.hidden) return;
      const keys = [...new Set([...this.current.searchParams.keys()].filter((k) => k.startsWith('filter.')))];
      const actions = box.querySelector('[data-relax-actions]');
      actions.replaceChildren();
      let near = [],
        chosen = [];
      const candidates = keys
        .map((key) => {
          const params = new URLSearchParams(this.current.search);
          params.delete(key);
          return {
            key,
            params,
            list: this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)),
          };
        })
        .sort((a, b) => b.list.length - a.list.length);
      if (candidates.length) {
        let params = new URLSearchParams(this.current.search);
        for (const item of candidates) {
          params.delete(item.key);
          chosen.push(item.key);
          near = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params));
          if (near.length >= 4) break;
        }
      }
      const names = chosen.map((k) => {
        const dim = Object.entries(OrtluxResponsiveCollection.dimensions).find(([, v]) => v === k)?.[0] || 'price';
        return this.c[dim];
      });
      box.querySelector('[data-empty-reason]').textContent = names.join(' + ') + ' — ' + this.c.relaxed;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.relax = JSON.stringify(chosen);
      button.textContent = this.c.relax + ': ' + names.join(' + ');
      actions.append(button);
      box.querySelector('[data-near]').replaceChildren(...near.slice(0, 4).map((p) => this.card(p)));
    }
    select(input) {
      const p =
        this.results?.find((p) => p.id === input.dataset.compareId) ||
        this.all?.find((p) => p.id === input.dataset.compareId);
      if (!p) {
        input.checked = false;
        this.say(this.c.loading);
        return;
      }
      if (input.checked && this.selected.size < 4) this.selected.set(p.id, p);
      else this.selected.delete(p.id);
      this.updateTray();
      this.say(`${this.selected.size} / 4 ${this.c.selected}`);
    }
    updateTray() {
      const tray = this.querySelector('[data-tray]');
      tray.hidden = !this.selected.size;
      tray.querySelector('[data-selected-count]').textContent = this.selected.size + ' / 4';
      tray.querySelector('[data-limit]').textContent = this.selected.size === 4 ? this.c.limit : '';
      const list = tray.querySelector('[data-selected-list]');
      list.replaceChildren();
      for (const p of this.selected.values()) {
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.removeCompare = p.id;
        b.textContent = p.title + ' ×';
        b.setAttribute('aria-label', this.c.remove + ' ' + p.title);
        list.append(b);
      }
      this.querySelectorAll('[data-compare-id]').forEach((input) => {
        input.checked = this.selected.has(input.dataset.compareId);
        input.disabled = this.selected.size === 4 && !input.checked;
        input.title = input.disabled ? this.c.limit : '';
      });
    }
    compare() {
      const dialog = this.querySelector('[data-comparison]'),
        table = dialog.querySelector('table'),
        items = [...this.selected.values()];
      if (!items.length) return;
      const head = document.createElement('tr'),
        corner = document.createElement('th');
      corner.scope = 'col';
      corner.textContent = this.c.model;
      head.append(corner);
      for (const p of items) {
        const th = document.createElement('th');
        th.scope = 'col';
        const link = document.createElement('a');
        link.className = 'oc-compare-model';
        link.href = this.productURL(p);
        link.dataset.productId = p.id;
        if (p.image) {
          const image = document.createElement('img');
          const src = new URL(p.image, location.origin);
          src.searchParams.set('width', '480');
          image.src = src.href;
          image.width = 240;
          image.height = 240;
          image.alt = '';
          image.decoding = 'async';
          image.className = 'oc-compare-image';
          link.append(image);
        }
        const name = document.createElement('span');
        name.textContent = p.title;
        link.append(name);
        th.append(link);
        head.append(th);
      }
      table.querySelector('thead').replaceChildren(head);
      const rows = [
        ['vehicle', 'vehicle', ''],
        ['load', 'load', 'kg'],
        ['weight', 'weight', 'kg'],
        ['range', 'range', 'km'],
        ['price', 'price', ''],
        ['motor', 'motor', 'W'],
        ['battery', 'battery', 'Wh'],
        ['speed', 'speed', 'km/h'],
        ['ip', 'ip', ''],
        ['heightMin', 'height_min', 'cm'],
        ['heightMax', 'height_max', 'cm'],
        ['rangeMax', 'range', 'km'],
        ['motorModel', 'motor_model', ''],
        ['frameMaterial', 'frame_material', ''],
        ['brakes', 'brakes', ''],
        ['tyres', 'tyres', ''],
        ['dimensions', 'dimensions', ''],
        ['gradeability', 'gradeability', '%'],
        ['testedMin', 'tested_min', 'km'],
        ['testedMax', 'tested_max', 'km'],
        ['testConditions', 'test_conditions', ''],
      ];
      const body = table.querySelector('tbody');
      body.replaceChildren();
      rows.forEach(([key, label, unit], index) => {
        if (key === 'vehicle') return;
        if (index > 4 && !items.some((p) => p[key] !== null && p[key] !== undefined && p[key] !== '')) return;
        const tr = document.createElement('tr'),
          th = document.createElement('th');
        th.scope = 'row';
        th.textContent = this.c[label] + (key === 'rangeMax' ? ' (max)' : '');
        tr.append(th);
        for (const p of items) {
          const td = document.createElement('td');
          td.textContent =
            p[key] === null || p[key] === undefined || p[key] === ''
              ? '—'
              : key === 'price'
                ? this.money.format(p.price / 100)
                : `${typeof p[key] === 'number' ? this.number.format(p[key]) : p[key]}${unit ? ' ' + unit : ''}`;
          tr.append(td);
        }
        body.append(tr);
      });
      const foot = document.createElement('tr'),
        th = document.createElement('th');
      th.scope = 'row';
      th.textContent = this.c.model;
      foot.append(th);
      for (const p of items) {
        const td = document.createElement('td'),
          a = document.createElement('a');
        a.href = this.productURL(p);
        a.dataset.productId = p.id;
        a.textContent = p.title + ' ↗';
        td.append(a);
        foot.append(td);
      }
      table.querySelector('tfoot').replaceChildren(foot);
      dialog.showModal();
      dialog.querySelector('button').focus();
    }
    markVisited() {
      this.querySelectorAll('.oc-card').forEach((card) => {
        card.querySelector('.oc-visited').hidden = !this.visited.has(card.dataset.id);
      });
    }
    openFilters() {
      const panel = this.querySelector('.oc-sidebar');
      this.drawerOpen = true;
      this.dataset.drawerOpen = '';
      panel.dataset.open = '';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'true');
      this.querySelector('[data-shade]').hidden = false;
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.inerted = [];
      for (const node of document.body.children) {
        if (!node.contains(this) && !node.inert) {
          node.inert = true;
          this.inerted.push(node);
        }
      }
      this.querySelector('[data-close-filters]').focus();
    }
    closeFilters(focus = true) {
      if (!this.drawerOpen) return;
      this.drawerOpen = false;
      delete this.dataset.drawerOpen;
      const panel = this.querySelector('.oc-sidebar');
      delete panel.dataset.open;
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'false');
      this.querySelector('[data-shade]').hidden = true;
      document.body.style.overflow = this.oldOverflow || '';
      this.inerted?.forEach((e) => (e.inert = false));
      if (focus) this.querySelector('[data-open-filters]').focus();
    }
    keydown(e) {
      if (!this.drawerOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeFilters();
      }
      if (e.key === 'Tab') {
        const nodes = [
          ...this.querySelector('.oc-sidebar').querySelectorAll(
            'button:not([disabled]),input:not([disabled]),a[href],select',
          ),
        ].filter((el) => el.getClientRects().length);
        const first = nodes[0],
          last = nodes.at(-1);
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    click(e) {
      const target = e.target.closest('button,a');
      if (!target) return;
      if (target.dataset.productId) {
        const destination = new URL(target.href, location.href);
        destination.searchParams.set(
          'oc_return',
          this.current.pathname + this.current.search + '#oc-card-' + target.dataset.productId,
        );
        target.href = destination.href;
        this.save('oc-card-' + target.dataset.productId);
        this.visited.add(target.dataset.productId);
        try {
          localStorage.setItem('ortlux-visited', JSON.stringify([...this.visited]));
        } catch {}
        this.markVisited();
        return;
      }
      if (target.matches('[data-open-filters]')) this.openFilters();
      else if (target.matches('[data-close-filters]')) this.closeFilters();
      else if (target.matches('[data-retry]')) this.ready = this.load();
      else if (target.matches('[data-page]')) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        this.navigate(new URL(target.href));
        const h = this.querySelector('.oc-result-heading');
        h.tabIndex = -1;
        h.focus({ preventScroll: true });
        h.scrollIntoView({ block: 'start', behavior: 'instant' });
      } else if (target.matches('[data-clear]')) {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()])
          if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.removeFilter) {
        const url = new URL(location.href),
          key = target.dataset.removeFilter,
          values = url.searchParams.getAll(key).filter((x) => x !== target.dataset.value);
        url.searchParams.delete(key);
        values.forEach((v) => url.searchParams.append(key, v));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.relax) {
        const url = new URL(location.href);
        JSON.parse(target.dataset.relax).forEach((k) => url.searchParams.delete(k));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.matches('[data-compare]')) this.compare();
      else if (target.matches('[data-close-compare]')) this.querySelector('[data-comparison]').close();
      else if (target.dataset.removeCompare) {
        this.selected.delete(target.dataset.removeCompare);
        this.updateTray();
        this.say(`${this.selected.size} / 4 ${this.c.selected}`);
        const fallback = this.selected.size
          ? this.querySelector('[data-compare]')
          : this.querySelector('[data-clear]');
        fallback.focus();
      } else if (target.matches('[data-clear-compare]')) {
        this.selected.clear();
        this.updateTray();
        this.say('0 / 4 ' + this.c.selected);
        this.querySelector('[data-clear]').focus();
      }
    }
  }
  if (!customElements.get('ortlux-responsive-collection')) customElements.define('ortlux-responsive-collection', OrtluxResponsiveCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-collection-v6"] && !Shopify.designMode) return;
  try {
    
  /* The numeric catalogue is loaded in market context; no external runtime. */
  class OrtluxResponsiveCollection extends HTMLElement {
    static dimensions = {
      scene: 'filter.p.m.ortlux.use_cases',
      brand: 'filter.p.m.ortlux.brand',
      load: 'filter.p.m.ortlux.load_bands',
      range: 'filter.p.m.ortlux.range_bands',
      weight: 'filter.p.m.ortlux.weight_bands',
      road: 'filter.p.m.ortlux.road_legal_markets',
    };
    static positive(v) {
      return typeof v === 'number' && Number.isFinite(v) && v > 0;
    }
    static labels(items) {
      const result = new Map();
      if (items.length < 2 || items.length > 12) return result;
      const metrics = [
        ['lightest', (p) => p.weight, 1],
        ['longest', (p) => p.range, -1],
        [
          'value',
          (p) =>
            OrtluxResponsiveCollection.positive(p.range) && OrtluxResponsiveCollection.positive(p.price)
              ? p.price / p.range
              : null,
          1,
        ],
        ['cheapest', (p) => p.price, 1],
      ];
      for (const [label, get, dir] of metrics) {
        const list = items
          .map((p) => ({ p, v: get(p) }))
          .filter((x) => OrtluxResponsiveCollection.positive(x.v))
          .sort((a, b) => dir * (a.v - b.v));
        if (list.length < 2) continue;
        const best = list[0],
          second = list[1];
        const gap = dir === 1 ? (second.v - best.v) / second.v : (best.v - second.v) / second.v;
        if (gap + Number.EPSILON >= 0.1 && !result.has(best.p.id)) result.set(best.p.id, label);
      }
      return result;
    }
    static matches(p, params, skip) {
      for (const [key, name] of Object.entries(this.dimensions)) {
        if (key === skip) continue;
        const selected = params.getAll(name).flatMap((x) => x.split(','));
        if (!selected.length) continue;
        const hit = selected.some((v) =>
          key === 'scene'
            ? (p.scenes || []).includes(v)
            : key === 'brand'
              ? String(p.brandId) === v
              : key === 'road'
                ? (p.road || []).includes(v)
                : key === 'load'
                  ? this.positive(p.load) && p.load >= Number(v)
                  : key === 'range'
                    ? this.positive(p.range) && p.range >= Number(v)
                    : key === 'weight'
                      ? this.positive(p.weight) && (v === 'gt25' ? p.weight > 25 : p.weight <= Number(v))
                      : true,
        );
        if (!hit) return false;
      }
      if (skip !== 'price') {
        const min = params.get('filter.v.price.gte'),
          max = params.get('filter.v.price.lte');
        const prices = Array.isArray(p.prices) && p.prices.length ? p.prices : [p.price];
        if (
          !prices.some(
            (price) =>
              (min === null || min === '' || price >= Number(min) * 100) &&
              (max === null || max === '' || price <= Number(max) * 100),
          )
        )
          return false;
      }
      return true;
    }
    connectedCallback() {
      if (!this.querySelector('[data-grid]')) return;
      if (this.initialized) return;
      this.initialized = true;
      this.c = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.pageSize = 12;
      this.selected = new Map();
      this.all = null;
      this.current = new URL(location.href);
      this.visited = new Set();
      this.abort = new AbortController();
      this.money = new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency',
        currency: this.dataset.currency,
      });
      this.number = new Intl.NumberFormat(this.dataset.locale, {
        maximumFractionDigits: 1,
      });
      try {
        this.visited = new Set(JSON.parse(localStorage.getItem('ortlux-visited') || '[]'));
      } catch {}
      this.dataset.enhanced = '';
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      this.addEventListener('click', (e) => this.click(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('change', (e) => this.change(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('keydown', (e) => this.keydown(e), {
        signal: this.abort.signal,
      });
      this.querySelector('form').addEventListener(
        'submit',
        (e) => {
          e.preventDefault();
          this.filterChange();
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'popstate',
        () => {
          this.current = new URL(location.href);
          this.ready.then(() => {
            this.syncInputs();
            this.render(false);
            this.restore();
          });
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'pageshow',
        (e) => {
          if (e.persisted) {
            this.markVisited();
            this.restore();
          }
        },
        { signal: this.abort.signal },
      );
      window.addEventListener('pagehide', () => this.save(), {
        signal: this.abort.signal,
      });
      window.addEventListener(
        'resize',
        () => {
          if (innerWidth > 750 && this.drawerOpen) this.closeFilters();
        },
        { signal: this.abort.signal },
      );
      this.querySelector('[data-comparison]').addEventListener(
        'close',
        () => this.querySelector('[data-compare]').focus(),
        { signal: this.abort.signal },
      );
      document.addEventListener(
        'focusin',
        (e) => {
          if (this.drawerOpen || this.querySelector('[data-comparison]').open) return;
          const tray = this.querySelector('[data-tray]');
          if (tray.hidden || tray.contains(e.target)) return;
          const rect = e.target.getBoundingClientRect(),
            top = tray.getBoundingClientRect().top;
          if (rect.bottom > top - 8) window.scrollBy({ top: rect.bottom - top + 16, behavior: 'instant' });
        },
        { signal: this.abort.signal },
      );
      this.markVisited();
      this.syncInputs();
      this.ready = this.load();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.closeFilters(false);
    }
    say(text) {
      this.querySelector('[data-live]').textContent = text;
    }
    async load() {
      this.setAttribute('aria-busy', 'true');
      this.say(this.c.loading);
      try {
        let products = [],
          page = 1,
          pages = 1;
        do {
          let url;
          if (this.dataset.preview) {
            url = new URL(this.dataset.preview, location.href);
            url.searchParams.set('page', page);
          } else {
            url = new URL(this.dataset.url, location.origin);
            url.searchParams.set('section_id', 'ortlux-collection-data-v2');
            url.searchParams.set('page', page);
          }
          const response = await fetch(url, {
            signal: this.abort.signal,
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Catalogue response ' + response.status);
          let data;
          if (this.dataset.preview) data = await response.json();
          else {
            const t = document.createElement('template');
            t.innerHTML = await response.text();
            const node = t.content.querySelector('[data-catalog-data]');
            if (!node) throw new Error('Missing data section');
            data = JSON.parse(node.textContent);
          }
          if (
            !Array.isArray(data.products) ||
            !Number.isInteger(data.pages) ||
            data.pages < 1 ||
            data.pages > 100
          )
            throw new Error('Invalid catalogue response');
          products.push(...data.products);
          pages = data.pages;
          page++;
        } while (page <= pages);
        this.all = [...new Map(products.map((p) => [String(p.id), { ...p, id: String(p.id) }])).values()];
        this.setupMissingFilters();
        this.setupPrices();
        this.syncInputs();
        this.render(false);
        this.restore();
        this.querySelector('[data-retry]').hidden = true;
      } catch (e) {
        if (e.name !== 'AbortError') {
          this.say(this.c.error);
          this.querySelector('[data-retry]').hidden = false;
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
    setupMissingFilters() {
      const form = this.querySelector('.oc-filter-form');
      const options = {
        scene: ['commuting', 'cargo', 'offroad', 'folding'],
        brand: [
          ...new Set(
            this.all.map((p) => String(p.brandId)).filter((id) => id !== 'null' && id !== 'undefined'),
          ),
        ],
        load: ['120', '150'],
        range: ['40', '60', '80'],
        weight: ['20', '25', 'gt25'],
        road: [this.dataset.market],
      };
      for (const [dimension, values] of Object.entries(options)) {
        if (form.querySelector(`[data-dimension="${dimension}"]`)) continue;
        if (
          (dimension === 'scene' && this.dataset.kind === 'scene') ||
          (dimension === 'brand' && this.dataset.kind === 'brand') ||
          (dimension === 'road' && this.dataset.vehicle !== 'escooter')
        )
          continue;
        const meaningful = values.filter((value) =>
          this.all.some((p) =>
            OrtluxResponsiveCollection.matches(
              p,
              new URLSearchParams([[OrtluxResponsiveCollection.dimensions[dimension], value]]),
            ),
          ),
        );
        if (!meaningful.length) continue;
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = dimension;
        const legend = document.createElement('legend');
        legend.textContent = this.c[dimension];
        fieldset.append(legend);
        for (const value of meaningful) {
          const label = document.createElement('label');
          label.className = 'oc-check';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.name = OrtluxResponsiveCollection.dimensions[dimension];
          input.value = value;
          const text = document.createElement('span');
          text.textContent =
            dimension === 'brand'
              ? this.all.find((p) => String(p.brandId) === value).brand
              : dimension === 'scene'
                ? this.c[value]
                : dimension === 'road'
                  ? this.c.approved
                  : dimension === 'weight'
                    ? `${value === 'gt25' ? '>' : '≤'} ${value === 'gt25' ? '25' : value} kg`
                    : `≥ ${value} ${dimension === 'range' ? 'km' : 'kg'}`;
          const count = document.createElement('small');
          count.dataset.optionCount = '';
          label.append(input, text, count);
          fieldset.append(label);
        }
        form.append(fieldset);
      }
      if (!form.querySelector('[data-dimension="price"]') && this.all.length) {
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = 'price';
        const legend = document.createElement('legend');
        legend.textContent = this.c.price;
        const bands = document.createElement('div');
        bands.dataset.priceBands = '';
        const inputs = document.createElement('div');
        inputs.className = 'oc-price-inputs';
        for (const [suffix, title] of [
          ['gte', this.c.from],
          ['lte', this.c.up_to],
        ]) {
          const label = document.createElement('label');
          label.textContent = title;
          const input = document.createElement('input');
          input.name = `filter.v.price.${suffix}`;
          input.type = 'number';
          input.min = '0';
          input.step = '0.01';
          input.inputMode = 'decimal';
          label.append(input);
          inputs.append(label);
        }
        fieldset.append(legend, bands, inputs);
        form.prepend(fieldset);
      }
    }
    setupPrices() {
      const raw = JSON.parse(this.querySelector('[data-price-config]').textContent || 'null');
      this.bands = raw?.[this.dataset.currency] || [];
      const wrap = this.querySelector('[data-price-bands]');
      if (!wrap) return;
      wrap.replaceChildren();
      wrap.setAttribute('aria-busy', 'false');
      for (const [index, band] of this.bands.entries()) {
        if (!Array.isArray(band) || band.length !== 2) continue;
        const label = document.createElement('label');
        label.className = 'oc-check';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'oc_price';
        input.value = index;
        const text = document.createElement('span');
        text.textContent = this.bandText(band);
        const count = document.createElement('small');
        count.dataset.optionCount = '';
        label.append(input, text, count);
        wrap.append(label);
      }
    }
    bandText([min, max]) {
      return min === null
        ? `${this.c.up_to} ${this.money.format(max)}`
        : max === null
          ? `${this.c.from} ${this.money.format(min)}`
          : `${this.money.format(min)}–${this.money.format(max)}`;
    }
    syncInputs() {
      const p = this.current.searchParams;
      this.querySelectorAll('.oc-filter-form input').forEach((input) => {
        if (input.name === 'oc_price') {
          const band = this.bands?.[input.value];
          input.checked =
            !!band &&
            String(band[0] ?? '') === (p.get('filter.v.price.gte') || '') &&
            String(band[1] ?? '') === (p.get('filter.v.price.lte') || '');
        } else if (input.type === 'checkbox')
          input.checked = p
            .getAll(input.name)
            .flatMap((x) => x.split(','))
            .includes(input.value);
        else input.value = p.get(input.name) || '';
      });
      this.querySelector('[data-sort]').value = p.get('oc_sort') || p.get('sort_by') || 'manual';
    }
    async filterChange() {
      if (!this.all) {
        await this.ready;
        if (!this.all) return;
      }
      const next = new URL(location.href);
      for (const k of [...next.searchParams.keys()])
        if (k.startsWith('filter.') || k === 'page') next.searchParams.delete(k);
      for (const [k, v] of new FormData(this.querySelector('form')))
        if (v && k !== 'oc_price') next.searchParams.append(k, v);
      this.navigate(next);
    }
    change(e) {
      if (e.target.matches('[data-sort]')) {
        const next = new URL(location.href);
        next.searchParams.delete('page');
        next.searchParams.delete('sort_by');
        next.searchParams.delete('oc_sort');
        const v = e.target.value;
        if (v === 'range-descending' || v === 'weight-ascending') next.searchParams.set('oc_sort', v);
        else if (v !== 'manual') next.searchParams.set('sort_by', v);
        this.ready.then(() => {
          if (this.all) this.navigate(next);
        });
      } else if (e.target.matches('[data-compare-id]')) this.select(e.target);
      else if (e.target.closest('.oc-filter-form')) {
        if (e.target.name === 'oc_price') {
          const [min, max] = this.bands[e.target.value];
          this.querySelector('[name="filter.v.price.gte"]').value = min ?? '';
          this.querySelector('[name="filter.v.price.lte"]').value = max ?? '';
        }
        this.filterChange();
      }
    }
    navigate(url) {
      this.save();
      history.pushState({ oc: { url: url.href, scroll: 0 } }, '', url);
      this.current = url;
      this.syncInputs();
      this.render();
    }
    save(anchor) {
      const state = {
        ...history.state,
        oc: { url: location.href, scroll: scrollY, anchor: anchor || null },
      };
      history.replaceState(state, '');
    }
    restore() {
      const s = history.state?.oc;
      if (!s || s.url !== location.href) {
        if (location.hash.startsWith('#oc-card-'))
          requestAnimationFrame(() =>
            requestAnimationFrame(() =>
              document
                .getElementById(location.hash.slice(1))
                ?.scrollIntoView({ block: 'center', behavior: 'instant' }),
            ),
          );
        return;
      }
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          window.scrollTo({ top: s.scroll || 0, behavior: 'instant' });
        }),
      );
    }
    sort(items) {
      const sort =
        this.current.searchParams.get('oc_sort') || this.current.searchParams.get('sort_by') || 'manual';
      return [...items].sort((a, b) => {
        if (sort === 'price-ascending') return a.price - b.price;
        if (sort === 'price-descending') return b.price - a.price;
        if (sort === 'range-descending') return (b.range ?? -Infinity) - (a.range ?? -Infinity);
        if (sort === 'weight-ascending') return (a.weight ?? Infinity) - (b.weight ?? Infinity);
        return a.rank - b.rank;
      });
    }
    render(announce = true) {
      if (!this.all) return;
      if (announce || this.current.searchParams.has('oc_sort'))
        document.querySelector('[data-oc-itemlist]')?.remove();
      const params = this.current.searchParams;
      const filteredUrl = [...params.keys()].some(
        (key) => key.startsWith('filter.') || key === 'oc_sort' || key === 'sort_by',
      );
      let robots = document.getElementById('ortlux-filter-robots');
      if (filteredUrl) {
        if (!robots) {
          robots = document.createElement('meta');
          robots.id = 'ortlux-filter-robots';
          robots.name = 'robots';
          document.head.append(robots);
        }
        robots.content = 'noindex,follow';
      } else robots?.remove();
      this.results = this.sort(
        this.all
          .filter((p) => OrtluxResponsiveCollection.matches(p, params))
          .map((p) => {
            const min = params.get('filter.v.price.gte'),
              max = params.get('filter.v.price.lte');
            const prices = (p.prices?.length ? p.prices : [p.price]).filter(
              (v) => (!min || v >= Number(min) * 100) && (!max || v <= Number(max) * 100),
            );
            return { ...p, price: Math.min(...prices) };
          }),
      );
      const sortControl = this.querySelector('[data-sort]');
      for (const [value, metric] of [['weight-ascending', 'weight'], ['range-descending', 'range']]) {
        const option = sortControl.querySelector(`option[value="${value}"]`);
        const available = this.results.some((p) => OrtluxResponsiveCollection.positive(p[metric]));
        option.hidden = !available;
        option.disabled = !available;
        if (!available && (params.get('oc_sort') === value || params.get('sort_by') === value)) {
          params.delete('oc_sort');
          params.delete('sort_by');
          this.results.sort((a, b) => a.rank - b.rank);
          history.replaceState(history.state, '', this.current);
        }
      }
      sortControl.value = params.get('oc_sort') || params.get('sort_by') || 'manual';
      this.visibleColumns = Math.max(1, getComputedStyle(this.querySelector('[data-grid]')).gridTemplateColumns.split(' ').length);
      const count = this.results.length,
        pages = Math.max(1, Math.ceil(count / this.pageSize));
      this.page = Math.min(pages, Math.max(1, parseInt(params.get('page') || '1', 10) || 1));
      const labels = OrtluxResponsiveCollection.labels(this.results),
        visible = this.results.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
      this.querySelector('[data-grid]').replaceChildren(
        ...visible.map((p, i) => this.card(p, labels.get(p.id), i)),
      );
      this.querySelectorAll('[data-count],[data-result-count]').forEach(
        (e) => (e.textContent = this.number.format(count)),
      );
      this.updateCounts();
      this.active();
      this.pagination(pages);
      this.empty();
      this.updateTray();
      this.markVisited();
      this.say(`${this.number.format(count)} ${this.c.results}`);
      if (announce) this.querySelector('[data-grid-wrap]').setAttribute('data-updated', '');
    }
    card(p, label, index = 9) {
      const node = this.querySelector('[data-card-template]').content.firstElementChild.cloneNode(true);
      node.dataset.id = p.id;
      node.id = 'oc-card-' + p.id;
      const link = node.querySelector('a');
      link.href = this.productURL(p);
      link.dataset.productId = p.id;
      const img = node.querySelector('img');
      if (p.image) {
        if (p.srcset) img.srcset = p.srcset;
        img.sizes = '(max-width: 640px) 100vw, (max-width: 1100px) 50vw, 33vw';
        img.src = p.image;
        img.alt = p.imageAlt || p.modelLabel;
        img.width = p.imageWidth || 600;
        img.height = p.imageHeight || 400;
        img.loading = index < this.visibleColumns ? 'eager' : 'lazy';
        img.decoding = 'async';
        img.fetchPriority = index === 0 ? 'high' : 'auto';
      } else {
        img.remove();
        node.querySelector('.oc-card-image').append(document.createTextNode(this.c.no_image));
      }
      node.querySelector('.oc-card-brand').textContent = p.brand;
      node.querySelector('h3').textContent = p.title;
      node.querySelector('[data-price]').textContent =
        (p.varies ? this.c.from + ' ' : '') + this.money.format(p.price / 100);
      const old = node.querySelector('s');
      if (p.comparePrice > p.price) old.textContent = this.money.format(p.comparePrice / 100);
      else old.remove();
      node.querySelector('[data-range]').textContent =
        p.range === null || p.range === undefined ? '—' : this.number.format(p.range) + ' km';
      node.querySelector('[data-weight]').textContent =
        p.weight === null || p.weight === undefined ? '—' : this.number.format(p.weight) + ' kg';
      node.querySelector('[data-badge]').textContent = label ? this.c[label] : '';
      const input = node.querySelector('[data-compare-id]');
      input.dataset.compareId = p.id;
      input.setAttribute('aria-label', this.c.compare + ' ' + p.brand + ' ' + p.title);
      input.checked = this.selected.has(p.id);
      input.disabled = this.selected.size >= 4 && !input.checked;
      return node;
    }
    productURL(p) {
      const url = new URL(p.url, location.href);
      url.searchParams.set('oc_return', this.current.pathname + this.current.search + '#oc-card-' + p.id);
      return url.href;
    }
    updateCounts() {
      for (const input of this.querySelectorAll('.oc-filter-form input[type=checkbox]')) {
        const key = input.closest('fieldset').dataset.dimension;
        const params = new URLSearchParams(this.current.search);
        params.delete(input.name);
        params.append(input.name, input.value);
        const count = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)).length;
        input.disabled = !count && !input.checked;
        input.closest('label').querySelector('[data-option-count]').textContent = count;
      }
      const pool = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, this.current.searchParams, 'price'));
      this.querySelectorAll('[name=oc_price]').forEach((input) => {
        const [min, max] = this.bands[input.value];
        const count = pool.filter((p) =>
          (p.prices?.length ? p.prices : [p.price]).some(
            (price) => (min === null || price >= min * 100) && (max === null || price <= max * 100),
          ),
        ).length;
        input.closest('label').querySelector('small').textContent = count;
        input.disabled = !count && !input.checked;
      });
    }
    active() {
      const wrap = this.querySelector('[data-active]');
      wrap.replaceChildren();
      for (const [key, val] of this.current.searchParams) {
        if (!key.startsWith('filter.')) continue;
        const input = [...this.querySelectorAll('.oc-filter-form input')].find(
          (e) => e.name === key && e.value === val,
        );
        const label = input?.closest('label')?.querySelector('span')?.textContent || val;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.removeFilter = key;
        button.dataset.value = val;
        button.textContent = (key.includes('price.') ? this.c.price + ' ' + val : label) + ' ×';
        button.setAttribute('aria-label', this.c.remove + ' ' + button.textContent);
        wrap.append(button);
      }
      if (!wrap.children.length) wrap.textContent = this.c.no_filters;
    }
    pagination(pages) {
      const nav = this.querySelector('[data-pagination]');
      nav.replaceChildren();
      for (const [name, page] of [
        ['prev', this.page - 1],
        ['next', this.page + 1],
      ]) {
        if (page < 1 || page > pages) continue;
        const a = document.createElement('a');
        const url = new URL(this.current);
        url.searchParams.set('page', page);
        a.href = url.href;
        a.rel =
          name +
          ([...this.current.searchParams.keys()].some(
            (k) => k.startsWith('filter.') || k === 'sort_by' || k === 'oc_sort',
          )
            ? ' nofollow'
            : '');
        a.dataset.page = page;
        a.textContent = this.c[name];
        nav.append(a);
      }
      const span = document.createElement('span');
      span.textContent = `${this.c.page} ${this.page} ${this.c.of} ${pages}`;
      nav.insertBefore(span, nav.querySelector('[rel~="next"]'));
    }
    empty() {
      const box = this.querySelector('[data-empty]');
      box.hidden = this.results.length > 0;
      this.querySelector('[data-grid]').hidden = !box.hidden;
      if (box.hidden) return;
      const keys = [...new Set([...this.current.searchParams.keys()].filter((k) => k.startsWith('filter.')))];
      const actions = box.querySelector('[data-relax-actions]');
      actions.replaceChildren();
      let near = [],
        chosen = [];
      const candidates = keys
        .map((key) => {
          const params = new URLSearchParams(this.current.search);
          params.delete(key);
          return {
            key,
            params,
            list: this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params)),
          };
        })
        .sort((a, b) => b.list.length - a.list.length);
      if (candidates.length) {
        let params = new URLSearchParams(this.current.search);
        for (const item of candidates) {
          params.delete(item.key);
          chosen.push(item.key);
          near = this.all.filter((p) => OrtluxResponsiveCollection.matches(p, params));
          if (near.length >= 4) break;
        }
      }
      const names = chosen.map((k) => {
        const dim = Object.entries(OrtluxResponsiveCollection.dimensions).find(([, v]) => v === k)?.[0] || 'price';
        return this.c[dim];
      });
      box.querySelector('[data-empty-reason]').textContent = names.join(' + ') + ' — ' + this.c.relaxed;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.relax = JSON.stringify(chosen);
      button.textContent = this.c.relax + ': ' + names.join(' + ');
      actions.append(button);
      box.querySelector('[data-near]').replaceChildren(...near.slice(0, 4).map((p) => this.card(p)));
    }
    select(input) {
      const p =
        this.results?.find((p) => p.id === input.dataset.compareId) ||
        this.all?.find((p) => p.id === input.dataset.compareId);
      if (!p) {
        input.checked = false;
        this.say(this.c.loading);
        return;
      }
      if (input.checked && this.selected.size < 4) this.selected.set(p.id, p);
      else this.selected.delete(p.id);
      this.updateTray();
      this.say(`${this.selected.size} / 4 ${this.c.selected}`);
    }
    updateTray() {
      const tray = this.querySelector('[data-tray]');
      tray.hidden = !this.selected.size;
      tray.querySelector('[data-selected-count]').textContent = this.selected.size + ' / 4';
      tray.querySelector('[data-limit]').textContent = this.selected.size === 4 ? this.c.limit : '';
      const list = tray.querySelector('[data-selected-list]');
      list.replaceChildren();
      for (const p of this.selected.values()) {
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.removeCompare = p.id;
        b.textContent = p.title + ' ×';
        b.setAttribute('aria-label', this.c.remove + ' ' + p.title);
        list.append(b);
      }
      this.querySelectorAll('[data-compare-id]').forEach((input) => {
        input.checked = this.selected.has(input.dataset.compareId);
        input.disabled = this.selected.size === 4 && !input.checked;
        input.title = input.disabled ? this.c.limit : '';
      });
    }
    compare() {
      const dialog = this.querySelector('[data-comparison]'),
        table = dialog.querySelector('table'),
        items = [...this.selected.values()];
      if (!items.length) return;
      table.style.setProperty('--oc-model-count', items.length);
      table.querySelector('colgroup')?.remove();
      const columns = document.createElement('colgroup');
      const labelColumn = document.createElement('col');
      labelColumn.className = 'oc-compare-label-column';
      columns.append(labelColumn);
      for (const item of items) columns.append(document.createElement('col'));
      table.prepend(columns);

      const head = document.createElement('tr'),
        corner = document.createElement('th');
      corner.scope = 'col';
      corner.textContent = this.c.model;
      head.append(corner);
      for (const p of items) {
        const th = document.createElement('th');
        th.scope = 'col';
        const link = document.createElement('a');
        link.className = 'oc-compare-model';
        link.href = this.productURL(p);
        link.dataset.productId = p.id;
        if (p.image) {
          const image = document.createElement('img');
          const src = new URL(p.image, location.origin);
          src.searchParams.set('width', '480');
          image.src = src.href;
          image.width = 240;
          image.height = 240;
          image.alt = '';
          image.decoding = 'async';
          image.className = 'oc-compare-image';
          link.append(image);
        }
        const name = document.createElement('span');
        name.textContent = p.title;
        link.append(name);
        th.append(link);
        head.append(th);
      }
      table.querySelector('thead').replaceChildren(head);
      const rows = [
        ['vehicle', 'vehicle', ''],
        ['load', 'load', 'kg'],
        ['weight', 'weight', 'kg'],
        ['range', 'range', 'km'],
        ['price', 'price', ''],
        ['motor', 'motor', 'W'],
        ['battery', 'battery', 'Wh'],
        ['speed', 'speed', 'km/h'],
        ['ip', 'ip', ''],
        ['heightMin', 'height_min', 'cm'],
        ['heightMax', 'height_max', 'cm'],
        ['rangeMax', 'range', 'km'],
        ['motorModel', 'motor_model', ''],
        ['frameMaterial', 'frame_material', ''],
        ['brakes', 'brakes', ''],
        ['tyres', 'tyres', ''],
        ['dimensions', 'dimensions', ''],
        ['gradeability', 'gradeability', '%'],
        ['testedMin', 'tested_min', 'km'],
        ['testedMax', 'tested_max', 'km'],
        ['testConditions', 'test_conditions', ''],
      ];
      const body = table.querySelector('tbody');
      body.replaceChildren();
      rows.forEach(([key, label, unit], index) => {
        if (key === 'vehicle') return;
        if (index > 4 && !items.some((p) => p[key] !== null && p[key] !== undefined && p[key] !== '')) return;
        const tr = document.createElement('tr'),
          th = document.createElement('th');
        th.scope = 'row';
        th.textContent = this.c[label] + (key === 'rangeMax' ? ' (max)' : '');
        tr.append(th);
        for (const p of items) {
          const td = document.createElement('td');
          td.textContent =
            p[key] === null || p[key] === undefined || p[key] === ''
              ? '—'
              : key === 'price'
                ? this.money.format(p.price / 100)
                : `${typeof p[key] === 'number' ? this.number.format(p[key]) : p[key]}${unit ? ' ' + unit : ''}`;
          tr.append(td);
        }
        body.append(tr);
      });
      const foot = document.createElement('tr'),
        th = document.createElement('th');
      th.scope = 'row';
      th.textContent = this.c.model;
      foot.append(th);
      for (const p of items) {
        const td = document.createElement('td'),
          a = document.createElement('a');
        a.href = this.productURL(p);
        a.dataset.productId = p.id;
        a.textContent = p.title + ' ↗';
        td.append(a);
        foot.append(td);
      }
      table.querySelector('tfoot').replaceChildren(foot);
      dialog.showModal();
      dialog.querySelector('button').focus();
    }
    markVisited() {
      this.querySelectorAll('.oc-card').forEach((card) => {
        card.querySelector('.oc-visited').hidden = !this.visited.has(card.dataset.id);
      });
    }
    openFilters() {
      const panel = this.querySelector('.oc-sidebar');
      this.drawerOpen = true;
      this.dataset.drawerOpen = '';
      panel.dataset.open = '';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'true');
      this.querySelector('[data-shade]').hidden = false;
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.inerted = [];
      for (const node of document.body.children) {
        if (!node.contains(this) && !node.inert) {
          node.inert = true;
          this.inerted.push(node);
        }
      }
      this.querySelector('[data-close-filters]').focus();
    }
    closeFilters(focus = true) {
      if (!this.drawerOpen) return;
      this.drawerOpen = false;
      delete this.dataset.drawerOpen;
      const panel = this.querySelector('.oc-sidebar');
      delete panel.dataset.open;
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'false');
      this.querySelector('[data-shade]').hidden = true;
      document.body.style.overflow = this.oldOverflow || '';
      this.inerted?.forEach((e) => (e.inert = false));
      if (focus) this.querySelector('[data-open-filters]').focus();
    }
    keydown(e) {
      if (!this.drawerOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeFilters();
      }
      if (e.key === 'Tab') {
        const nodes = [
          ...this.querySelector('.oc-sidebar').querySelectorAll(
            'button:not([disabled]),input:not([disabled]),a[href],select',
          ),
        ].filter((el) => el.getClientRects().length);
        const first = nodes[0],
          last = nodes.at(-1);
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    click(e) {
      const target = e.target.closest('button,a');
      if (!target) return;
      if (target.dataset.productId) {
        const destination = new URL(target.href, location.href);
        destination.searchParams.set(
          'oc_return',
          this.current.pathname + this.current.search + '#oc-card-' + target.dataset.productId,
        );
        target.href = destination.href;
        this.save('oc-card-' + target.dataset.productId);
        this.visited.add(target.dataset.productId);
        try {
          localStorage.setItem('ortlux-visited', JSON.stringify([...this.visited]));
        } catch {}
        this.markVisited();
        return;
      }
      if (target.matches('[data-open-filters]')) this.openFilters();
      else if (target.matches('[data-close-filters]')) this.closeFilters();
      else if (target.matches('[data-retry]')) this.ready = this.load();
      else if (target.matches('[data-page]')) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        this.navigate(new URL(target.href));
        const h = this.querySelector('.oc-result-heading');
        h.tabIndex = -1;
        h.focus({ preventScroll: true });
        h.scrollIntoView({ block: 'start', behavior: 'instant' });
      } else if (target.matches('[data-clear]')) {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()])
          if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.removeFilter) {
        const url = new URL(location.href),
          key = target.dataset.removeFilter,
          values = url.searchParams.getAll(key).filter((x) => x !== target.dataset.value);
        url.searchParams.delete(key);
        values.forEach((v) => url.searchParams.append(key, v));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.relax) {
        const url = new URL(location.href);
        JSON.parse(target.dataset.relax).forEach((k) => url.searchParams.delete(k));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.matches('[data-compare]')) this.compare();
      else if (target.matches('[data-close-compare]')) this.querySelector('[data-comparison]').close();
      else if (target.dataset.removeCompare) {
        this.selected.delete(target.dataset.removeCompare);
        this.updateTray();
        this.say(`${this.selected.size} / 4 ${this.c.selected}`);
        const fallback = this.selected.size
          ? this.querySelector('[data-compare]')
          : this.querySelector('[data-clear]');
        fallback.focus();
      } else if (target.matches('[data-clear-compare]')) {
        this.selected.clear();
        this.updateTray();
        this.say('0 / 4 ' + this.c.selected);
        this.querySelector('[data-clear]').focus();
      }
    }
  }
  if (!customElements.get('ortlux-responsive-collection')) customElements.define('ortlux-responsive-collection', OrtluxResponsiveCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-collection"] && !Shopify.designMode) return;
  try {
    
  /* The numeric catalogue is loaded in market context; no external runtime. */
  class OrtluxCollection extends HTMLElement {
    static dimensions = {
      scene: 'filter.p.m.ortlux.use_cases',
      brand: 'filter.p.m.ortlux.brand',
      load: 'filter.p.m.ortlux.load_bands',
      range: 'filter.p.m.ortlux.range_bands',
      weight: 'filter.p.m.ortlux.weight_bands',
      road: 'filter.p.m.ortlux.road_legal_markets',
    };
    static positive(v) {
      return typeof v === 'number' && Number.isFinite(v) && v > 0;
    }
    static labels(items) {
      const result = new Map();
      if (items.length < 2 || items.length > 12) return result;
      const metrics = [
        ['lightest', (p) => p.weight, 1],
        ['longest', (p) => p.range, -1],
        [
          'value',
          (p) =>
            OrtluxCollection.positive(p.range) && OrtluxCollection.positive(p.price)
              ? p.price / p.range
              : null,
          1,
        ],
        ['cheapest', (p) => p.price, 1],
      ];
      for (const [label, get, dir] of metrics) {
        const list = items
          .map((p) => ({ p, v: get(p) }))
          .filter((x) => OrtluxCollection.positive(x.v))
          .sort((a, b) => dir * (a.v - b.v));
        if (list.length < 2) continue;
        const best = list[0],
          second = list[1];
        const gap = dir === 1 ? (second.v - best.v) / second.v : (best.v - second.v) / second.v;
        if (gap + Number.EPSILON >= 0.1 && !result.has(best.p.id)) result.set(best.p.id, label);
      }
      return result;
    }
    static matches(p, params, skip) {
      for (const [key, name] of Object.entries(this.dimensions)) {
        if (key === skip) continue;
        const selected = params.getAll(name).flatMap((x) => x.split(','));
        if (!selected.length) continue;
        const hit = selected.some((v) =>
          key === 'scene'
            ? (p.scenes || []).includes(v)
            : key === 'brand'
              ? String(p.brandId) === v
              : key === 'road'
                ? (p.road || []).includes(v)
                : key === 'load'
                  ? this.positive(p.load) && p.load >= Number(v)
                  : key === 'range'
                    ? this.positive(p.range) && p.range >= Number(v)
                    : key === 'weight'
                      ? this.positive(p.weight) && (v === 'gt25' ? p.weight > 25 : p.weight <= Number(v))
                      : true,
        );
        if (!hit) return false;
      }
      if (skip !== 'price') {
        const min = params.get('filter.v.price.gte'),
          max = params.get('filter.v.price.lte');
        const prices = Array.isArray(p.prices) && p.prices.length ? p.prices : [p.price];
        if (
          !prices.some(
            (price) =>
              (min === null || min === '' || price >= Number(min) * 100) &&
              (max === null || max === '' || price <= Number(max) * 100),
          )
        )
          return false;
      }
      return true;
    }
    connectedCallback() {
      if (!this.querySelector('[data-grid]')) return;
      if (this.initialized) return;
      this.initialized = true;
      this.c = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.pageSize = 12;
      this.selected = new Map();
      this.all = null;
      this.current = new URL(location.href);
      this.visited = new Set();
      this.abort = new AbortController();
      this.money = new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency',
        currency: this.dataset.currency,
      });
      this.number = new Intl.NumberFormat(this.dataset.locale, {
        maximumFractionDigits: 1,
      });
      try {
        this.visited = new Set(JSON.parse(localStorage.getItem('ortlux-visited') || '[]'));
      } catch {}
      this.dataset.enhanced = '';
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      this.addEventListener('click', (e) => this.click(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('change', (e) => this.change(e), {
        signal: this.abort.signal,
      });
      this.addEventListener('keydown', (e) => this.keydown(e), {
        signal: this.abort.signal,
      });
      this.querySelector('form').addEventListener(
        'submit',
        (e) => {
          e.preventDefault();
          this.filterChange();
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'popstate',
        () => {
          this.current = new URL(location.href);
          this.ready.then(() => {
            this.syncInputs();
            this.render(false);
            this.restore();
          });
        },
        { signal: this.abort.signal },
      );
      window.addEventListener(
        'pageshow',
        (e) => {
          if (e.persisted) {
            this.markVisited();
            this.restore();
          }
        },
        { signal: this.abort.signal },
      );
      window.addEventListener('pagehide', () => this.save(), {
        signal: this.abort.signal,
      });
      window.addEventListener(
        'resize',
        () => {
          if (innerWidth > 750 && this.drawerOpen) this.closeFilters();
        },
        { signal: this.abort.signal },
      );
      this.querySelector('[data-comparison]').addEventListener(
        'close',
        () => this.querySelector('[data-compare]').focus(),
        { signal: this.abort.signal },
      );
      document.addEventListener(
        'focusin',
        (e) => {
          if (this.drawerOpen || this.querySelector('[data-comparison]').open) return;
          const tray = this.querySelector('[data-tray]');
          if (tray.hidden || tray.contains(e.target)) return;
          const rect = e.target.getBoundingClientRect(),
            top = tray.getBoundingClientRect().top;
          if (rect.bottom > top - 8) window.scrollBy({ top: rect.bottom - top + 16, behavior: 'instant' });
        },
        { signal: this.abort.signal },
      );
      this.markVisited();
      this.syncInputs();
      this.ready = this.load();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.closeFilters(false);
    }
    say(text) {
      this.querySelector('[data-live]').textContent = text;
    }
    async load() {
      this.setAttribute('aria-busy', 'true');
      this.say(this.c.loading);
      try {
        let products = [],
          page = 1,
          pages = 1;
        do {
          let url;
          if (this.dataset.preview) {
            url = new URL(this.dataset.preview, location.href);
            url.searchParams.set('page', page);
          } else {
            url = new URL(this.dataset.url, location.origin);
            url.searchParams.set('section_id', 'ortlux-collection-data');
            url.searchParams.set('page', page);
          }
          const response = await fetch(url, {
            signal: this.abort.signal,
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Catalogue response ' + response.status);
          let data;
          if (this.dataset.preview) data = await response.json();
          else {
            const t = document.createElement('template');
            t.innerHTML = await response.text();
            const node = t.content.querySelector('[data-catalog-data]');
            if (!node) throw new Error('Missing data section');
            data = JSON.parse(node.textContent);
          }
          if (
            !Array.isArray(data.products) ||
            !Number.isInteger(data.pages) ||
            data.pages < 1 ||
            data.pages > 100
          )
            throw new Error('Invalid catalogue response');
          products.push(...data.products);
          pages = data.pages;
          page++;
        } while (page <= pages);
        this.all = [...new Map(products.map((p) => [String(p.id), { ...p, id: String(p.id) }])).values()];
        this.setupMissingFilters();
        this.setupPrices();
        this.syncInputs();
        this.render(false);
        this.restore();
        this.querySelector('[data-retry]').hidden = true;
      } catch (e) {
        if (e.name !== 'AbortError') {
          this.say(this.c.error);
          this.querySelector('[data-retry]').hidden = false;
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
    setupMissingFilters() {
      const form = this.querySelector('.oc-filter-form');
      const options = {
        scene: ['commuting', 'cargo', 'offroad', 'folding'],
        brand: [
          ...new Set(
            this.all.map((p) => String(p.brandId)).filter((id) => id !== 'null' && id !== 'undefined'),
          ),
        ],
        load: ['120', '150'],
        range: ['40', '60', '80'],
        weight: ['20', '25', 'gt25'],
        road: [this.dataset.market],
      };
      for (const [dimension, values] of Object.entries(options)) {
        if (form.querySelector(`[data-dimension="${dimension}"]`)) continue;
        if (
          (dimension === 'scene' && this.dataset.kind === 'scene') ||
          (dimension === 'brand' && this.dataset.kind === 'brand') ||
          (dimension === 'road' && this.dataset.vehicle !== 'escooter')
        )
          continue;
        const meaningful = values.filter((value) =>
          this.all.some((p) =>
            OrtluxCollection.matches(
              p,
              new URLSearchParams([[OrtluxCollection.dimensions[dimension], value]]),
            ),
          ),
        );
        if (!meaningful.length) continue;
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = dimension;
        const legend = document.createElement('legend');
        legend.textContent = this.c[dimension];
        fieldset.append(legend);
        for (const value of meaningful) {
          const label = document.createElement('label');
          label.className = 'oc-check';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.name = OrtluxCollection.dimensions[dimension];
          input.value = value;
          const text = document.createElement('span');
          text.textContent =
            dimension === 'brand'
              ? this.all.find((p) => String(p.brandId) === value).brand
              : dimension === 'scene'
                ? this.c[value]
                : dimension === 'road'
                  ? this.c.approved
                  : dimension === 'weight'
                    ? `${value === 'gt25' ? '>' : '≤'} ${value === 'gt25' ? '25' : value} kg`
                    : `≥ ${value} ${dimension === 'range' ? 'km' : 'kg'}`;
          const count = document.createElement('small');
          count.dataset.optionCount = '';
          label.append(input, text, count);
          fieldset.append(label);
        }
        form.append(fieldset);
      }
      if (!form.querySelector('[data-dimension="price"]') && this.all.length) {
        const fieldset = document.createElement('fieldset');
        fieldset.dataset.dimension = 'price';
        const legend = document.createElement('legend');
        legend.textContent = this.c.price;
        const bands = document.createElement('div');
        bands.dataset.priceBands = '';
        const inputs = document.createElement('div');
        inputs.className = 'oc-price-inputs';
        for (const [suffix, title] of [
          ['gte', this.c.from],
          ['lte', this.c.up_to],
        ]) {
          const label = document.createElement('label');
          label.textContent = title;
          const input = document.createElement('input');
          input.name = `filter.v.price.${suffix}`;
          input.type = 'number';
          input.min = '0';
          input.step = '0.01';
          input.inputMode = 'decimal';
          label.append(input);
          inputs.append(label);
        }
        fieldset.append(legend, bands, inputs);
        form.prepend(fieldset);
      }
    }
    setupPrices() {
      const raw = JSON.parse(this.querySelector('[data-price-config]').textContent || 'null');
      this.bands = raw?.[this.dataset.currency] || [];
      const wrap = this.querySelector('[data-price-bands]');
      if (!wrap) return;
      wrap.replaceChildren();
      wrap.setAttribute('aria-busy', 'false');
      for (const [index, band] of this.bands.entries()) {
        if (!Array.isArray(band) || band.length !== 2) continue;
        const label = document.createElement('label');
        label.className = 'oc-check';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'oc_price';
        input.value = index;
        const text = document.createElement('span');
        text.textContent = this.bandText(band);
        const count = document.createElement('small');
        count.dataset.optionCount = '';
        label.append(input, text, count);
        wrap.append(label);
      }
    }
    bandText([min, max]) {
      return min === null
        ? `${this.c.up_to} ${this.money.format(max)}`
        : max === null
          ? `${this.c.from} ${this.money.format(min)}`
          : `${this.money.format(min)}–${this.money.format(max)}`;
    }
    syncInputs() {
      const p = this.current.searchParams;
      this.querySelectorAll('.oc-filter-form input').forEach((input) => {
        if (input.name === 'oc_price') {
          const band = this.bands?.[input.value];
          input.checked =
            !!band &&
            String(band[0] ?? '') === (p.get('filter.v.price.gte') || '') &&
            String(band[1] ?? '') === (p.get('filter.v.price.lte') || '');
        } else if (input.type === 'checkbox')
          input.checked = p
            .getAll(input.name)
            .flatMap((x) => x.split(','))
            .includes(input.value);
        else input.value = p.get(input.name) || '';
      });
      this.querySelector('[data-sort]').value = p.get('oc_sort') || p.get('sort_by') || 'manual';
    }
    async filterChange() {
      if (!this.all) {
        await this.ready;
        if (!this.all) return;
      }
      const next = new URL(location.href);
      for (const k of [...next.searchParams.keys()])
        if (k.startsWith('filter.') || k === 'page') next.searchParams.delete(k);
      for (const [k, v] of new FormData(this.querySelector('form')))
        if (v && k !== 'oc_price') next.searchParams.append(k, v);
      this.navigate(next);
    }
    change(e) {
      if (e.target.matches('[data-sort]')) {
        const next = new URL(location.href);
        next.searchParams.delete('page');
        next.searchParams.delete('sort_by');
        next.searchParams.delete('oc_sort');
        const v = e.target.value;
        if (v === 'range-descending' || v === 'weight-ascending') next.searchParams.set('oc_sort', v);
        else if (v !== 'manual') next.searchParams.set('sort_by', v);
        this.ready.then(() => {
          if (this.all) this.navigate(next);
        });
      } else if (e.target.matches('[data-compare-id]')) this.select(e.target);
      else if (e.target.closest('.oc-filter-form')) {
        if (e.target.name === 'oc_price') {
          const [min, max] = this.bands[e.target.value];
          this.querySelector('[name="filter.v.price.gte"]').value = min ?? '';
          this.querySelector('[name="filter.v.price.lte"]').value = max ?? '';
        }
        this.filterChange();
      }
    }
    navigate(url) {
      this.save();
      history.pushState({ oc: { url: url.href, scroll: 0 } }, '', url);
      this.current = url;
      this.syncInputs();
      this.render();
    }
    save(anchor) {
      const state = {
        ...history.state,
        oc: { url: location.href, scroll: scrollY, anchor: anchor || null },
      };
      history.replaceState(state, '');
    }
    restore() {
      const s = history.state?.oc;
      if (!s || s.url !== location.href) {
        if (location.hash.startsWith('#oc-card-'))
          requestAnimationFrame(() =>
            requestAnimationFrame(() =>
              document
                .getElementById(location.hash.slice(1))
                ?.scrollIntoView({ block: 'center', behavior: 'instant' }),
            ),
          );
        return;
      }
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          window.scrollTo({ top: s.scroll || 0, behavior: 'instant' });
        }),
      );
    }
    sort(items) {
      const sort =
        this.current.searchParams.get('oc_sort') || this.current.searchParams.get('sort_by') || 'manual';
      return [...items].sort((a, b) => {
        if (sort === 'price-ascending') return a.price - b.price;
        if (sort === 'price-descending') return b.price - a.price;
        if (sort === 'range-descending') return (b.range ?? -Infinity) - (a.range ?? -Infinity);
        if (sort === 'weight-ascending') return (a.weight ?? Infinity) - (b.weight ?? Infinity);
        return a.rank - b.rank;
      });
    }
    render(announce = true) {
      if (!this.all) return;
      if (announce || this.current.searchParams.has('oc_sort'))
        document.querySelector('[data-oc-itemlist]')?.remove();
      const params = this.current.searchParams;
      const filteredUrl = [...params.keys()].some(
        (key) => key.startsWith('filter.') || key === 'oc_sort' || key === 'sort_by',
      );
      let robots = document.getElementById('ortlux-filter-robots');
      if (filteredUrl) {
        if (!robots) {
          robots = document.createElement('meta');
          robots.id = 'ortlux-filter-robots';
          robots.name = 'robots';
          document.head.append(robots);
        }
        robots.content = 'noindex,follow';
      } else robots?.remove();
      this.results = this.sort(
        this.all
          .filter((p) => OrtluxCollection.matches(p, params))
          .map((p) => {
            const min = params.get('filter.v.price.gte'),
              max = params.get('filter.v.price.lte');
            const prices = (p.prices?.length ? p.prices : [p.price]).filter(
              (v) => (!min || v >= Number(min) * 100) && (!max || v <= Number(max) * 100),
            );
            return { ...p, price: Math.min(...prices) };
          }),
      );
      const count = this.results.length,
        pages = Math.max(1, Math.ceil(count / this.pageSize));
      this.page = Math.min(pages, Math.max(1, parseInt(params.get('page') || '1', 10) || 1));
      const labels = OrtluxCollection.labels(this.results),
        visible = this.results.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
      this.querySelector('[data-grid]').replaceChildren(
        ...visible.map((p, i) => this.card(p, labels.get(p.id), i)),
      );
      this.querySelectorAll('[data-count],[data-result-count]').forEach(
        (e) => (e.textContent = this.number.format(count)),
      );
      this.updateCounts();
      this.active();
      this.pagination(pages);
      this.empty();
      this.updateTray();
      this.markVisited();
      this.say(`${this.number.format(count)} ${this.c.results}`);
      if (announce) this.querySelector('[data-grid-wrap]').setAttribute('data-updated', '');
    }
    card(p, label, index = 9) {
      const node = this.querySelector('[data-card-template]').content.firstElementChild.cloneNode(true);
      node.dataset.id = p.id;
      node.id = 'oc-card-' + p.id;
      const link = node.querySelector('a');
      link.href = this.productURL(p);
      link.dataset.productId = p.id;
      const img = node.querySelector('img');
      if (p.image) {
        if (p.srcset) img.srcset = p.srcset;
        img.sizes = '(max-width: 360px) 90vw, (max-width: 750px) 44vw, (max-width: 1100px) 34vw, 25vw';
        img.src = p.image;
        img.alt = p.title;
        img.width = p.imageWidth || 600;
        img.height = p.imageHeight || 400;
        img.loading = index < (innerWidth <= 360 ? 1 : innerWidth <= 1100 ? 2 : 3) ? 'eager' : 'lazy';
        img.decoding = 'async';
        img.fetchPriority = index === 0 ? 'high' : 'auto';
      } else {
        img.remove();
        node.querySelector('.oc-card-image').append(document.createTextNode(this.c.no_image));
      }
      node.querySelector('.oc-card-brand').textContent = p.brand;
      node.querySelector('h3').textContent = p.title;
      node.querySelector('[data-price]').textContent =
        (p.varies ? this.c.from + ' ' : '') + this.money.format(p.price / 100);
      const old = node.querySelector('s');
      if (p.comparePrice > p.price) old.textContent = this.money.format(p.comparePrice / 100);
      else old.remove();
      node.querySelector('[data-range]').textContent =
        p.range === null || p.range === undefined ? '—' : this.number.format(p.range) + ' km';
      node.querySelector('[data-weight]').textContent =
        p.weight === null || p.weight === undefined ? '—' : this.number.format(p.weight) + ' kg';
      node.querySelector('[data-badge]').textContent = label ? this.c[label] : '';
      const input = node.querySelector('[data-compare-id]');
      input.dataset.compareId = p.id;
      input.setAttribute('aria-label', this.c.compare + ' ' + p.brand + ' ' + p.title);
      input.checked = this.selected.has(p.id);
      input.disabled = this.selected.size >= 4 && !input.checked;
      return node;
    }
    productURL(p) {
      const url = new URL(p.url, location.href);
      url.searchParams.set('oc_return', this.current.pathname + this.current.search + '#oc-card-' + p.id);
      return url.href;
    }
    updateCounts() {
      for (const input of this.querySelectorAll('.oc-filter-form input[type=checkbox]')) {
        const key = input.closest('fieldset').dataset.dimension;
        const params = new URLSearchParams(this.current.search);
        params.delete(input.name);
        params.append(input.name, input.value);
        const count = this.all.filter((p) => OrtluxCollection.matches(p, params)).length;
        input.disabled = !count && !input.checked;
        input.closest('label').querySelector('[data-option-count]').textContent = count;
      }
      const pool = this.all.filter((p) => OrtluxCollection.matches(p, this.current.searchParams, 'price'));
      this.querySelectorAll('[name=oc_price]').forEach((input) => {
        const [min, max] = this.bands[input.value];
        const count = pool.filter((p) =>
          (p.prices?.length ? p.prices : [p.price]).some(
            (price) => (min === null || price >= min * 100) && (max === null || price <= max * 100),
          ),
        ).length;
        input.closest('label').querySelector('small').textContent = count;
        input.disabled = !count && !input.checked;
      });
    }
    active() {
      const wrap = this.querySelector('[data-active]');
      wrap.replaceChildren();
      for (const [key, val] of this.current.searchParams) {
        if (!key.startsWith('filter.')) continue;
        const input = [...this.querySelectorAll('.oc-filter-form input')].find(
          (e) => e.name === key && e.value === val,
        );
        const label = input?.closest('label')?.querySelector('span')?.textContent || val;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.removeFilter = key;
        button.dataset.value = val;
        button.textContent = (key.includes('price.') ? this.c.price + ' ' + val : label) + ' ×';
        button.setAttribute('aria-label', this.c.remove + ' ' + button.textContent);
        wrap.append(button);
      }
      if (!wrap.children.length) wrap.textContent = this.c.no_filters;
    }
    pagination(pages) {
      const nav = this.querySelector('[data-pagination]');
      nav.replaceChildren();
      for (const [name, page] of [
        ['prev', this.page - 1],
        ['next', this.page + 1],
      ]) {
        if (page < 1 || page > pages) continue;
        const a = document.createElement('a');
        const url = new URL(this.current);
        url.searchParams.set('page', page);
        a.href = url.href;
        a.rel =
          name +
          ([...this.current.searchParams.keys()].some(
            (k) => k.startsWith('filter.') || k === 'sort_by' || k === 'oc_sort',
          )
            ? ' nofollow'
            : '');
        a.dataset.page = page;
        a.textContent = this.c[name];
        nav.append(a);
      }
      const span = document.createElement('span');
      span.textContent = `${this.c.page} ${this.page} ${this.c.of} ${pages}`;
      nav.insertBefore(span, nav.querySelector('[rel~="next"]'));
    }
    empty() {
      const box = this.querySelector('[data-empty]');
      box.hidden = this.results.length > 0;
      this.querySelector('[data-grid]').hidden = !box.hidden;
      if (box.hidden) return;
      const keys = [...new Set([...this.current.searchParams.keys()].filter((k) => k.startsWith('filter.')))];
      const actions = box.querySelector('[data-relax-actions]');
      actions.replaceChildren();
      let near = [],
        chosen = [];
      const candidates = keys
        .map((key) => {
          const params = new URLSearchParams(this.current.search);
          params.delete(key);
          return {
            key,
            params,
            list: this.all.filter((p) => OrtluxCollection.matches(p, params)),
          };
        })
        .sort((a, b) => b.list.length - a.list.length);
      if (candidates.length) {
        let params = new URLSearchParams(this.current.search);
        for (const item of candidates) {
          params.delete(item.key);
          chosen.push(item.key);
          near = this.all.filter((p) => OrtluxCollection.matches(p, params));
          if (near.length >= 4) break;
        }
      }
      const names = chosen.map((k) => {
        const dim = Object.entries(OrtluxCollection.dimensions).find(([, v]) => v === k)?.[0] || 'price';
        return this.c[dim];
      });
      box.querySelector('[data-empty-reason]').textContent = names.join(' + ') + ' — ' + this.c.relaxed;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.relax = JSON.stringify(chosen);
      button.textContent = this.c.relax + ': ' + names.join(' + ');
      actions.append(button);
      box.querySelector('[data-near]').replaceChildren(...near.slice(0, 4).map((p) => this.card(p)));
    }
    select(input) {
      const p =
        this.results?.find((p) => p.id === input.dataset.compareId) ||
        this.all?.find((p) => p.id === input.dataset.compareId);
      if (!p) {
        input.checked = false;
        this.say(this.c.loading);
        return;
      }
      if (input.checked && this.selected.size < 4) this.selected.set(p.id, p);
      else this.selected.delete(p.id);
      this.updateTray();
      this.say(`${this.selected.size} / 4 ${this.c.selected}`);
    }
    updateTray() {
      const tray = this.querySelector('[data-tray]');
      tray.hidden = !this.selected.size;
      tray.querySelector('[data-selected-count]').textContent = this.selected.size + ' / 4';
      tray.querySelector('[data-limit]').textContent = this.selected.size === 4 ? this.c.limit : '';
      const list = tray.querySelector('[data-selected-list]');
      list.replaceChildren();
      for (const p of this.selected.values()) {
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.removeCompare = p.id;
        b.textContent = p.title + ' ×';
        b.setAttribute('aria-label', this.c.remove + ' ' + p.title);
        list.append(b);
      }
      this.querySelectorAll('[data-compare-id]').forEach((input) => {
        input.checked = this.selected.has(input.dataset.compareId);
        input.disabled = this.selected.size === 4 && !input.checked;
        input.title = input.disabled ? this.c.limit : '';
      });
    }
    compare() {
      const dialog = this.querySelector('[data-comparison]'),
        table = dialog.querySelector('table'),
        items = [...this.selected.values()];
      if (!items.length) return;
      const head = document.createElement('tr'),
        corner = document.createElement('th');
      corner.scope = 'col';
      corner.textContent = this.c.model;
      head.append(corner);
      for (const p of items) {
        const th = document.createElement('th');
        th.scope = 'col';
        th.textContent = p.brand + ' ' + p.title;
        head.append(th);
      }
      table.querySelector('thead').replaceChildren(head);
      const rows = [
        ['vehicle', 'vehicle', ''],
        ['load', 'load', 'kg'],
        ['weight', 'weight', 'kg'],
        ['range', 'range', 'km'],
        ['price', 'price', ''],
        ['motor', 'motor', 'W'],
        ['battery', 'battery', 'Wh'],
        ['speed', 'speed', 'km/h'],
        ['ip', 'ip', ''],
        ['heightMin', 'height_min', 'cm'],
        ['heightMax', 'height_max', 'cm'],
        ['rangeMax', 'range', 'km'],
        ['motorModel', 'motor_model', ''],
        ['frameMaterial', 'frame_material', ''],
        ['brakes', 'brakes', ''],
        ['tyres', 'tyres', ''],
        ['dimensions', 'dimensions', ''],
        ['gradeability', 'gradeability', '%'],
        ['testedMin', 'tested_min', 'km'],
        ['testedMax', 'tested_max', 'km'],
        ['testConditions', 'test_conditions', ''],
      ];
      const body = table.querySelector('tbody');
      body.replaceChildren();
      rows.forEach(([key, label, unit], index) => {
        if (index > 4 && !items.some((p) => p[key] !== null && p[key] !== undefined && p[key] !== '')) return;
        const tr = document.createElement('tr'),
          th = document.createElement('th');
        th.scope = 'row';
        th.textContent = this.c[label] + (key === 'rangeMax' ? ' (max)' : '');
        tr.append(th);
        for (const p of items) {
          const td = document.createElement('td');
          td.textContent =
            p[key] === null || p[key] === undefined || p[key] === ''
              ? '—'
              : key === 'price'
                ? this.money.format(p.price / 100)
                : `${typeof p[key] === 'number' ? this.number.format(p[key]) : p[key]}${unit ? ' ' + unit : ''}`;
          tr.append(td);
        }
        body.append(tr);
      });
      const foot = document.createElement('tr'),
        th = document.createElement('th');
      th.scope = 'row';
      th.textContent = this.c.model;
      foot.append(th);
      for (const p of items) {
        const td = document.createElement('td'),
          a = document.createElement('a');
        a.href = this.productURL(p);
        a.dataset.productId = p.id;
        a.textContent = p.title + ' ↗';
        td.append(a);
        foot.append(td);
      }
      table.querySelector('tfoot').replaceChildren(foot);
      dialog.showModal();
      dialog.querySelector('button').focus();
    }
    markVisited() {
      this.querySelectorAll('.oc-card').forEach((card) => {
        card.querySelector('.oc-visited').hidden = !this.visited.has(card.dataset.id);
      });
    }
    openFilters() {
      const panel = this.querySelector('.oc-sidebar');
      this.drawerOpen = true;
      this.dataset.drawerOpen = '';
      panel.dataset.open = '';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'true');
      this.querySelector('[data-shade]').hidden = false;
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.inerted = [];
      for (const node of document.body.children) {
        if (!node.contains(this) && !node.inert) {
          node.inert = true;
          this.inerted.push(node);
        }
      }
      this.querySelector('[data-close-filters]').focus();
    }
    closeFilters(focus = true) {
      if (!this.drawerOpen) return;
      this.drawerOpen = false;
      delete this.dataset.drawerOpen;
      const panel = this.querySelector('.oc-sidebar');
      delete panel.dataset.open;
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      this.querySelector('[data-open-filters]').setAttribute('aria-expanded', 'false');
      this.querySelector('[data-shade]').hidden = true;
      document.body.style.overflow = this.oldOverflow || '';
      this.inerted?.forEach((e) => (e.inert = false));
      if (focus) this.querySelector('[data-open-filters]').focus();
    }
    keydown(e) {
      if (!this.drawerOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeFilters();
      }
      if (e.key === 'Tab') {
        const nodes = [
          ...this.querySelector('.oc-sidebar').querySelectorAll(
            'button:not([disabled]),input:not([disabled]),a[href],select',
          ),
        ].filter((el) => el.getClientRects().length);
        const first = nodes[0],
          last = nodes.at(-1);
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    click(e) {
      const target = e.target.closest('button,a');
      if (!target) return;
      if (target.dataset.productId) {
        const destination = new URL(target.href, location.href);
        destination.searchParams.set(
          'oc_return',
          this.current.pathname + this.current.search + '#oc-card-' + target.dataset.productId,
        );
        target.href = destination.href;
        this.save('oc-card-' + target.dataset.productId);
        this.visited.add(target.dataset.productId);
        try {
          localStorage.setItem('ortlux-visited', JSON.stringify([...this.visited]));
        } catch {}
        this.markVisited();
        return;
      }
      if (target.matches('[data-open-filters]')) this.openFilters();
      else if (target.matches('[data-close-filters]')) this.closeFilters();
      else if (target.matches('[data-retry]')) this.ready = this.load();
      else if (target.matches('[data-page]')) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        this.navigate(new URL(target.href));
        const h = this.querySelector('.oc-result-heading');
        h.tabIndex = -1;
        h.focus({ preventScroll: true });
        h.scrollIntoView({ block: 'start', behavior: 'instant' });
      } else if (target.matches('[data-clear]')) {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()])
          if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.removeFilter) {
        const url = new URL(location.href),
          key = target.dataset.removeFilter,
          values = url.searchParams.getAll(key).filter((x) => x !== target.dataset.value);
        url.searchParams.delete(key);
        values.forEach((v) => url.searchParams.append(key, v));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.dataset.relax) {
        const url = new URL(location.href);
        JSON.parse(target.dataset.relax).forEach((k) => url.searchParams.delete(k));
        url.searchParams.delete('page');
        this.navigate(url);
        this.querySelector('[data-clear]').focus();
      } else if (target.matches('[data-compare]')) this.compare();
      else if (target.matches('[data-close-compare]')) this.querySelector('[data-comparison]').close();
      else if (target.dataset.removeCompare) {
        this.selected.delete(target.dataset.removeCompare);
        this.updateTray();
        this.say(`${this.selected.size} / 4 ${this.c.selected}`);
        const fallback = this.selected.size
          ? this.querySelector('[data-compare]')
          : this.querySelector('[data-clear]');
        fallback.focus();
      } else if (target.matches('[data-clear-compare]')) {
        this.selected.clear();
        this.updateTray();
        this.say('0 / 4 ' + this.c.selected);
        this.querySelector('[data-clear]').focus();
      }
    }
  }
  if (!customElements.get('ortlux-collection')) customElements.define('ortlux-collection', OrtluxCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-policy-page"] && !Shopify.designMode) return;
  try {
    
  /* Local enhancement only; all policy text, anchors and contact links are server-rendered. */
  if (!customElements.get('ortlux-policy')) {
    customElements.define(
      'ortlux-policy',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const { signal } = this.abort;
          const header =
            document.getElementById('header-component') || document.querySelector('.policy-preview-header');
          if (header) {
            const measure = () =>
              document.documentElement.style.setProperty(
                '--ortlux-policy-header-height',
                `${Math.ceil(header.getBoundingClientRect().height)}px`,
              );
            this.resize = new ResizeObserver(measure);
            this.resize.observe(header);
            measure();
            this.addEventListener(
              'focusin',
              (event) => {
                requestAnimationFrame(() => {
                  if (!event.target.isConnected) return;
                  const top = event.target.getBoundingClientRect().top;
                  const protectedTop = header.getBoundingClientRect().bottom + 12;
                  if (top < protectedTop)
                    window.scrollBy({
                      top: top - protectedTop,
                      behavior: 'instant',
                    });
                });
              },
              { signal },
            );
          }
          this.querySelectorAll('[data-policy-print]').forEach((button) => {
            button.disabled = false;
            button.addEventListener('click', () => window.print(), { signal });
          });
          this.querySelectorAll('form[data-withdrawal-draft]').forEach((form) =>
            form.addEventListener('submit', (e) => e.preventDefault(), {
              signal,
            }),
          );
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resize?.disconnect();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-policy-product-detail"] && !Shopify.designMode) return;
  try {
    
  /* Section-local progressive enhancement; native product forms work without JavaScript. */
  if (!customElements.get('ortlux-product')) {
    customElements.define(
      'ortlux-product',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.querySelectorAll('[data-variant]').forEach((select) => {
            select.disabled = false;
          });
          const selectImage = (link) => {
            const main = this.querySelector('.op-main-photo img');
            if (!main || !link) return;
            main.srcset = link.dataset.imageSrcset;
            main.src = link.dataset.imageSrc;
            main.alt = link.querySelector('img')?.alt || '';
            this.querySelectorAll('[data-gallery-image]').forEach(item => {
              if (item === link) item.setAttribute('aria-current', 'true');
              else item.removeAttribute('aria-current');
            });
            const status = this.querySelector('[data-gallery-status]');
            if (status) status.textContent = main.alt;
          };
          this.addEventListener('click', event => {
            const link = event.target.closest('[data-gallery-image]');
            if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            selectImage(link);
          }, { signal });
          const horizonHeader = document.getElementById('header-component');
          if (horizonHeader) {
            this.resizeObserver = new ResizeObserver(() => {
              const height = horizonHeader.getBoundingClientRect().height;
              document.documentElement.style.setProperty('--ortlux-header-offset', `${height + 16}px`);
            });
            this.resizeObserver.observe(horizonHeader);
            this.addEventListener(
              'focusin',
              (event) => {
                const rect = event.target.getBoundingClientRect();
                const bottom = horizonHeader.getBoundingClientRect().bottom;
                if (rect.top < bottom + 8)
                  window.scrollBy({
                    top: rect.top - bottom - 8,
                    behavior: 'instant',
                  });
              },
              { signal },
            );
          }
          this.addEventListener(
            'change',
            (event) => {
              if (!event.target.matches('[data-variant]')) return;
              const option = event.target.selectedOptions[0];
              if (option.dataset.imageId) selectImage(this.querySelector(`[data-gallery-image="${option.dataset.imageId}"]`));
              const price = this.querySelector('span[data-price]');
              const compare = this.querySelector('[data-compare-price]');
              price.textContent = option.dataset.price;
              compare.textContent = option.dataset.compare || '';
              compare.hidden = !option.dataset.compare;
              this.querySelector('p[data-stock]').textContent = option.dataset.stock;
              const submit = this.querySelector('[data-purchase]');
              const canBuy = option.dataset.available === 'true' && this.dataset.ready === 'true';
              submit.disabled = !canBuy;
              submit.textContent = canBuy ? this.dataset.addLabel : this.dataset.unavailableLabel;
              this.querySelector('[data-status]').textContent =
                `${option.textContent.trim()}. ${option.dataset.stock}`;
              const url = new URL(location.href);
              url.searchParams.set('variant', option.value);
              history.replaceState(null, '', url);
            },
            { signal },
          );
          this.addEventListener(
            'submit',
            (event) => {
              if (this.dataset.preview !== 'true') return;
              event.preventDefault();
              this.querySelector('[data-status]').textContent = this.dataset.previewLabel;
            },
            { signal },
          );
          // Native video controls and captions stay usable without JavaScript. No autoplay.
          this.querySelectorAll('video').forEach((video) => {
            video.preload = 'none';
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }
      },
    );
  }

  if (!customElements.get('ortlux-collection-return'))
    customElements.define(
      'ortlux-collection-return',
      class extends HTMLElement {
        connectedCallback() {
          const value = new URL(location.href).searchParams.get('oc_return');
          if (!value) return;
          try {
            const url = new URL(value, location.origin);
            if (
              url.origin === location.origin &&
              url.pathname.startsWith('/') &&
              !url.username &&
              !url.password
            )
              this.querySelector('a').href = url.href;
          } catch {}
        }
      },
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-product-mobility-wallets"] && !Shopify.designMode) return;
  try {
    
  /* Section-local progressive enhancement; native product forms work without JavaScript. */
  if (!customElements.get('ortlux-product')) {
    customElements.define(
      'ortlux-product',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.querySelectorAll('[data-variant]').forEach((select) => {
            select.disabled = false;
          });
          const selectImage = (link) => {
            const main = this.querySelector('.op-main-photo img');
            if (!main || !link) return;
            main.srcset = link.dataset.imageSrcset;
            main.src = link.dataset.imageSrc;
            main.alt = link.querySelector('img')?.alt || '';
            this.querySelectorAll('[data-gallery-image]').forEach(item => {
              if (item === link) item.setAttribute('aria-current', 'true');
              else item.removeAttribute('aria-current');
            });
            const status = this.querySelector('[data-gallery-status]');
            if (status) status.textContent = main.alt;
          };
          this.addEventListener('click', event => {
            const link = event.target.closest('[data-gallery-image]');
            if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            selectImage(link);
          }, { signal });
          const horizonHeader = document.getElementById('header-component');
          if (horizonHeader) {
            this.resizeObserver = new ResizeObserver(() => {
              const height = horizonHeader.getBoundingClientRect().height;
              document.documentElement.style.setProperty('--ortlux-header-offset', `${height + 16}px`);
            });
            this.resizeObserver.observe(horizonHeader);
            this.addEventListener(
              'focusin',
              (event) => {
                const rect = event.target.getBoundingClientRect();
                const bottom = horizonHeader.getBoundingClientRect().bottom;
                if (rect.top < bottom + 8)
                  window.scrollBy({
                    top: rect.top - bottom - 8,
                    behavior: 'instant',
                  });
              },
              { signal },
            );
          }
          this.addEventListener(
            'change',
            (event) => {
              if (!event.target.matches('[data-variant]')) return;
              const option = event.target.selectedOptions[0];
              if (option.dataset.imageId) selectImage(this.querySelector(`[data-gallery-image="${option.dataset.imageId}"]`));
              const price = this.querySelector('span[data-price]');
              const compare = this.querySelector('[data-compare-price]');
              price.textContent = option.dataset.price;
              compare.textContent = option.dataset.compare || '';
              compare.hidden = !option.dataset.compare;
              this.querySelector('p[data-stock]').textContent = option.dataset.stock;
              const submit = this.querySelector('[data-purchase]');
              const canBuy = option.dataset.available === 'true';
              submit.disabled = !canBuy;
              this.querySelector('[data-unavailable-message]').hidden = canBuy;
              submit.textContent = canBuy ? this.dataset.addLabel : this.dataset.unavailableLabel;
              this.querySelector('[data-status]').textContent =
                `${option.textContent.trim()}. ${option.dataset.stock}`;
              const url = new URL(location.href);
              url.searchParams.set('variant', option.value);
              history.replaceState(null, '', url);
            },
            { signal },
          );
          this.addEventListener(
            'submit',
            (event) => {
              if (this.dataset.preview !== 'true') return;
              event.preventDefault();
              this.querySelector('[data-status]').textContent = this.dataset.previewLabel;
            },
            { signal },
          );
          // Native video controls and captions stay usable without JavaScript. No autoplay.
          this.querySelectorAll('video').forEach((video) => {
            video.preload = 'none';
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }
      },
    );
  }

  if (!customElements.get('ortlux-collection-return'))
    customElements.define(
      'ortlux-collection-return',
      class extends HTMLElement {
        connectedCallback() {
          const value = new URL(location.href).searchParams.get('oc_return');
          if (!value) return;
          try {
            const url = new URL(value, location.origin);
            if (
              url.origin === location.origin &&
              url.pathname.startsWith('/') &&
              !url.username &&
              !url.password
            )
              this.querySelector('a').href = url.href;
          } catch {}
        }
      },
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-product-mobility"] && !Shopify.designMode) return;
  try {
    
  /* Section-local progressive enhancement; native product forms work without JavaScript. */
  if (!customElements.get('ortlux-product')) {
    customElements.define(
      'ortlux-product',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.querySelectorAll('[data-variant]').forEach((select) => {
            select.disabled = false;
          });
          const selectImage = (link) => {
            const main = this.querySelector('.op-main-photo img');
            if (!main || !link) return;
            main.srcset = link.dataset.imageSrcset;
            main.src = link.dataset.imageSrc;
            main.alt = link.querySelector('img')?.alt || '';
            this.querySelectorAll('[data-gallery-image]').forEach(item => {
              if (item === link) item.setAttribute('aria-current', 'true');
              else item.removeAttribute('aria-current');
            });
            const status = this.querySelector('[data-gallery-status]');
            if (status) status.textContent = main.alt;
          };
          this.addEventListener('click', event => {
            const link = event.target.closest('[data-gallery-image]');
            if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            selectImage(link);
          }, { signal });
          const horizonHeader = document.getElementById('header-component');
          if (horizonHeader) {
            this.resizeObserver = new ResizeObserver(() => {
              const height = horizonHeader.getBoundingClientRect().height;
              document.documentElement.style.setProperty('--ortlux-header-offset', `${height + 16}px`);
            });
            this.resizeObserver.observe(horizonHeader);
            this.addEventListener(
              'focusin',
              (event) => {
                const rect = event.target.getBoundingClientRect();
                const bottom = horizonHeader.getBoundingClientRect().bottom;
                if (rect.top < bottom + 8)
                  window.scrollBy({
                    top: rect.top - bottom - 8,
                    behavior: 'instant',
                  });
              },
              { signal },
            );
          }
          this.addEventListener(
            'change',
            (event) => {
              if (!event.target.matches('[data-variant]')) return;
              const option = event.target.selectedOptions[0];
              if (option.dataset.imageId) selectImage(this.querySelector(`[data-gallery-image="${option.dataset.imageId}"]`));
              const price = this.querySelector('span[data-price]');
              const compare = this.querySelector('[data-compare-price]');
              price.textContent = option.dataset.price;
              compare.textContent = option.dataset.compare || '';
              compare.hidden = !option.dataset.compare;
              this.querySelector('p[data-stock]').textContent = option.dataset.stock;
              const submit = this.querySelector('[data-purchase]');
              const canBuy = option.dataset.available === 'true';
              submit.disabled = !canBuy;
              this.querySelector('[data-unavailable-message]').hidden = canBuy;
              submit.textContent = canBuy ? this.dataset.addLabel : this.dataset.unavailableLabel;
              this.querySelector('[data-status]').textContent =
                `${option.textContent.trim()}. ${option.dataset.stock}`;
              const url = new URL(location.href);
              url.searchParams.set('variant', option.value);
              history.replaceState(null, '', url);
            },
            { signal },
          );
          this.addEventListener(
            'submit',
            (event) => {
              if (this.dataset.preview !== 'true') return;
              event.preventDefault();
              this.querySelector('[data-status]').textContent = this.dataset.previewLabel;
            },
            { signal },
          );
          // Native video controls and captions stay usable without JavaScript. No autoplay.
          this.querySelectorAll('video').forEach((video) => {
            video.preload = 'none';
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }
      },
    );
  }

  if (!customElements.get('ortlux-collection-return'))
    customElements.define(
      'ortlux-collection-return',
      class extends HTMLElement {
        connectedCallback() {
          const value = new URL(location.href).searchParams.get('oc_return');
          if (!value) return;
          try {
            const url = new URL(value, location.origin);
            if (
              url.origin === location.origin &&
              url.pathname.startsWith('/') &&
              !url.username &&
              !url.password
            )
              this.querySelector('a').href = url.href;
          } catch {}
        }
      },
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-product-v2"] && !Shopify.designMode) return;
  try {
    
  /* Section-local progressive enhancement; native product forms work without JavaScript. */
  if (!customElements.get('ortlux-product')) {
    customElements.define(
      'ortlux-product',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.querySelectorAll('[data-variant]').forEach((select) => {
            select.disabled = false;
          });
          const selectImage = (link) => {
            const main = this.querySelector('.op-main-photo img');
            if (!main || !link) return;
            main.srcset = link.dataset.imageSrcset;
            main.src = link.dataset.imageSrc;
            main.alt = link.querySelector('img')?.alt || '';
            this.querySelectorAll('[data-gallery-image]').forEach(item => {
              if (item === link) item.setAttribute('aria-current', 'true');
              else item.removeAttribute('aria-current');
            });
            const status = this.querySelector('[data-gallery-status]');
            if (status) status.textContent = main.alt;
          };
          this.addEventListener('click', event => {
            const link = event.target.closest('[data-gallery-image]');
            if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            selectImage(link);
          }, { signal });
          const horizonHeader = document.getElementById('header-component');
          if (horizonHeader) {
            this.resizeObserver = new ResizeObserver(() => {
              const height = horizonHeader.getBoundingClientRect().height;
              document.documentElement.style.setProperty('--ortlux-header-offset', `${height + 16}px`);
            });
            this.resizeObserver.observe(horizonHeader);
            this.addEventListener(
              'focusin',
              (event) => {
                const rect = event.target.getBoundingClientRect();
                const bottom = horizonHeader.getBoundingClientRect().bottom;
                if (rect.top < bottom + 8)
                  window.scrollBy({
                    top: rect.top - bottom - 8,
                    behavior: 'instant',
                  });
              },
              { signal },
            );
          }
          this.addEventListener(
            'change',
            (event) => {
              if (!event.target.matches('[data-variant]')) return;
              const option = event.target.selectedOptions[0];
              if (option.dataset.imageId) selectImage(this.querySelector(`[data-gallery-image="${option.dataset.imageId}"]`));
              const price = this.querySelector('span[data-price]');
              const compare = this.querySelector('[data-compare-price]');
              price.textContent = option.dataset.price;
              compare.textContent = option.dataset.compare || '';
              compare.hidden = !option.dataset.compare;
              this.querySelector('p[data-stock]').textContent = option.dataset.stock;
              const submit = this.querySelector('[data-purchase]');
              const canBuy = option.dataset.available === 'true' && this.dataset.ready === 'true';
              submit.disabled = !canBuy;
              submit.textContent = canBuy ? this.dataset.addLabel : this.dataset.unavailableLabel;
              this.querySelector('[data-status]').textContent =
                `${option.textContent.trim()}. ${option.dataset.stock}`;
              const url = new URL(location.href);
              url.searchParams.set('variant', option.value);
              history.replaceState(null, '', url);
            },
            { signal },
          );
          this.addEventListener(
            'submit',
            (event) => {
              if (this.dataset.preview !== 'true') return;
              event.preventDefault();
              this.querySelector('[data-status]').textContent = this.dataset.previewLabel;
            },
            { signal },
          );
          // Native video controls and captions stay usable without JavaScript. No autoplay.
          this.querySelectorAll('video').forEach((video) => {
            video.preload = 'none';
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }
      },
    );
  }

  if (!customElements.get('ortlux-collection-return'))
    customElements.define(
      'ortlux-collection-return',
      class extends HTMLElement {
        connectedCallback() {
          const value = new URL(location.href).searchParams.get('oc_return');
          if (!value) return;
          try {
            const url = new URL(value, location.origin);
            if (
              url.origin === location.origin &&
              url.pathname.startsWith('/') &&
              !url.username &&
              !url.password
            )
              this.querySelector('a').href = url.href;
          } catch {}
        }
      },
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-product-v3"] && !Shopify.designMode) return;
  try {
    
  /* Section-local progressive enhancement; native product forms work without JavaScript. */
  if (!customElements.get('ortlux-product')) {
    customElements.define(
      'ortlux-product',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.querySelectorAll('[data-variant]').forEach((select) => {
            select.disabled = false;
          });
          const selectImage = (link) => {
            const main = this.querySelector('.op-main-photo img');
            if (!main || !link) return;
            main.srcset = link.dataset.imageSrcset;
            main.src = link.dataset.imageSrc;
            main.alt = link.querySelector('img')?.alt || '';
            this.querySelectorAll('[data-gallery-image]').forEach(item => {
              if (item === link) item.setAttribute('aria-current', 'true');
              else item.removeAttribute('aria-current');
            });
            const status = this.querySelector('[data-gallery-status]');
            if (status) status.textContent = main.alt;
          };
          this.addEventListener('click', event => {
            const link = event.target.closest('[data-gallery-image]');
            if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            selectImage(link);
          }, { signal });
          const horizonHeader = document.getElementById('header-component');
          if (horizonHeader) {
            this.resizeObserver = new ResizeObserver(() => {
              const height = horizonHeader.getBoundingClientRect().height;
              document.documentElement.style.setProperty('--ortlux-header-offset', `${height + 16}px`);
            });
            this.resizeObserver.observe(horizonHeader);
            this.addEventListener(
              'focusin',
              (event) => {
                const rect = event.target.getBoundingClientRect();
                const bottom = horizonHeader.getBoundingClientRect().bottom;
                if (rect.top < bottom + 8)
                  window.scrollBy({
                    top: rect.top - bottom - 8,
                    behavior: 'instant',
                  });
              },
              { signal },
            );
          }
          this.addEventListener(
            'change',
            (event) => {
              if (!event.target.matches('[data-variant]')) return;
              const option = event.target.selectedOptions[0];
              if (option.dataset.imageId) selectImage(this.querySelector(`[data-gallery-image="${option.dataset.imageId}"]`));
              const price = this.querySelector('span[data-price]');
              const compare = this.querySelector('[data-compare-price]');
              price.textContent = option.dataset.price;
              compare.textContent = option.dataset.compare || '';
              compare.hidden = !option.dataset.compare;
              this.querySelector('p[data-stock]').textContent = option.dataset.stock;
              const submit = this.querySelector('[data-purchase]');
              const canBuy = option.dataset.available === 'true' && this.dataset.ready === 'true';
              submit.disabled = !canBuy;
              submit.textContent = canBuy ? this.dataset.addLabel : this.dataset.unavailableLabel;
              this.querySelector('[data-status]').textContent =
                `${option.textContent.trim()}. ${option.dataset.stock}`;
              const url = new URL(location.href);
              url.searchParams.set('variant', option.value);
              history.replaceState(null, '', url);
            },
            { signal },
          );
          this.addEventListener(
            'submit',
            (event) => {
              if (this.dataset.preview !== 'true') return;
              event.preventDefault();
              this.querySelector('[data-status]').textContent = this.dataset.previewLabel;
            },
            { signal },
          );
          // Native video controls and captions stay usable without JavaScript. No autoplay.
          this.querySelectorAll('video').forEach((video) => {
            video.preload = 'none';
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }
      },
    );
  }

  if (!customElements.get('ortlux-collection-return'))
    customElements.define(
      'ortlux-collection-return',
      class extends HTMLElement {
        connectedCallback() {
          const value = new URL(location.href).searchParams.get('oc_return');
          if (!value) return;
          try {
            const url = new URL(value, location.origin);
            if (
              url.origin === location.origin &&
              url.pathname.startsWith('/') &&
              !url.username &&
              !url.password
            )
              this.querySelector('a').href = url.href;
          } catch {}
        }
      },
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-product-v4"] && !Shopify.designMode) return;
  try {
    
  /* Section-local progressive enhancement; native product forms work without JavaScript. */
  if (!customElements.get('ortlux-product')) {
    customElements.define(
      'ortlux-product',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.querySelectorAll('[data-variant]').forEach((select) => {
            select.disabled = false;
          });
          const selectImage = (link) => {
            const main = this.querySelector('.op-main-photo img');
            if (!main || !link) return;
            main.srcset = link.dataset.imageSrcset;
            main.src = link.dataset.imageSrc;
            main.alt = link.querySelector('img')?.alt || '';
            this.querySelectorAll('[data-gallery-image]').forEach(item => {
              if (item === link) item.setAttribute('aria-current', 'true');
              else item.removeAttribute('aria-current');
            });
            const status = this.querySelector('[data-gallery-status]');
            if (status) status.textContent = main.alt;
          };
          this.addEventListener('click', event => {
            const link = event.target.closest('[data-gallery-image]');
            if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            selectImage(link);
          }, { signal });
          const horizonHeader = document.getElementById('header-component');
          if (horizonHeader) {
            this.resizeObserver = new ResizeObserver(() => {
              const height = horizonHeader.getBoundingClientRect().height;
              document.documentElement.style.setProperty('--ortlux-header-offset', `${height + 16}px`);
            });
            this.resizeObserver.observe(horizonHeader);
            this.addEventListener(
              'focusin',
              (event) => {
                const rect = event.target.getBoundingClientRect();
                const bottom = horizonHeader.getBoundingClientRect().bottom;
                if (rect.top < bottom + 8)
                  window.scrollBy({
                    top: rect.top - bottom - 8,
                    behavior: 'instant',
                  });
              },
              { signal },
            );
          }
          this.addEventListener(
            'change',
            (event) => {
              if (!event.target.matches('[data-variant]')) return;
              const option = event.target.selectedOptions[0];
              if (option.dataset.imageId) selectImage(this.querySelector(`[data-gallery-image="${option.dataset.imageId}"]`));
              const price = this.querySelector('span[data-price]');
              const compare = this.querySelector('[data-compare-price]');
              price.textContent = option.dataset.price;
              compare.textContent = option.dataset.compare || '';
              compare.hidden = !option.dataset.compare;
              this.querySelector('p[data-stock]').textContent = option.dataset.stock;
              const submit = this.querySelector('[data-purchase]');
              const canBuy = option.dataset.available === 'true';
              submit.disabled = !canBuy;
              this.querySelector('[data-unavailable-message]').hidden = canBuy;
              submit.textContent = canBuy ? this.dataset.addLabel : this.dataset.unavailableLabel;
              this.querySelector('[data-status]').textContent =
                `${option.textContent.trim()}. ${option.dataset.stock}`;
              const url = new URL(location.href);
              url.searchParams.set('variant', option.value);
              history.replaceState(null, '', url);
            },
            { signal },
          );
          this.addEventListener(
            'submit',
            (event) => {
              if (this.dataset.preview !== 'true') return;
              event.preventDefault();
              this.querySelector('[data-status]').textContent = this.dataset.previewLabel;
            },
            { signal },
          );
          // Native video controls and captions stay usable without JavaScript. No autoplay.
          this.querySelectorAll('video').forEach((video) => {
            video.preload = 'none';
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }
      },
    );
  }

  if (!customElements.get('ortlux-collection-return'))
    customElements.define(
      'ortlux-collection-return',
      class extends HTMLElement {
        connectedCallback() {
          const value = new URL(location.href).searchParams.get('oc_return');
          if (!value) return;
          try {
            const url = new URL(value, location.origin);
            if (
              url.origin === location.origin &&
              url.pathname.startsWith('/') &&
              !url.username &&
              !url.password
            )
              this.querySelector('a').href = url.href;
          } catch {}
        }
      },
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ortlux-product-wallets"] && !Shopify.designMode) return;
  try {
    
  /* Section-local progressive enhancement; native product forms work without JavaScript. */
  if (!customElements.get('ortlux-product')) {
    customElements.define(
      'ortlux-product',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.querySelectorAll('[data-variant]').forEach((select) => {
            select.disabled = false;
          });
          const selectImage = (link) => {
            const main = this.querySelector('.op-main-photo img');
            if (!main || !link) return;
            main.srcset = link.dataset.imageSrcset;
            main.src = link.dataset.imageSrc;
            main.alt = link.querySelector('img')?.alt || '';
            this.querySelectorAll('[data-gallery-image]').forEach(item => {
              if (item === link) item.setAttribute('aria-current', 'true');
              else item.removeAttribute('aria-current');
            });
            const status = this.querySelector('[data-gallery-status]');
            if (status) status.textContent = main.alt;
          };
          this.addEventListener('click', event => {
            const link = event.target.closest('[data-gallery-image]');
            if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            selectImage(link);
          }, { signal });
          const horizonHeader = document.getElementById('header-component');
          if (horizonHeader) {
            this.resizeObserver = new ResizeObserver(() => {
              const height = horizonHeader.getBoundingClientRect().height;
              document.documentElement.style.setProperty('--ortlux-header-offset', `${height + 16}px`);
            });
            this.resizeObserver.observe(horizonHeader);
            this.addEventListener(
              'focusin',
              (event) => {
                const rect = event.target.getBoundingClientRect();
                const bottom = horizonHeader.getBoundingClientRect().bottom;
                if (rect.top < bottom + 8)
                  window.scrollBy({
                    top: rect.top - bottom - 8,
                    behavior: 'instant',
                  });
              },
              { signal },
            );
          }
          this.addEventListener(
            'change',
            (event) => {
              if (!event.target.matches('[data-variant]')) return;
              const option = event.target.selectedOptions[0];
              if (option.dataset.imageId) selectImage(this.querySelector(`[data-gallery-image="${option.dataset.imageId}"]`));
              const price = this.querySelector('span[data-price]');
              const compare = this.querySelector('[data-compare-price]');
              price.textContent = option.dataset.price;
              compare.textContent = option.dataset.compare || '';
              compare.hidden = !option.dataset.compare;
              this.querySelector('p[data-stock]').textContent = option.dataset.stock;
              const submit = this.querySelector('[data-purchase]');
              const canBuy = option.dataset.available === 'true';
              submit.disabled = !canBuy;
              this.querySelector('[data-unavailable-message]').hidden = canBuy;
              submit.textContent = canBuy ? this.dataset.addLabel : this.dataset.unavailableLabel;
              this.querySelector('[data-status]').textContent =
                `${option.textContent.trim()}. ${option.dataset.stock}`;
              const url = new URL(location.href);
              url.searchParams.set('variant', option.value);
              history.replaceState(null, '', url);
            },
            { signal },
          );
          this.addEventListener(
            'submit',
            (event) => {
              if (this.dataset.preview !== 'true') return;
              event.preventDefault();
              this.querySelector('[data-status]').textContent = this.dataset.previewLabel;
            },
            { signal },
          );
          // Native video controls and captions stay usable without JavaScript. No autoplay.
          this.querySelectorAll('video').forEach((video) => {
            video.preload = 'none';
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }
      },
    );
  }

  if (!customElements.get('ortlux-collection-return'))
    customElements.define(
      'ortlux-collection-return',
      class extends HTMLElement {
        connectedCallback() {
          const value = new URL(location.href).searchParams.get('oc_return');
          if (!value) return;
          try {
            const url = new URL(value, location.origin);
            if (
              url.origin === location.origin &&
              url.pathname.startsWith('/') &&
              !url.username &&
              !url.password
            )
              this.querySelector('a').href = url.href;
          } catch {}
        }
      },
    );

  } catch(e) { console.error(e); }
})();
})();
